import {
    CategoryInsightsOverviewSections,
    CategoryOverviewBrandContributionMetricKey,
    CategoryOverviewChartsKeys,
    categoryOverviewDefaultChartPoints,
    CategoryOverviewSerpKeys,
    CategoryOverviewSubCategoryMetricKey,
    catOverviewCompareTablesMetricsToSum,
    catOverviewComparisonTableMetricsToSum,
    COLORS,
    CustomGroupingFunction,
    MISC_PA_REPORT_WIDGET,
    MY_PRODUCT_TRENDS_FILTER_MAP,
    RATINGS_DEFAULT_DATA,
    valueDeltaDefault,
} from "@ts/constants";
import {
    BuyboxData,
    IBrandwiseOverallTrendsOriginalData,
    ICategoriesOptions,
    ICategoryData,
    IChannelData,
    ICompiledRoasSpendData,
    ICompiledRoasSpendDataItem,
    ICompiledRoasSpendDelta,
    ICustomerSatisfactionOriginalData,
    IDriverwiseReviewTrendData,
    IDriverwiseReviewTrendOriginalData,
    IGroupedDriverwiseReviewTrendData,
    TOverviewStructuredDataObj,
    IProductRatingVsCompetitorsData,
    IProductRatingVsCompetitorsSpiderChartData,
    ITrendsWithCompareModalWidgetData,
    IRatingSummaryData,
    IReviewsOriginalData,
    IReviewTrendsOriginalData,
    IReviewVerbatimOriginalData,
    ISatisfactionDriver,
    ISatisfactionDriversFormattedData,
    ISatisfactionDriversOriginalData,
    ISatisfactionDriverwiseOriginalData,
    ISelectedPeriodData,
    ISentimentOriginalData,
    ISkusData,
    ITop10SubCatsByRatingsDataOriginalData,
    ITop10SubCatsByRatingsMasterData,
    ITop10SubCatsByRatingsOriginalData,
    ITop10SubCatsByRatingsSubcatData,
    IWordcloudReviewData,
    IWordcloudReviewElementsData,
    IWordcloudReviewWidgetData,
    ProductAnalysisOriginalData,
    ProductTrendData,
    ProductTrendDataItem,
    RatingInput,
    TPaModuleLoadingState,
    TPaModuleReducerActions,
    TProductRatingVsCompetitorsOriginalData,
    TProductReviewData,
    TProductReviewFormattedTableData,
    TProductReviewTableDataEntry,
    TTrendsWithComparisionData,
    TSentimentData,
    IDigitalShelfData,
    ITrendsWithComparisionWidgetFormatterKeys,
    IRpiData,
    IPriceVsSalesDataOriginalData,
    IPriceVsSalesFormattedData,
    IMsVsRpiDataOriginalData,
    IMsVsRpiDataFormattedData,
    IPricingChartsToggleFiltersState,
    IPricingChartsToggleFiltersActions,
    IPricingChartsFiltersState,
    IPricingChartsFiltersActions,
    IPriceDealsDataFormattedData,
    IPriceDealsDataOriginalData,
    IPricingSummaryOriginalData,
    IPricingSummaryFormattedData,
    ICompetitiveProductsDaywiseOriginalData,
    ICompetitiveProductsDaywiseFormattedData,
    ICompetitiveProductsDaywiseMetrics,
    IPricingCompetitiveAnalysisFormattedData,
    IPricingCompetitiveAnalysisOriginalData,
    IPricingSatisfactionSummaryFormattedData,
    IPricingSatisfactionSummaryOriginalData,
    IMyProductTrendsOriginalData,
    IMyProductTrendsFormatterData,
    IPricingCompetitiveAnalysisTrendsOriginalData,
    IPricingCompetitiveAnalysisTrendsFormattedData,
    MyProductTrendsTypes,
    CommonWidgetMetrics,
    DeepDiveBrandScoreInfo,
    ISpendRoasData,
    IVisibilitySummaryOriginalData,
    IVisibilitySummaryFormattedData,
    IVisibilitySatisfactionSummaryOriginalData,
    IKeywordVisibilityInputData,
    IKeywordVisibilityFormattedData,
    ISovDataItem,
    ISovFormattedData,
    ICTRFormattedData,
    ICTRGroupedDataItem,
    ICTRSeriesItem,
    IPerformanceComparisionRawDataItem,
    IPerformanceComparisonData,
    IPerformanceComparisionAggregatedDataItem,
    AggregationField,
    KeywordTypeValues,
    IBBWinnersDistributionOriginalData,
    IAvailabilityChartsFiltersState,
    IAvailabilityChartsFiltersActions,
    VisibilityMyProductTrendData,
    TCategoryOverviewShowHideStatesInitialState,
    TCategoryOverviewShowHideStatesActions,
    TCategoryOverviewRadioFiltersInitialState,
    TCategoryOverviewRadioFiltersActions,
    TAvailabilityEcommData,
    AvailabilityCompetitionData,
    TBuyboxWinnerAndLosersData,
    TopProductsWithEstimatedSalesLossEcommRow,
    TopSubcategoriesWithEstimatedSalesLossEcommRow,
    AvailabilityDrilldownTypes,
    GroupingKey,
    IBestSellerSKUData,
    ICategoryOverviewBestSellerSKUTableRow,
    ICategoryOverviewComparisonGraphData,
    ICategoryOverviewComparisonGraphFormattedData,
    ICategoryOverviewCompetitionGraphData,
    ICategoryOverviewCrossChannelCompetitionComparisonGraphItem,
    IcategoryOverviewCrossChannelCompetitonComparisonData,
    ICategoryOverviewCrossChannelGraphData,
    ICategoryOverviewDrainers,
    IFormattedDrainerData,
    IFormattedSubCategoryPerformance,
    ISubCategoryPerformance,
    MetricWithDelta,
    MyProductTrendsModules,
    TAvailabilityIssuesByCityData,
    TAvailabilityIssuesByCityDataResult,
    TCategoryOverviewComparisonGraphFormattedDataForXAxisOpposite,
    TCatOverviewCrossChannelCompetitionComparisonAggEntry,
    TFormattedCategoryOverviewCrossChannelCompetitonComparisonData,
    TSubCategoryAvailabilityData,
    CATEGORY_OVERVIEW_MS_TRENDS_OVERTIME_RADIO,
    CATEGORY_OVERVIEW_SKU_FILTERS,
    ICategoryInsightFilters,
    ICategoryMarketShareAndSizeData,
    ICategoryOverviewBrandContributionData,
    ICategoryOverviewMarketShareAndSizeFormattedData,
    ICategoryOverviewMSTrendsOverTimeData,
    ICategoryOverviewSerpData,
    ICategoryOverviewSummaryMetrics,
    IFormattedCategoryOverviewMsTrendsOverTimeData,
    ISaleSpendRoas,
    ISovRatingBuyboxReview,
    TBrandContributionFormattedData,
    TCategoryOverviewSubCategoriesData,
    IAvailabilityData,
    IAvailabilityMySkuData,
    TOtherSellerFormattedData,
    AggregationType,
    FrequencySlicerOptions,
    ProductDeepdiveModules,
    ProductDeepdiveOverviewSections,
    SubModule,
} from "./common-types";
import { internationalizeNumericValue, startCase, titleCase } from "./utils";
import store from "@/store";
import {
    chain,
    compact,
    each,
    extend,
    filter,
    find,
    first,
    get,
    groupBy,
    includes,
    isArray,
    isEmpty,
    isNumber,
    isString,
    isUndefined,
    keys,
    last,
    map,
    max,
    omit,
    partition,
    pluck,
    reduce,
    size,
    sortBy,
    uniq,
} from "underscore";
import dayjs from "dayjs";
import moment from "moment";
import { getSelectedDateRange } from "./date-range";
import { TDate } from "./funnel";
import React from "react";
import { unique } from "underscore";
import { CHANNEL_CONFIGS } from "@/config/channel-configs";

export const calcOutOfStockInfo = (
    data: any
): {
    out_of_stock_since: string | null;
    out_of_stock_percentage: string;
} => {
    if (!isArray(data) || isEmpty(data)) {
        return {
            out_of_stock_since: null,
            out_of_stock_percentage: "-",
        };
    }

    // Find the first unavailable item's crawl_date
    const firstOutOfStockItem = chain(data)
        .find((item) => item && !item.availability)
        ?.value();
    const outOfStockSince = firstOutOfStockItem
        ? firstOutOfStockItem.crawl_date
        : null;

    // Calculate total days and out-of-stock days
    const totalDays = size(data);
    const outOfStockDays = size(
        filter(data, (item) => item && item.availability === false)
    );

    const outOfStockPercentage =
        totalDays > 0 ? (outOfStockDays / totalDays) * 100 : 0;

    return {
        out_of_stock_since: outOfStockSince
            ? dayjs(outOfStockSince).format("DD-MM-YYYY")
            : null,
        out_of_stock_percentage: outOfStockPercentage
            ? `${outOfStockPercentage.toFixed(1)}%`
            : "-",
    };
};

export const calcPercentageChange = (
    key: string,
    dataObj: ProductTrendData
): string | null => {
    const isValidNumber = (num: any): boolean => isNumber(num) && !isNaN(num);

    if (!Array.isArray(dataObj) || dataObj.length === 0) {
        return null;
    }

    const processPercentages = (
        data: ProductTrendData,
        numeratorKey: string,
        denominatorKey: string
    ) => {
        const percentages = data
            .map((item) => {
                if (
                    isValidNumber(item[numeratorKey]) &&
                    isValidNumber(item[denominatorKey]) &&
                    item[denominatorKey] !== 0
                ) {
                    return {
                        date: item.date || item.crawl_date,
                        numerator: item[numeratorKey],
                        denominator: item[denominatorKey],
                    };
                } else {
                    return {
                        date: item.date || item.crawl_date,
                        numerator: null,
                        denominator: null,
                    };
                }
            })
            .filter(
                (item) => item.numerator !== null && item.denominator !== null
            );

        if (percentages.length === 0) {
            return null;
        }

        const midpoint = Math.floor(percentages.length / 2);
        const [firstHalf, secondHalf] = partition(
            percentages,
            (_, index) => index < midpoint
        );

        const sumFirstHalf = firstHalf.reduce(
            (acc, item) => ({
                numerator: acc.numerator + item.numerator,
                denominator: acc.denominator + item.denominator,
            }),
            { numerator: 0, denominator: 0 }
        );

        const sumSecondHalf = secondHalf.reduce(
            (acc, item) => ({
                numerator: acc.numerator + item.numerator,
                denominator: acc.denominator + item.denominator,
            }),
            { numerator: 0, denominator: 0 }
        );

        const avgFirstHalf =
            sumFirstHalf.denominator !== 0
                ? (sumFirstHalf.numerator / sumFirstHalf.denominator) * 100
                : 0;

        const avgSecondHalf =
            sumSecondHalf.denominator !== 0
                ? (sumSecondHalf.numerator / sumSecondHalf.denominator) * 100
                : 0;

        if (key === DeepDiveBrandScoreInfo.MS_PERC_BY_VALUE) {
            MISC_PA_REPORT_WIDGET.msValue = avgFirstHalf.toFixed(1);
        } else if (key === DeepDiveBrandScoreInfo.ORGANIC_VISIBILITY) {
            MISC_PA_REPORT_WIDGET.organicVisibility = avgFirstHalf.toFixed(1);
        } else if (key === DeepDiveBrandScoreInfo.PAID_VISIBILITY) {
            MISC_PA_REPORT_WIDGET.paidVisibility = avgFirstHalf.toFixed(1);
        }

        const percentageChange =
            avgFirstHalf !== 0 ? avgFirstHalf - avgSecondHalf : null;

        return percentageChange ? `${percentageChange.toFixed(2)}%` : null;
    };

    if (key === DeepDiveBrandScoreInfo.MS_PERC_BY_VALUE) {
        return processPercentages(dataObj, "revenue", "cat_revenue");
    }

    if (key === DeepDiveBrandScoreInfo.LATEST_BSR) {
        const sortedData = dataObj
            .slice()
            .sort(
                (a, b) =>
                    new Date(a.date || a.crawl_date).getTime() -
                    new Date(b.date || b.crawl_date).getTime()
            )
            .reverse();

        const latestEntry = sortedData.find((item) =>
            isValidNumber(item?.bsr_rank_2)
        );
        if (!latestEntry) {
            return null;
        }

        const latestCategory = latestEntry.bsr_category_2;

        MISC_PA_REPORT_WIDGET.latestBsrCategory = latestCategory;

        const filteredData = sortedData.filter(
            (item) =>
                item.bsr_category_2 === latestCategory &&
                isValidNumber(item?.bsr_rank_2)
        );

        const latestFirstHalfBSR = filteredData[0]?.bsr_rank_2 || null;
        MISC_PA_REPORT_WIDGET.latestBsrRank = latestFirstHalfBSR;
        if (filteredData.length < 2) {
            return null;
        }

        const latestSecondHalfBSR =
            filteredData[filteredData.length - 1]?.bsr_rank_2 || null;

        if (
            !isValidNumber(latestFirstHalfBSR) ||
            !isValidNumber(latestSecondHalfBSR)
        ) {
            return null;
        }

        const absoluteChange = latestSecondHalfBSR - latestFirstHalfBSR;
        return absoluteChange > 0 ? `+${absoluteChange}` : `${absoluteChange}`;
    }

    if (key === DeepDiveBrandScoreInfo.ORGANIC_VISIBILITY) {
        return processPercentages(
            dataObj,
            "org_sku_wt_crawl_sv",
            "org_cat_wt_crawl_sv"
        );
    }

    if (key === DeepDiveBrandScoreInfo.PAID_VISIBILITY) {
        return processPercentages(
            dataObj,
            "paid_sku_wt_crawl_sv",
            "paid_cat_wt_crawl_sv"
        );
    }

    return null;
};

export const compileBuyboxData = (data: BuyboxData) => {
    if (!isArray(data) || isEmpty(data)) {
        return {
            buybox_winner: null,
            buybox_lost_since: "-",
            buybox_win_percent: "-",
        };
    }

    let buyboxWinner: string | null = null;
    let buyboxLostSince: string | null = null;

    // Sort data by crawl_date in descending order
    data = sortBy(data, (item) => -moment(item.crawl_date).valueOf());

    // Calculate buybox win count
    const buyboxWinCount = reduce(
        data,
        (count, item) => count + (item.buybox_win ? 1 : 0),
        0
    );

    // Determine buybox winner and buybox lost since
    each(data, (item) => {
        if (item.buybox_win) {
            if (isArray(item.merchant_name) && !isEmpty(item.merchant_name)) {
                buyboxWinner = item.merchant_name[0];
            }
        } else if (!buyboxLostSince) {
            if (
                isArray(item.merchant_name) &&
                !isEmpty(item.merchant_name) &&
                !buyboxWinner
            ) {
                buyboxLostSince = item.crawl_date || null;
                buyboxWinner = item.merchant_name[0];
            }
        }
    });

    // Calculate the buybox win percentage
    const totalRecords = data.length;
    const buyboxWinPercent =
        totalRecords > 0
            ? `${((buyboxWinCount / totalRecords) * 100).toFixed(1)}%`
            : "-";

    return {
        buybox_winner: buyboxWinner,
        buybox_lost_since: buyboxLostSince
            ? moment(buyboxLostSince).format("DD-MM-YYYY")
            : "-",
        buybox_win_percent: buyboxWinPercent,
    };
};

export const getStructuredData = async (
    section: string,
    dataObj: TOverviewStructuredDataObj
) => {
    return new Promise((resolve, reject) => {
        let brandScoreInfo = {};
        let buyBoxData: {
            [key: string]: any;
        } = {};
        let data;
        let tempData;

        try {
            switch (section) {
                case "overview":
                    buyBoxData = compileBuyboxData(dataObj as BuyboxData);
                    const dataArr = dataObj as ProductTrendData;
                    data = dataArr[0];
                    tempData = calcOutOfStockInfo(dataObj);
                    brandScoreInfo = {
                        [DeepDiveBrandScoreInfo.MS_PERC_BY_VALUE]: {
                            percChange: calcPercentageChange(
                                DeepDiveBrandScoreInfo.MS_PERC_BY_VALUE,
                                dataArr
                            ),
                            value: MISC_PA_REPORT_WIDGET.msValue
                                ? MISC_PA_REPORT_WIDGET.msValue + "%"
                                : "-",
                        },
                        [DeepDiveBrandScoreInfo.LATEST_BSR]: {
                            percChange: calcPercentageChange(
                                DeepDiveBrandScoreInfo.LATEST_BSR,
                                dataArr
                            ),
                            value: MISC_PA_REPORT_WIDGET.latestBsrRank || "-",
                            name: `${
                                MISC_PA_REPORT_WIDGET?.latestBsrCategory
                                    ? MISC_PA_REPORT_WIDGET.latestBsrCategory +
                                      " (Latest BSR)"
                                    : "Latest BSR"
                            }`,
                        },
                        [DeepDiveBrandScoreInfo.OUT_OF_STOCK_PERC]: {
                            value: tempData.out_of_stock_percentage,
                        },
                        [DeepDiveBrandScoreInfo.BUYBOX_WIN]: {
                            value: buyBoxData.buybox_win_percent || "0%",
                        },
                        [DeepDiveBrandScoreInfo.BUYBOX_LOST_SINCE]: {
                            value: buyBoxData.buybox_lost_since || "-",
                        },
                        [DeepDiveBrandScoreInfo.ORGANIC_VISIBILITY]: {
                            percChange: calcPercentageChange(
                                DeepDiveBrandScoreInfo.ORGANIC_VISIBILITY,
                                dataArr
                            ),
                            value: MISC_PA_REPORT_WIDGET.organicVisibility
                                ? `${MISC_PA_REPORT_WIDGET.organicVisibility}%`
                                : "-",
                        },
                        [DeepDiveBrandScoreInfo.PAID_VISIBILITY]: {
                            percChange: calcPercentageChange(
                                DeepDiveBrandScoreInfo.PAID_VISIBILITY,
                                dataArr
                            ),
                            value: MISC_PA_REPORT_WIDGET.paidVisibility
                                ? `${MISC_PA_REPORT_WIDGET.paidVisibility}%`
                                : "-",
                        },
                        [DeepDiveBrandScoreInfo.CONTENT_SCORE]: {
                            value: data?.content_score
                                ? data?.content_score.toFixed(2)
                                : "-",
                            link: "#",
                        },
                    };

                    resolve({
                        product_img: `https://m.media-amazon.com/images/P/${data?.sku}._AC_UY218_.jpg`,
                        rating: +data?.rating?.toFixed(2) || 0,
                        rating_count: data?.rating_count || 0,
                        mrp: data?.mrp?.toFixed(1) || "N/A",
                        price: data?.price?.toFixed(1) || "N/A",
                        discount:
                            data?.mrp && data?.price
                                ? `${(
                                      ((data?.mrp - data?.price) / data?.mrp) *
                                      100
                                  ).toFixed(0)}%`
                                : "",
                        availability: data?.availability,
                        sku: data?.sku || "N/A",
                        sku_title: data?.sku_title || "N/A",
                        skuLink: data?.sku_link || "#",
                        category: data?.bsr_category || "N/A",
                        subCategory: data?.bsr_category_2 || "N/A",
                        categoryRank: data?.bsr_rank_2
                            ? `#${data?.bsr_rank_2}`
                            : "N/A",
                        out_of_stock_since: tempData.out_of_stock_since,
                        buyBoxWinner: buyBoxData.buybox_winner,
                        brandScoreInfo,
                    });
                    break;
                case "productTrendAnalysis":
                    resolve(data);
                    break;
                case "reviews":
                    const ratingData = dataObj as RatingInput[];
                    tempData =
                        +ratingData[0].star1 +
                        +ratingData[0].star2 +
                        +ratingData[0].star3 +
                        +ratingData[0].star4 +
                        +ratingData[0].star5;
                    data = {
                        ...ratingData[0],
                        ratingDistribution: {
                            "5 Star": (
                                (+ratingData[0].star5 / tempData) *
                                100
                            ).toFixed(0),
                            "4 Star": (
                                (+ratingData[0].star4 / tempData) *
                                100
                            ).toFixed(0),
                            "3 Star": (
                                (+ratingData[0].star3 / tempData) *
                                100
                            ).toFixed(0),
                            "2 Star": (
                                (+ratingData[0].star2 / tempData) *
                                100
                            ).toFixed(0),
                            "1 Star": (
                                (+ratingData[0].star1 / tempData) *
                                100
                            ).toFixed(0),
                        },
                    };
                    resolve(data);
                    break;
                case "digitalShelf":
                    const digitalShelfData = dataObj as IDigitalShelfData;
                    MISC_PA_REPORT_WIDGET.ratingsCount =
                        digitalShelfData.maxRatingCount || 1;
                    resolve(digitalShelfData.digitalShelfData);
                    break;
                case "spendRoasData":
                    data = getCompiledRoasSpendData(
                        dataObj as ICompiledRoasSpendData
                    );
                    resolve(data);
                    break;
                case "funnel":
                    data = dataObj;
                    resolve(data);
                    break;
                default:
                    resolve({});
            }
        } catch (error) {
            reject(error);
        }
    });
};

export const getCompiledProductTrendsData = (
    data: ProductTrendData,
    fields: { key: string; label: string }[],
    dateKey: keyof ProductTrendData[0]
) => {
    const { startDate, endDate } = getSelectedDateRange();

    const periodLength = endDate.diff(startDate, "days") + 1;

    const currentDates = data
        .map((d) => moment(d[dateKey]).format("DD-MM-YYYY"))
        .filter((date) =>
            moment(date, "DD-MM-YYYY").isBetween(
                startDate,
                endDate,
                undefined,
                "[]"
            )
        )
        .sort((a, b) => moment(a, "DD-MM-YYYY").diff(moment(b, "DD-MM-YYYY")));

    const dataMap = Object.fromEntries(
        data.map((d) => [moment(d[dateKey]).format("DD-MM-YYYY"), d])
    );

    const currentTrend: Record<string, number[]> = {};
    const previousTrend: Record<string, number[]> = {};

    fields.forEach(({ key }) => {
        currentTrend[key] = currentDates.map((currentDate) =>
            dataMap[currentDate]
                ? +(+dataMap[currentDate][key])?.toFixed(2) || 0
                : 0
        );
        previousTrend[key] = currentDates.map((currentDate) => {
            const previousDate = moment(currentDate, "DD-MM-YYYY")
                .subtract(periodLength, "days")
                .format("DD-MM-YYYY");
            return dataMap[previousDate]
                ? +(+dataMap[previousDate][key])?.toFixed(2) || 0
                : 0;
        });
    });

    const generateChartOptions = (title: string, field: string) => ({
        title: { text: title, align: "center" },
        xAxis: { categories: currentDates },
        yAxis: { title: { text: title } },
        series: [
            {
                name: "Current Period",
                data: currentTrend[field],
                connectNulls: true,
            },
            {
                name: "Previous Period",
                data: previousTrend[field],
                connectNulls: true,
            },
        ],
        tooltip: {
            shared: true,
            formatter: function (
                this: Highcharts.TooltipFormatterContextObject
            ) {
                const index = this.points[0]?.point.index;
                const currentDate = currentDates[index];
                const previousDate = moment(currentDate, "DD-MM-YYYY")
                    .subtract(periodLength, "days")
                    .format("DD-MM-YYYY");

                const currentTooltip = `<b>Current Period (${currentDate}):</b> ${this.points[0].y}`;
                const previousTooltip = `<b>Previous Period (${previousDate}):</b> ${this.points[1].y}`;
                return `${currentTooltip}<br>${previousTooltip}`;
            },
        },
    });

    const chartOptions = {
        titles: fields.map((f) => f.label),
        chartOptions: Object.fromEntries(
            fields.map(({ key, label }) => [
                label,
                generateChartOptions(label, key),
            ])
        ),
    };

    return chartOptions;
};

export const getCompiledRoasSpendDataFromFunnel = (
    data: ProductTrendData[],
    setModuleData: React.Dispatch<React.SetStateAction<any>>
) => {
    const processData = () => {
        const result = {
            SP: { spends: 0, roas: 0, roasChange: 0, spendChange: 0 },
            SD: { spends: 0, roas: 0, roasChange: 0, spendChange: 0 },
        };

        data.forEach((item: any) => {
            const programType = item.program_type?.toUpperCase();
            if (programType && result[programType as keyof typeof result]) {
                result[programType as keyof typeof result].spends =
                    item.spend || 0;
                result[programType as keyof typeof result].roas =
                    item.roas || 0;
                result[programType as keyof typeof result].spendChange =
                    item.spend_change || "";
                result[programType as keyof typeof result].roasChange =
                    item.roas_change || "";
            } else {
                console.warn(`Unexpected program_type: ${item.program_type}`);
            }
        });

        return result;
    };

    const selectedPeriodData = processData();

    const finalResult = {
        byAdType: {
            categories: ["SP", "SD"],
            series: [
                {
                    name: "By Spends",
                    data: [
                        +(
                            (selectedPeriodData.SP.spends /
                                (selectedPeriodData.SP.spends +
                                    selectedPeriodData.SD.spends)) *
                            100
                        ).toFixed(0),
                        +(
                            (selectedPeriodData.SD.spends /
                                (selectedPeriodData.SP.spends +
                                    selectedPeriodData.SD.spends)) *
                            100
                        ).toFixed(0),
                    ],
                    color: "#3572EF",
                    yAxis: 0,
                    dataLabels: {
                        enabled: true,
                        formatter: function (): string {
                            // @ts-ignore
                            return this.y + "%";
                        },
                    },
                    tooltip: {
                        valueSuffix: "%",
                    },
                },
                {
                    name: "By ROAS",
                    data: [
                        +selectedPeriodData.SP.roas.toFixed(2),
                        +selectedPeriodData.SD.roas.toFixed(2),
                    ],
                    color: "#3ABEF9",
                    yAxis: 1,
                },
            ],
        },
    };

    const chartOptions = {
        chartDataSeries: finalResult,
        delta: {
            SP: {
                roas: selectedPeriodData.SP.roasChange * 100,
                spend: selectedPeriodData.SP.spendChange * 100,
            },
            SD: {
                roas: selectedPeriodData.SD.roasChange * 100,
                spend: selectedPeriodData.SD.spendChange * 100,
            },
        },
    };

    setModuleData((prev: ISpendRoasData) => ({
        ...prev,
        spendRoasData: {
            chartDataSeries: {
                ...(prev.spendRoasData?.chartDataSeries || {}),
                ...(chartOptions?.chartDataSeries || {}),
            },
            delta: {
                ...(prev.spendRoasData?.delta || {}),
                ...(chartOptions?.delta || {}),
            },
        },
    }));
};

export const getCompiledRoasSpendData = (data: ICompiledRoasSpendData) => {
    const categories = data.currentData.map(
        (item: ICompiledRoasSpendDataItem) => item.type
    );

    const selectedPeriodData = data.currentData.reduce(
        (
            acc: Record<string, ICompiledRoasSpendDataItem>,
            item: ICompiledRoasSpendDataItem
        ) => {
            acc[item.type] = {
                sale: item.sale,
                spend: item.spend,
                roas: item.roas,
                spends: item.spends,
            };
            return acc;
        },
        {}
    );

    const previousPeriodData = data.previousData.reduce(
        (
            acc: Record<string, ICompiledRoasSpendDataItem>,
            item: ICompiledRoasSpendDataItem
        ) => {
            acc[item.type] = {
                sale: item.sale,
                spend: item.spend,
                roas: item.roas,
                spends: item.spends,
            };
            return acc;
        },
        {}
    );

    const totalSpend = categories.reduce((acc: number, type: string) => {
        acc += +selectedPeriodData[type]?.spend || 0;
        return acc;
    }, 0);

    const finalResult = {
        byTargetType: {
            categories: categories.map((type: string) => startCase(type)),
            series: [
                {
                    name: "By Spends",
                    data: categories
                        .map(
                            (type: string) =>
                                (+(selectedPeriodData[type]?.spend || 0) /
                                    totalSpend) *
                                100
                        )
                        .map((value) => (isNaN(value) ? 0 : +value.toFixed(0))),
                    color: "#3572EF",
                    yAxis: 0,
                    dataLabels: {
                        enabled: true,
                        formatter: function (): string {
                            // @ts-ignore
                            return this.y + "%";
                        },
                    },
                    tooltip: {
                        valueSuffix: "%",
                    },
                },
                {
                    name: "By ROAS",
                    data: categories.map((type: string) =>
                        selectedPeriodData[type]?.roas != null
                            ? +selectedPeriodData[type].roas.toFixed(2)
                            : 0
                    ),
                    color: "#3ABEF9",
                    yAxis: 1,
                },
            ],
        },
    };

    const delta = categories.reduce(
        (acc: Record<string, ICompiledRoasSpendDelta>, type: string) => {
            acc[type] = {
                roas: previousPeriodData[type]?.roas
                    ? (((selectedPeriodData[type]?.roas || 0) -
                          previousPeriodData[type].roas) /
                          previousPeriodData[type].roas) *
                      100
                    : 0,
                spend: previousPeriodData[type]?.spend
                    ? (((selectedPeriodData[type]?.spend || 0) -
                          previousPeriodData[type].spend) /
                          previousPeriodData[type].spend) *
                      100
                    : 0,
            };
            return acc;
        },
        {}
    );

    return {
        chartDataSeries: finalResult,
        delta,
    };
};

export const getCompiledRoasSpendDataFromKeywords = (
    data: ProductTrendData
) => {
    const broadData: ProductTrendData = [];
    const phraseData: ProductTrendData = [];
    const exactData: ProductTrendData = [];

    data.forEach((item: ProductTrendDataItem) => {
        if (item.match_type === "broad") {
            broadData.push(item);
        } else if (item.match_type === "phrase") {
            phraseData.push(item);
        } else if (item.match_type === "exact") {
            exactData.push(item);
        }
    });

    const calculate = (dataSubset: ProductTrendData) => {
        let totalSpend = 0;
        let spendChangeSum = 0;
        let roasChangeSum = 0;
        let spendChangeCount = 0;
        let roasChangeCount = 0;
        let totalSale = 0;

        dataSubset.forEach((item) => {
            totalSpend += item.spend || 0;
            totalSale += item.sale || 0;

            if (item.spend_change !== null) {
                spendChangeSum += item.spend_change;
                spendChangeCount++;
            }

            if (item.roas_change !== null) {
                roasChangeSum += item.roas_change;
                roasChangeCount++;
            }
        });

        const averageSpendChange = spendChangeCount
            ? (spendChangeSum / spendChangeCount).toFixed(2)
            : "0.00";
        const averageROASChange = roasChangeCount
            ? (roasChangeSum / roasChangeCount).toFixed(2)
            : "0.00";

        return {
            totalSpend: totalSpend.toFixed(0),
            totalROAS: (totalSale / totalSpend).toFixed(2),
            averageSpendChange,
            averageROASChange,
        };
    };

    const selectedPeriodData: ISelectedPeriodData | any = {
        Broad: calculate(broadData),
        Phrase: calculate(phraseData),
        Exact: calculate(exactData),
    };

    const categories = ["Broad", "Phrase", "Exact"];
    const totalSpends =
        +selectedPeriodData.Broad.totalSpend +
        +selectedPeriodData.Phrase.totalSpend +
        +selectedPeriodData.Exact.totalSpend;

    const finalResult = {
        byMatchType: {
            categories,
            series: [
                {
                    name: "By Spends",
                    data: categories.map(
                        (type) =>
                            +(
                                (+selectedPeriodData[type].totalSpend /
                                    totalSpends) *
                                100
                            ).toFixed(0)
                    ),
                    color: "#3572EF",
                    yAxis: 0,
                    dataLabels: {
                        enabled: true,
                        formatter: function (): string {
                            // @ts-ignore
                            return this.y + "%";
                        },
                    },
                    tooltip: {
                        valueSuffix: "%",
                    },
                },
                {
                    name: "By ROAS",
                    data: categories.map(
                        (type) => +selectedPeriodData[type].totalROAS
                    ),
                    color: "#3ABEF9",
                    yAxis: 1,
                },
            ],
        },
    };

    const delta = categories.reduce(
        (
            acc: Record<string, { roas: number; spend: number }>,
            type: string
        ) => {
            acc[type] = {
                roas: selectedPeriodData[type].averageROASChange,
                spend: selectedPeriodData[type].averageSpendChange,
            };
            return acc;
        },
        {}
    );

    return {
        chartDataSeries: finalResult,
        delta,
    };
};

export const calculateChangePerc = (
    current: number,
    previous: number
): number => {
    if (previous === 0) return 0;
    const change = ((current - previous) / previous) * 100;
    return parseFloat(change.toFixed(1));
};

export const formatReviewRatingData = (originalData: IReviewsOriginalData) => {
    if (originalData) {
        const { rating, rating_count, star_1, star_2, star_3, star_4, star_5 } =
            originalData;
        const calculatePercentage = (starCount: number) =>
            +((starCount / rating_count) * 100).toFixed(0);

        return {
            rating,
            rating_count,
            ratingDistribution: {
                "5 stars": calculatePercentage(star_5),
                "4 stars": calculatePercentage(star_4),
                "3 stars": calculatePercentage(star_3),
                "2 stars": calculatePercentage(star_2),
                "1 star": calculatePercentage(star_1),
            },
        };
    }
    return RATINGS_DEFAULT_DATA;
};

export const groupReviewTrendByChannel = (
    originalData: Array<{
        review_date: string;
        "#reviews": number;
        channel_id: number;
    }>
) => {
    const groupedData = reduce(
        originalData,
        (acc, curr) => {
            const { channel_id, review_date, "#reviews": reviewCount } = curr;
            if (!acc[channel_id]) {
                acc[channel_id] = {
                    channel: channel_id.toString(),
                    review: [],
                };
            }
            acc[channel_id].review.push({
                review_date,
                review_count: reviewCount,
            });
            return acc;
        },
        {} as Record<
            number,
            {
                channel: string;
                review: { review_date: string; review_count: number }[];
            }
        >
    );

    return Object.values(groupedData);
};

export const formatReviewData = (
    originalData: Array<IReviewTrendsOriginalData> = []
) => {
    if (!originalData || originalData.length === 0) {
        return {
            chartDataSeries: {
                categories: [],
                series: [],
            },
        };
    }

    const dates = [
        ...new Set(
            originalData.reduce(
                (acc, channel) =>
                    acc.concat(channel.review.map((r) => r.review_date)),
                []
            )
        ),
    ];

    const series = map(originalData, (channel) => ({
        name: channel.channel,
        data: map(dates, (date) => {
            const review = find(channel.review, (r) => r.review_date === date);
            return review ? review.review_count : 0;
        }),
    }));

    return {
        chartDataSeries: {
            categories: dates,
            series: series,
        },
    };
};

export const formatChannelwiseRatingsAndReviewsData = (
    originalData?: IChannelData[]
) => {
    if (!originalData) {
        return [
            {
                channel_name: titleCase(
                    CHANNEL_CONFIGS[store.getState().channel.value].name
                ),
                review_percentage: 0,
                review_delta: 0,
                rating_percentage: 0,
                rating_delta: 0,
                rating: 0,
            },
        ];
    }

    return map(originalData, (data) => {
        const prevReview = data?.prev_review ?? 0;
        const currReview = data?.curr_review ?? 0;
        const prevRating = data?.prev_rating ?? 0;
        const currRating = data?.curr_rating ?? 0;

        const review_percent = prevReview
            ? ((currReview - prevReview) / prevReview) * 100
            : 0;

        const rating_percent = prevRating
            ? ((currRating - prevRating) / prevRating) * 100
            : 0;

        const formatNumber = (num: number | null | undefined) => {
            if (num == null || isNaN(num)) {
                return 0;
            }
            return num % 1 === 0 ? num : +num.toFixed(1);
        };

        return {
            channel_name: data?.channel
                ? titleCase(data.channel)
                : "Unknown Channel",
            review_percentage: formatNumber(Math.abs(review_percent)),
            review_delta: formatNumber(data?.delta_review),
            rating_percentage: formatNumber(Math.abs(rating_percent)),
            rating_delta: formatNumber(data?.delta_rating),
            rating: formatNumber(data?.star_rating),
        };
    });
};

export const formatReviewVerbatimData = (
    originalData: IReviewVerbatimOriginalData[] | []
) => {
    if (!Array.isArray(originalData)) {
        return [];
    }

    return map(originalData, (data) => ({
        review_id: data.review_id || "Unknown",
        title: data.review_title || "No Title",
        review_content: data.review_content || "No Content",
        channel: data.name || "Unknown Channel",
        review_date: data.review_date || "Unknown Date",
        found_helpful: data.found_helpful || "",
        rating: data.rating ?? 0,
        about_driver: data.about_driver || "",
    }));
};

export const formatSentimentData = (
    data: ISentimentOriginalData[] | undefined
) => {
    const safeData: any[] = data ?? [];
    const extractSentiments = (key: keyof ISentimentOriginalData) =>
        map(
            filter(safeData, (item) => item.theme && item[key]),
            (item) => ({
                comment: item.theme!,
                category: item[key]!,
            })
        );

    const positiveSentiments = extractSentiments("theme_postitive");
    const negativeSentiments = extractSentiments("theme_negative");

    return {
        positiveSentiments,
        negativeSentiments,
    };
};

export const formatProductAnalysisData = (
    originalData: ProductAnalysisOriginalData[]
) => {
    return originalData && originalData.length
        ? map(originalData, (entry) => ({
              key: entry.key || entry.sku,
              productImage: entry.product_image || "",
              productName: entry.product_name || "N/A",
              bsr: entry.bsr || "N/A",
              avgPrice: entry.avg_price ? +entry.avg_price.toFixed(1) : 0,
              avgDiscount: entry.discount_range
                  ? parseFloat(entry.discount_range)
                  : 0,
              priceRange: entry.price_range || "N/A",
              discountRange: entry.discount_range || "N/A",
              rating: entry.rating || 0,
              ratingsCount: entry.ratings_count || 0,
              reviewsCount: entry.reviews_count || 0,
              sku: entry.key || entry.sku || "N/A",
              skuLink: entry.sku_link || "N/A",
              bsrCategory: entry.bsr_category || "N/A",
          }))
        : [
              {
                  key: "1",
                  productImage: null,
                  productName: "No Data",
                  bsr: null,
                  avgPrice: 0,
                  avgDiscount: 0,
                  priceRange: "-",
                  discountRange: "-",
                  rating: 0,
                  ratingsCount: 0,
                  reviewsCount: 0,
                  sku: "-",
                  skuLink: null,
                  bsrCategory: null,
              },
          ];
};

export const formatCategoriesFilters = (data: Array<ICategoryData>) => {
    const formattedData: ICategoriesOptions = {
        categories: [],
        subCategories: [],
    };

    if (data.length) {
        each(data, (entry) => {
            const { tag_type, tags } = entry;
            if (tag_type === "Category" && tags) {
                formattedData.categories = [
                    ...map(tags, (tag) => ({
                        value: tag,
                        label: tag,
                    })),
                ];
            } else if (tag_type === "Subcategory" && tags) {
                formattedData.subCategories = [
                    ...map(tags, (tag) => ({
                        value: tag,
                        label: tag,
                    })),
                ];
            }
        });
    }

    return formattedData;
};

export const formatSkusFilters = (data: Array<ISkusData>) => {
    return {
        skus: data.length
            ? map(data, (item) => ({
                  value: item.sku,
                  label: item.sku,
              }))
            : [],
    };
};

export const formatCustomerSatisfactionData = (
    data?: ICustomerSatisfactionOriginalData[]
) => {
    if (!data || data.length === 0) {
        return {
            chartDataSeries: {
                categories: [],
                series: [
                    { name: "Satisfied", data: [], color: "blue" },
                    { name: "Neutral", data: [], color: "orange" },
                    { name: "Dissatisfied", data: [], color: "red" },
                ],
            },
            npsData: [],
        };
    }

    // Sort data by the sum of satisfied_count, dissatisfied_count, and neutral_count in descending order
    const sortedData = chain(data)
        .sortBy(
            (item) =>
                -(
                    (+item.satisfied_count || +item.satisfied || 0) +
                    (+item.neutral_count || +item.neutral || 0) +
                    (+item.dissatisfied_count || +item.dissatisfied || 0)
                )
        )
        .value();

    const categories = map(sortedData, (item) => startCase(item.sentiment));
    const colors: Record<string, string> = {
        satisfied: "blue",
        neutral: "orange",
        dissatisfied: "red",
    };

    const seriesNames = ["satisfied", "neutral", "dissatisfied"];
    const series = map(seriesNames, (name) => ({
        name: titleCase(name),
        data: map(
            sortedData,
            (item) =>
                +item[
                    (`${name}_count` ||
                        name) as keyof ICustomerSatisfactionOriginalData
                ]
        ),
        color: colors[name],
    }));

    const npsData = map(sortedData, (item) => {
        const score = item["nps_score"] || item["nps score"];
        if (score == null) return 0;
        const parsedScore = parseFloat(score);
        return Number.isInteger(parsedScore)
            ? parsedScore
            : +parsedScore.toFixed(1);
    });

    return {
        chartDataSeries: {
            categories,
            series,
        },
        npsData,
    };
};

export const groupByDateDriverwiseReviewTrendData = (
    data: IDriverwiseReviewTrendData[]
): IGroupedDriverwiseReviewTrendData[] => {
    const groupedResult = data.reduce(
        (
            result: Record<string, IGroupedDriverwiseReviewTrendData>,
            item: IDriverwiseReviewTrendData
        ) => {
            const { review_date, theme, rating } = item;

            if (!result[review_date]) {
                result[review_date] = {
                    review_date,
                    review_trend: [],
                };
            }

            result[review_date].review_trend.push({
                sentiment: theme,
                avg_rating: rating,
            });

            return result;
        },
        {}
    );

    const sortedResult = Object.values(groupedResult).sort(
        (
            a: IGroupedDriverwiseReviewTrendData,
            b: IGroupedDriverwiseReviewTrendData
        ) =>
            new Date(a.review_date).getTime() -
            new Date(b.review_date).getTime()
    );

    return sortedResult;
};

export const formatDriverwiseReviewTrendData = (
    originalData: IDriverwiseReviewTrendOriginalData[]
) => {
    if (!originalData || originalData.length === 0) {
        return [];
    }

    const seriesData: Record<string, any> = {};
    each(originalData, (item) => {
        const date = new Date(item.review_date).getTime();
        each(item.review_trend, (trend) => {
            if (!seriesData[trend.sentiment]) {
                seriesData[trend.sentiment] = [];
            }
            seriesData[trend.sentiment].push([date, trend.avg_rating]);
        });
    });

    const seriesArray = map(keys(seriesData), (sentiment) => ({
        name: startCase(sentiment),
        data: seriesData[sentiment],
    }));

    return seriesArray;
};

export const formatTop10SubCatsByRatingsData = (
    originalData: (ITop10SubCatsByRatingsDataOriginalData | null | undefined)[]
) => {
    return originalData
        ? map(originalData, (item, index) => ({
              label: item?.sub_category || "N/A",
              subcategoryId: item?.sub_category,
              channel: item?.channel || "N/A",
              rating:
                  item?.star_rating != null ? Math.round(item.star_rating) : 0,
              rating_count: item?.["#rating"] ?? 0,
              review_count: item?.["#reviews"] ?? 0,
              nps: item?.["nps score"] ?? 0,
              features: {
                  liked_features: item?.liked_features ?? [],
                  disliked_features: item?.disliked_features ?? [],
              },
          }))
        : [];
};

export const formatTop10SubCatsByRatingsMasterData = (
    originalData: ITop10SubCatsByRatingsOriginalData[]
) => {
    const subcategoryIds: { [key: string]: string } = {};
    let idCounter = 1;

    const groupedData: { [key: string]: { [key: string]: number } } = {};

    each(originalData, ({ review_date, sub_category, rating_count }) => {
        if (!groupedData[review_date]) {
            groupedData[review_date] = {};
        }

        if (!groupedData[review_date][sub_category]) {
            groupedData[review_date][sub_category] = 0;
        }

        groupedData[review_date][sub_category] += rating_count;

        if (!subcategoryIds[sub_category]) {
            subcategoryIds[sub_category] = (idCounter++).toString();
        }
    });

    const masterData: ITop10SubCatsByRatingsMasterData[] = map(
        keys(groupedData),
        (date) => {
            const values: ITop10SubCatsByRatingsSubcatData[] = map(
                keys(groupedData[date]),
                (subcategory) => ({
                    subcategoryId: subcategory,
                    label: subcategory,
                    ratingScore: groupedData[date][subcategory],
                })
            );
            return { date, values };
        }
    );
    return masterData;
};

export const formatBrandwiseOverallTrends = (
    originalData: IBrandwiseOverallTrendsOriginalData[]
) => {
    const categories = Array.from(
        new Set(map(originalData, (item) => item.review_date))
    ).sort();
    const dataByBrand = reduce(
        originalData,
        (acc, item) => {
            if (!acc[item.brand]) {
                acc[item.brand] = {};
            }
            acc[item.brand][item.review_date] = {
                rating: item.rating,
                ratingCount: item.rating_count,
            };
            return acc;
        },
        {} as Record<
            string,
            Record<string, { rating: number; ratingCount: number }>
        >
    );

    const ratingsData = map(keys(dataByBrand), (brand) => ({
        name: brand,
        data: map(categories, (date) => dataByBrand[brand][date]?.rating || 0),
    }));

    const numberOfRatingsData = map(keys(dataByBrand), (brand) => ({
        name: brand,
        data: map(
            categories,
            (date) => dataByBrand[brand][date]?.ratingCount || 0
        ),
    }));

    return { categories, ratingsData, numberOfRatingsData };
};

export const formatSatisfactionDriverwise = (
    originalData: ISatisfactionDriverwiseOriginalData[]
) => {
    const brandMap = new Map();

    each(originalData, (item) => {
        each(item.data, (dataItem) => {
            const brand = dataItem.brand;

            if (!brandMap.has(brand)) {
                brandMap.set(brand, {
                    company: brand,
                    sentiments: [],
                });
            }

            brandMap.get(brand).sentiments.push({
                sentiment: startCase(dataItem.theme),
                rating: dataItem.avg_rating,
                size: 2.5,
            });
        });
    });

    return Array.from(brandMap.values());
};

//TODO: get it reviewed by @vish
export function getTopSubCategories(
    data: ITop10SubCatsByRatingsDataOriginalData[],
    limit = 10
) {
    // Algorithm:
    // 1. Normalize the star rating to a 0-100 scale.
    // 2. Calculate a score based on NPS, star rating, and the number of reviews.
    // 3. Sort the data by the score in descending order.
    // 4. Return the top `limit` subcategories or fewer if less than the specified limit.

    function calculateScore(item: ITop10SubCatsByRatingsDataOriginalData) {
        const npsScore = item["nps score"] || 0;
        const starRating = item.star_rating || 0;
        const reviewCount = item["#reviews"] || 0;

        // Normalize star rating (1-5 -> 0-100)
        const normalizedStarRating = (starRating - 1) * 25;

        // Weighted sum: NPS (50%), star rating (30%), review count (20%)
        return (
            npsScore * 0.5 +
            normalizedStarRating * 0.3 +
            Math.log(reviewCount + 1) * 0.2
        );
    }

    // Add score to each item and sort by score in descending order
    const scoredData = map(data, (item) => ({
        ...item,
        score: calculateScore(item),
    })).sort((a, b) => b.score - a.score);

    return scoredData.slice(0, limit);
}

export const formatRatingSummary = (
    input: RatingInput
): IRatingSummaryData | null => {
    if (!input) return null;

    const {
        current_rating,
        current_rating_count,
        current_review_count,
        prev_rating,
        prev_rating_count,
        prev_review_count,
        star1,
        star2,
        star3,
        star4,
        star5,
    } = input;

    const stars = [star1, star2, star3, star4, star5];
    const totalStars = reduce(stars, (a, b) => a + b, 0);

    const calcPercentage = (count: number) =>
        totalStars ? Math.round((count / totalStars) * 100) : 0;

    const ratingBars = map(stars, (count, index) => ({
        label: (index + 1).toString(),
        percentage: calcPercentage(count),
    }));

    const ratingDistribution = Object.fromEntries(
        map(stars, (count, index) => [
            `${index + 1} star${index === 0 ? "" : "s"}`,
            calcPercentage(count),
        ])
    );

    return {
        rating: {
            value: current_rating,
            change: Math.round((current_rating - prev_rating) * 10) / 10,
        },
        numRatings: {
            value: current_rating_count,
            change: current_rating_count - prev_rating_count,
            velocity: current_rating_count >= prev_rating_count ? 1 : -1,
        },
        reviews: {
            total: current_review_count,
            change: current_review_count - prev_review_count,
            averageRating: Math.round((current_rating / 5) * 10) / 10,
            ratingBars,
        },
        ratings: {
            rating: Math.round((current_rating / 5) * 10) / 10,
            rating_count: current_rating_count,
            ratingDistribution,
        },
    };
};

export const formatSatisfactionDriversSummary = (
    input: TSentimentData[]
): { positives: ISatisfactionDriver[]; negatives: ISatisfactionDriver[] } => {
    if (!input) return { positives: [], negatives: [] };

    const result = reduce(
        input,
        (
            acc,
            { sentiment, sentiment_type, curr_nps_score, prev_nps_score }
        ) => {
            const driver: ISatisfactionDriver = {
                name: sentiment,
                score: curr_nps_score,
                change: calculateChangePerc(
                    curr_nps_score || 0,
                    prev_nps_score || 0
                ),
            };

            if (sentiment_type === "positive") {
                acc.positives.push(driver);
            } else if (sentiment_type === "negative") {
                acc.negatives.push(driver);
            }

            return acc;
        },
        { positives: [], negatives: [] }
    );

    return result;
};

export const formatWordcloudReviewData = (
    input: IWordcloudReviewData[]
): IWordcloudReviewWidgetData => {
    if (!input || input.length === 0) {
        return { positiveReviewData: [], negativeReviewData: [] };
    }

    // Process input to group by phrase_value and calculate weights
    const groupedData = chain(input)
        .groupBy("phrase_value")
        .map((items, phrase_value) => ({
            sentiment_type: items[0].sentiment_type,
            name: startCase(phrase_value.replace(/_/g, " ")),
            weight: items.length,
        }))
        .sortBy("weight")
        .value();

    const { positiveReviewData, negativeReviewData } = groupedData.reduce(
        (acc, item) => {
            if (item.sentiment_type === "positive") {
                acc.positiveReviewData.push(item);
            } else if (item.sentiment_type === "negative") {
                acc.negativeReviewData.push(item);
            }
            return acc;
        },
        { positiveReviewData: [], negativeReviewData: [] } as {
            positiveReviewData: IWordcloudReviewElementsData[];
            negativeReviewData: IWordcloudReviewElementsData[];
        }
    );

    const formatTopItems = (data: IWordcloudReviewElementsData[]) =>
        first(data, 15).map((item, index) =>
            extend(item, { weight: index + 1 })
        );

    return {
        positiveReviewData: formatTopItems(positiveReviewData),
        negativeReviewData: formatTopItems(negativeReviewData),
    };
};
export const formatTrendsWithCompareModalData = (
    input: TTrendsWithComparisionData[],
    formatterkeys: ITrendsWithComparisionWidgetFormatterKeys
): ITrendsWithCompareModalWidgetData => {
    const {
        categoryKey,
        yAxisKey,
        yAxisOppositeKey,
        yAxisOppositeKeyOptional,
    } = formatterkeys;
    const result: ITrendsWithCompareModalWidgetData = {
        categories: [],
        yAxisData: [],
        yAxisOppositeData: [],
        yAxisOppositeDataOptional: [],
    };

    if (!input || !Array.isArray(input)) {
        return result;
    }

    each(input, (item) => {
        result.categories.push(item?.[categoryKey] ?? "N/A");
        result.yAxisData.push(item?.[yAxisKey] ? round(item?.[yAxisKey]) : 0);
        result.yAxisOppositeData.push(
            item?.[yAxisOppositeKey] ? round(item?.[yAxisOppositeKey]) : null
        );
        result.yAxisOppositeDataOptional.push(
            item?.[yAxisOppositeKeyOptional]
                ? round(item?.[yAxisOppositeKeyOptional])
                : null
        );
    });

    return result;
};

export const formatReviewsAndVerbatimTableData = (
    originalData: TProductReviewData[] = []
): TProductReviewFormattedTableData => {
    if (!Array.isArray(originalData) || originalData.length === 0) {
        return { tableData: [], expandedTableData: {} };
    }

    const groupedData = groupBy(originalData, "review_id");

    const tableData: TProductReviewTableDataEntry[] = map(
        groupedData,
        (group, reviewId) => {
            const firstEntry = group[0];
            const ratingsSum = reduce(
                group,
                (sum, { rating = 0 }) => sum + rating,
                0
            );
            const combinedDrivers = compact(pluck(group, "about_driver"));

            return {
                review_id: reviewId,
                review_title: firstEntry.review_title || "-",
                content: firstEntry.content || "-",
                channel: titleCase(CHANNEL_CONFIGS[firstEntry.channel_id].name),
                sentiment_type: firstEntry.sentiment_type || "-",
                sentiment_score: firstEntry.sentiment_score || 0,
                review_date: firstEntry.review_date || "-",
                rating: ratingsSum / group.length,
                found_useful: Boolean(firstEntry.found_useful),
                about_driver: combinedDrivers,
            };
        }
    );

    const expandedTableData = groupBy(
        map(
            originalData,
            ({
                review_id,
                sentiment_type,
                sentiment_score,
                review_date,
                about_driver,
                phrase_value,
            }) => ({
                review_id,
                sentiment_type: sentiment_type || "-",
                sentiment_score: sentiment_score || 0,
                review_date: review_date || "-",
                theme: startCase(about_driver) || "-",
                verbatim: phrase_value || "-",
            })
        ),
        "review_id"
    );

    return { tableData, expandedTableData };
};

export const formatSatisfactionDriversData = (
    originalData:
        | (ISatisfactionDriversOriginalData | null | undefined)[]
        | null
        | undefined
): ISatisfactionDriversFormattedData[] => {
    if (!originalData || !Array.isArray(originalData)) {
        return [];
    }

    return map(originalData, (data, index) => ({
        key: (index + 1).toString(),
        review_id: data?.review_id,
        phrase: data?.phrase_value
            ? `“${data.phrase_value}”`
            : "No phrase available",
        channel: titleCase(CHANNEL_CONFIGS[data?.channel_id].name),
        sentiment: data?.sentiment_type || "-",
        date_published: data?.review_date || "-",
        rating: data?.rating || 0,
        about_driver: startCase(data?.sentiment) || "-",
    }));
};

export const formatSatisfactionDriversTrendData = (
    originalData: ISatisfactionDriversOriginalData[] | null | undefined
) => {
    if (!originalData || originalData.length === 0) {
        return {
            chartDataSeries: {
                categories: [],
                series: [],
            },
        };
    }

    const categories = chain(originalData)
        .pluck("review_date")
        .uniq()
        .sortBy((date) => date)
        .value();

    const groupedByChannel = groupBy(originalData, "channel_id");

    const series = map(groupedByChannel, (reviews, channelId) => {
        const data = map(categories, (date) => {
            const reviewsForDate = filter(
                reviews,
                (r) => r.review_date === date
            );
            const averageScore = isEmpty(reviewsForDate)
                ? 0
                : reduce(
                      reviewsForDate,
                      (sum, review) => sum + review.sentiment_score,
                      0
                  ) / reviewsForDate.length;

            return averageScore;
        });

        return {
            name: titleCase(CHANNEL_CONFIGS[+channelId].name),
            data,
        };
    });

    return {
        chartDataSeries: {
            categories,
            series,
        },
    };
};

export const formatCrossChannelsTrendData = (
    originalData: any[] | null | undefined,
    filterKey: string,
    selectedComparisionChannels: string[]
) => {
    if (isEmpty(originalData)) {
        return {
            chartDataSeries: {
                categories: [],
                series: [],
            },
        };
    }

    const currentChannel = store.getState().channel.value;

    const categories = chain(originalData)
        .pluck("review_date")
        .uniq()
        .sortBy((date) => new Date(date).getTime())
        .value();

    const allAvlChannels = chain(originalData)
        .pluck("channel_id")
        .uniq()
        .value();

    const filteredChannels = filter(allAvlChannels, (channelId) => {
        // Skip the current channel
        if (channelId === currentChannel) {
            return false;
        }

        // If "all" is selected, include all channels except the current channel
        if (includes(selectedComparisionChannels, "all")) {
            return true;
        }

        // Otherwise, include only if the channel's mapping is in selectedComparisionChannels
        return includes(
            selectedComparisionChannels,
            CHANNEL_CONFIGS[channelId].name
        );
    });

    //! Ensure current channel data is always first
    const channelIds = [currentChannel, ...filteredChannels];

    const series = map(channelIds, (channelId) => {
        const data = map(categories, (date) => {
            const filteredData = chain(originalData)
                .filter(
                    (item) =>
                        item.review_date === date &&
                        item.channel_id === channelId
                )
                .pluck(filterKey)
                .reduce((sum, value) => sum + value, 0)
                .value();

            // If no data is found, return 0
            return filteredData || 0;
        });

        return {
            name: titleCase(CHANNEL_CONFIGS[channelId].name),
            data,
        };
    });

    return {
        chartDataSeries: {
            categories,
            series,
        },
    };
};

export const getTop5Sentiments = (sentimentsData: any[]) => {
    if (isEmpty(sentimentsData)) return [];

    const sortedData = sortBy(sentimentsData, (item) => -item.nps_score);

    const topSentiments = chain(sortedData).pluck("sentiment").first(5).value();

    return topSentiments;
};

export interface IChartData {
    rating: number;
    rating_count: number;
    sku: string;
}

export const formatProductRatingVsCompetitorsTrend: TProductRatingVsCompetitorsOriginalData =
    (data, selectedSku) => {
        if (isEmpty(data)) {
            return {
                categories: [],
                series: [],
            };
        }

        const categories: string[] = [
            "Your Product",
            ...map(
                filter(data, (item) => item.sku !== selectedSku),
                (item) => item.sku
            ),
        ];

        const [yourProduct, others] = partition(
            data,
            (item) => item.sku === selectedSku
        );

        const seriesData: { y: number; color: string }[] = map(
            [...yourProduct, ...others],
            (item, index) => ({
                y: item.rating_count,
                color:
                    item.sku === selectedSku
                        ? COLORS[0]
                        : COLORS[index % COLORS.length],
                rating: item.rating || 0,
            })
        );

        return {
            categories,
            series: [
                {
                    name: "#Ratings",
                    data: seriesData,
                    showInLegend: false,
                },
            ],
        };
    };

export const formatProductRatingVsCompetitorsSpiderChart = (
    data: IProductRatingVsCompetitorsData[],
    selectedSku: string
): IProductRatingVsCompetitorsSpiderChartData => {
    const groupedBySku = groupBy(data, CommonWidgetMetrics.SKU);

    const uniqueSentiments = map(
        uniq(data, (item) => item.theme),
        (item) => item.theme
    );

    const mapThemesToRatings = (
        skuData: IProductRatingVsCompetitorsData[],
        themesOrder: string[]
    ): number[] => {
        return map(themesOrder, (theme) => {
            const match = find(skuData, { theme });
            return match ? (match.rating !== undefined ? match.rating : 0) : 0;
        });
    };

    const result: IProductRatingVsCompetitorsSpiderChartData = {
        Features: map(uniqueSentiments, (theme) => startCase(theme)),
    };

    each(groupedBySku, (skuData, sku) => {
        const themeScores = mapThemesToRatings(skuData, uniqueSentiments);
        result[sku === selectedSku ? "My SKU Score" : sku] = themeScores;
    });

    const categoryAverage = map(uniqueSentiments, (theme) => {
        const scores = chain(data)
            .filter({ theme })
            .map((item) => (item.rating !== undefined ? item.rating : 0))
            .value();
        return scores.length
            ? reduce(scores, (sum, val) => sum + val, 0) / scores.length
            : 0;
    });

    result["Category Average"] = categoryAverage;

    return result;
};

export const loadingReducer = (
    state: TPaModuleLoadingState,
    action: TPaModuleReducerActions
): TPaModuleLoadingState => {
    switch (action.type) {
        case "RESET":
            return action.payload;
        default:
            if (action.type in state) {
                return { ...state, [action.type]: action.payload };
            }
            throw new Error(`Unhandled action type: ${action.type}`);
    }
};

export const round = (value: number, decimals = 2): number => {
    const factor = Math.pow(10, decimals);
    return Math.round(value * factor) / factor;
};

export const calculateRpi = (data: IRpiData, basePrice?: number): number => {
    const { price = 0, revenue = 0, upd = 0 } = data;
    const inferredBasePrice = isUndefined(basePrice)
        ? upd > 0
            ? revenue / upd
            : 0
        : basePrice;
    if (inferredBasePrice <= 0) {
        return 0;
    }

    const rpi = (price / inferredBasePrice) * 100;
    return round(rpi, 2);
};

export const formatPriceVsSalesData = (
    originalData: IPriceVsSalesDataOriginalData[]
): IPriceVsSalesFormattedData[] => {
    if (!originalData || !Array.isArray(originalData)) {
        return [];
    }

    return map(originalData, (item) => ({
        price: round(item.price, 2),
        sales: item.sales_units,
    }));
};

export const formatMsVsRpiData = (
    originalData?: IMsVsRpiDataOriginalData[] | null,
    type: string = MyProductTrendsTypes.RPI
): IMsVsRpiDataFormattedData => {
    if (!isArray(originalData) || isEmpty(originalData)) {
        return {
            categories: [],
            series: [
                {
                    name:
                        type === MyProductTrendsTypes.RPI
                            ? MyProductTrendsTypes.RPI.toUpperCase()
                            : titleCase(MyProductTrendsTypes.PRICE),
                    data: [],
                },
                { name: "Market Share (%)", data: [] },
            ],
        };
    }

    const { categories, rpiData, priceData, marketShareData } = chain(
        originalData
    )
        .compact()
        .map((item) => ({
            crawl_date: item.crawl_date,
            price: isNumber(item.price) ? item.price : 0,
            market_share: isNumber(item.market_share) ? item.market_share : 0,
            revenue: isNumber(item.revenue) ? item.revenue : 0,
            upd: isNumber(item.upd) && item.upd > 0 ? item.upd : 1,
            avg_price_on_date: isNumber(item.avg_price_on_date)
                ? item.avg_price_on_date
                : 0,
        }))
        .sortBy((item) => item.crawl_date)
        .reduce(
            (acc, item) => {
                acc.categories.push(item.crawl_date);

                if (type === MyProductTrendsTypes.RPI) {
                    const rpi =
                        item.price > 0 && item.avg_price_on_date > 0
                            ? round(
                                  (item.price / item.avg_price_on_date) * 100,
                                  2
                              )
                            : 0;
                    acc.rpiData.push(rpi);
                } else {
                    acc.priceData.push(parseFloat(item.price.toFixed(2)));
                }

                acc.marketShareData.push(
                    parseFloat(item.market_share.toFixed(2))
                );
                return acc;
            },
            {
                categories: [],
                rpiData: [],
                priceData: [],
                marketShareData: [],
            } as {
                categories: string[];
                rpiData: number[];
                priceData: number[];
                marketShareData: number[];
            }
        )
        .value();

    return {
        categories,
        series: [
            {
                name:
                    type === MyProductTrendsTypes.RPI
                        ? MyProductTrendsTypes.RPI.toUpperCase()
                        : titleCase(MyProductTrendsTypes.PRICE),
                data: type === MyProductTrendsTypes.RPI ? rpiData : priceData,
            },
            {
                name: "Market Share (%)",
                data: marketShareData,
            },
        ],
    };
};

export const chartToggleFiltersReducer = (
    state: Partial<IPricingChartsToggleFiltersState>,
    action: Partial<IPricingChartsToggleFiltersActions>
) => {
    switch (action.type) {
        case "RESET":
            return action.payload;
        default:
            if (action.type in state) {
                return { ...state, [action.type]: action.payload };
            }
            throw new Error(`Unhandled action type: ${action.type}`);
    }
};

export const chartFiltersReducer = (
    state: Partial<
        | IPricingChartsFiltersState
        | IAvailabilityChartsFiltersState
        | Record<string, any>
    >,
    action: Partial<
        | IPricingChartsFiltersActions
        | IAvailabilityChartsFiltersActions
        | Record<string, any>
    >
) => {
    switch (action.type) {
        case "RESET":
            return action.payload;
        default:
            if (action.type in state) {
                return { ...state, [action.type]: action.payload };
            }
            throw new Error(`Unhandled action type: ${action.type}`);
    }
};

export const formatPriceDealsData = (
    originalData: IPriceDealsDataOriginalData[] | null | undefined
): IPriceDealsDataFormattedData[] => {
    return chain(originalData || [])
        .compact()
        .map((item) => ({
            date: item.crawl_date,
            price: round(item.price ?? 0, 2),
            deal: round(item.deal ?? 0, 2),
        }))
        .sortBy((item) => item.date)
        .value();
};

export const formatPricingSummaryData = (
    originalData: IPricingSummaryOriginalData
): IPricingSummaryFormattedData => {
    const {
        current_price: currentPrice = 0,
        previous_price: previousPrice = 0,
        current_rpi: currentRpi = 0,
        previous_rpi: previousRpi = 0,
        best_sku_rpi: bestSkuRpi = 0,
        per_unit: perUnit = 0,
        current_deal: currentDeal = 0,
        previous_deal: previousDeal = 0,
    } = originalData || {};

    const currency = store.getState().channelCurrencySymbol.value;

    return {
        price: {
            value: `${currency}${currentPrice ? currentPrice.toFixed(2) : 0}`,
            change: calculateChangePerc(currentPrice, previousPrice),
            unitPrice: `${currency}${perUnit ? perUnit.toFixed(2) : 0}`,
        },
        rpi: {
            value: currentRpi ? parseFloat(currentRpi.toFixed(2)) : 0,
            change: calculateChangePerc(currentRpi, previousRpi),
            percentage: bestSkuRpi,
            status:
                bestSkuRpi > 0
                    ? CommonWidgetMetrics.ABOVE
                    : CommonWidgetMetrics.BELOW,
        },
        averageDealPercentage: {
            value: currentDeal ? parseFloat(currentDeal.toFixed(2)) : 0,
            change: calculateChangePerc(currentDeal, previousDeal),
        },
    };
};

export const formatVisibilitySummaryData = (
    originalData: IVisibilitySummaryOriginalData
): IVisibilitySummaryFormattedData => {
    const {
        [AggregationField.CURRENT_ORGANIC_VISIBILITY]:
            currentOrganicVisibility = 0,
        [AggregationField.CURRENT_PAID_VISIBILITY]: currentPaidVisibility = 0,
        [AggregationField.PREVIOUS_ORGANIC_VISIBILITY]:
            previousOrganicVisibility = 0,
        [AggregationField.PREVIOUS_PAID_VISIBILITY]: previousPaidVisibility = 0,
    } = originalData || {};

    return {
        organicVisibility: {
            value: currentOrganicVisibility
                ? +currentOrganicVisibility.toFixed(2)
                : 0,
            change: +(
                currentOrganicVisibility - previousOrganicVisibility
            ).toFixed(2),
        },
        paidVisibility: {
            value: currentPaidVisibility
                ? +currentPaidVisibility.toFixed(2)
                : 0,
            change: +(currentPaidVisibility - previousPaidVisibility).toFixed(
                2
            ),
            percentage: currentPaidVisibility,
            status:
                currentPaidVisibility > 0
                    ? CommonWidgetMetrics.ABOVE
                    : CommonWidgetMetrics.BELOW,
        },
        GV: {
            value: 0,
            change: 0,
        },
    };
};

export const formatVisibilityMyProductTrendData = (
    data: Array<VisibilityMyProductTrendData>
) => {
    return map(data, (item) => {
        const orgSku = item.org_sku_wt_crawl_sv || 0;
        const orgCat = item.org_cat_wt_crawl_sv || 1;
        const paidSku = item.paid_sku_wt_crawl_sv || 0;
        const paidCat = item.paid_cat_wt_crawl_sv || 1;

        return {
            ...item,
            organic_visibility: round((orgSku / orgCat) * 100, 2),
            paid_visibility: round((paidSku / paidCat) * 100, 2),
            overall_visibility: round(
                ((orgSku + paidSku) / (orgCat + paidCat)) * 100,
                2
            ),
        };
    });
};

const formatSKUData = (
    data: ICompetitiveProductsDaywiseOriginalData[],
    sku: string,
    currency: string
): ICompetitiveProductsDaywiseFormattedData => {
    const skuTitle = data[0]?.sku_title || "Unknown";
    const metrics: ICompetitiveProductsDaywiseMetrics[] = [
        { type: "MS" },
        { type: "Price" },
    ];

    const sortedData = sortBy(data, CommonWidgetMetrics.CRAWL_DATE).reverse();

    each(sortedData, (item) => {
        const { crawl_date, market_share, price } = item;

        if (crawl_date) {
            metrics[0][crawl_date] = `${(market_share ?? 0).toFixed(1)}%`;
            metrics[1][crawl_date] = price
                ? `${currency} ${price.toFixed(1)}`
                : "-";
        }
    });

    return {
        name: `${skuTitle}-[${sku}]`,
        metrics,
    };
};

export const formatCompetitiveProductsDaywise = (
    originalData: ICompetitiveProductsDaywiseOriginalData[] | null | undefined,
    selectedSKU: string
): ICompetitiveProductsDaywiseFormattedData[] => {
    if (!isArray(originalData) || isEmpty(originalData)) {
        return [];
    }

    const currency = store.getState().channelCurrencySymbol.value;
    const groupedData = groupBy(originalData, CommonWidgetMetrics.SKU);

    const selectedSKUData = groupedData[selectedSKU] || [];
    const otherSKUData = omit(groupedData, selectedSKU);

    const sortedOtherSKUData = Object.entries(otherSKUData).sort(
        ([, dataA], [, dataB]) => {
            const latestMarketShareA = getLatestMarketShare(dataA);
            const latestMarketShareB = getLatestMarketShare(dataB);

            if (latestMarketShareA === null || latestMarketShareA === undefined)
                return 1;
            if (latestMarketShareB === null || latestMarketShareB === undefined)
                return -1;

            return latestMarketShareB - latestMarketShareA;
        }
    );

    const formattedData = [
        ...(selectedSKUData.length > 0
            ? [formatSKUData(selectedSKUData, selectedSKU, currency)]
            : []),
        ...sortedOtherSKUData.map(([sku, data]) =>
            formatSKUData(data, sku, currency)
        ),
    ];

    return formattedData;
};

const getLatestMarketShare = (
    data: ICompetitiveProductsDaywiseOriginalData[]
): number | null => {
    const latestData = data.sort(
        (a, b) =>
            new Date(b.crawl_date).getTime() - new Date(a.crawl_date).getTime()
    )[0];
    return latestData?.market_share ?? null;
};

export const formatPricingCompetitiveAnalysis = (
    originalData: IPricingCompetitiveAnalysisOriginalData[]
): IPricingCompetitiveAnalysisFormattedData[] => {
    if (!isArray(originalData)) {
        return [];
    }

    return map(originalData, (item, index) => {
        const price = isNumber(item.price) ? item.price : 0;
        const sales = isNumber(item.sales) ? item.sales : 0;
        const volume = isNumber(item.unit_per_day) ? item.unit_per_day : 0;
        const productName = isString(item.sku)
            ? item.sku
            : `Product ${index + 1}`;
        const skuTitle = isString(item.sku_title)
            ? item.sku_title
            : `Product ${index + 1}`;
        return { price, sales, volume, productName, skuTitle };
    });
};

export const formatPricingSatisfactionDriversSummary = (
    input: IPricingSatisfactionSummaryOriginalData[]
): IPricingSatisfactionSummaryFormattedData => {
    if (!input) return { positives: [], negatives: [] };

    const formattedData = map(input, (item) => {
        const {
            sku: sku = 0,
            curr_price: currPrice = 0,
            prev_price: prevPrice = 0,
            curr_revenue: currRevenue = 0,
            curr_upd: currUpd = 0,
        } = item;
        return {
            product_name: sku,
            price_drop: calculateChangePerc(currPrice ?? 0, prevPrice ?? 0),
            rpi:
                currPrice > 0 && currRevenue > 0
                    ? calculateRpi({
                          price: currPrice,
                          revenue: currRevenue,
                          upd: currUpd,
                      })
                    : 0,
        };
    });

    const result = formattedData.reduce(
        (acc, item) => {
            if (item.price_drop < 0) {
                acc.negatives.push(item);
            } else if (item.price_drop > 0) {
                acc.positives.push(item);
            }
            return acc;
        },
        { positives: [], negatives: [] }
    );

    return result;
};

export const formatVisibilitySatisfactionDriversSummary = (
    input: IVisibilitySatisfactionSummaryOriginalData[]
): IPricingSatisfactionSummaryFormattedData => {
    if (!input) return { positives: [], negatives: [] };

    const formattedData = map(input, (item) => {
        const {
            [AggregationField.KEYWORD]: keyword = 0,
            [AggregationField.CURRENT_WT_CRAWL_SV]: currentSV = 0,
            [AggregationField.PREVIOUS_WT_CRAWL_SV]: previousSV = 0,
        } = item;
        return {
            keyword_name: keyword,
            sv_change:
                currentSV && previousSV
                    ? +(currentSV * 100 - previousSV * 100).toFixed(2)
                    : 0,
        };
    });

    const result = formattedData.reduce(
        (acc, item) => {
            if (item.sv_change < 0) {
                acc.negatives.push(item);
            } else if (item.sv_change > 0) {
                acc.positives.push(item);
            }
            return acc;
        },
        { positives: [], negatives: [] }
    );

    return result;
};

export const calculateMsPercent = (data: any) => {
    const { revenue = 0, cat_revenue = 0 } = data;

    return round((revenue / cat_revenue) * 100, 2);
};

export const formatMyProductTrends = (
    originalData: Partial<IMyProductTrendsOriginalData>[] | null | undefined,
    type: MyProductTrendsTypes,
    groupKey?: string
): IMyProductTrendsFormatterData => {
    if (isEmpty(originalData)) {
        return {
            chartDataSeries: {
                categories: [],
                series: [],
            },
            skuTitles: {},
        };
    }

    let dataToFormat = originalData;

    if (type === MyProductTrendsTypes.RPI) {
        dataToFormat = map(dataToFormat, (item) => ({
            ...item,
            [CommonWidgetMetrics.CURR_RPI]: calculateRpi({
                price: item.price,
                revenue: item.revenue,
                upd: item.unit_per_day,
            }),
        }));
    }

    const groupedData = groupBy(
        dataToFormat,
        groupKey || CommonWidgetMetrics.NAME
    );
    const categories = chain(dataToFormat)
        .pluck(CommonWidgetMetrics.CRAWL_DATE)
        .uniq()
        .value();
    const skuTitles: Record<string, string> = {};

    const series = map(groupedData, (items, name) => {
        const firstItem = items[0];
        if (firstItem?.sku_title) {
            skuTitles[name] = firstItem.sku_title;
        } else if (firstItem?.sku) {
            skuTitles[name] = firstItem.sku;
        } else if (firstItem?.brand) {
            skuTitles[titleCase(name)] = titleCase(firstItem.brand);
        } else {
            skuTitles[name] = firstItem.keyword;
        }

        return {
            name: titleCase(name),
            data: pluck(items, MY_PRODUCT_TRENDS_FILTER_MAP[type]).map(
                (value) =>
                    value
                        ? typeof value === "boolean"
                            ? value
                                ? 100
                                : 0
                            : parseFloat(value.toFixed(2))
                        : 0
            ),
        };
    });

    return {
        chartDataSeries: {
            categories,
            series,
        },
        skuTitles,
    };
};

export const formatPricingCompetitiveAnalysisTrends = (
    originalData:
        | IPricingCompetitiveAnalysisTrendsOriginalData[]
        | null
        | undefined,
    mySku: string
): IPricingCompetitiveAnalysisTrendsFormattedData => {
    if (!originalData || !Array.isArray(originalData)) {
        return {
            products: [],
            prices: [],
            dealPercentages: [],
            categoryAveragePrice: [],
            skuTitles: [],
        };
    }

    const groupedData = groupBy(
        originalData.filter((item) => item.sku),
        CommonWidgetMetrics.SKU
    );

    const products: string[] = [];
    const prices: number[] = [];
    const dealPercentages: number[] = [];
    const categoryAveragePrice: number[] = [];
    const skuTitles: string[] = [];

    const orderedGroupedData =
        mySku in groupedData
            ? { [mySku]: groupedData[mySku], ...groupedData }
            : groupedData;

    each(orderedGroupedData, (items, sku) => {
        products.push(sku === mySku ? "My Product" : sku);
        skuTitles.push(items[0]?.sku_title || "Unknown Title");

        const sortedItems = sortBy(items, (item) => item.crawl_date || "");

        const latestData = last(sortedItems) || {
            price: 0,
            current_deal_percentage: 0,
        };

        prices.push(latestData.price ?? 0);
        dealPercentages.push(latestData.current_deal_percentage ?? 0);

        // Calculate average price
        const validPrices = pluck(
            filter(
                items,
                (item) => item.price !== null && item.price !== undefined
            ),
            CommonWidgetMetrics.PRICE
        ) as number[];
        const averagePrice = validPrices.length
            ? reduce(validPrices, (sum, price) => sum + price, 0) /
              validPrices.length
            : 0;
        categoryAveragePrice.push(averagePrice);
    });

    return {
        products,
        prices,
        dealPercentages,
        categoryAveragePrice,
        skuTitles,
    };
};

/* 
  !Note [DND]: 
  * Antd Rating do not support fractional values for rating like 2.4 etc only 0.5 values works
  * So we need to round to nearest 0.5 to show the half stars in this view, using the below function
*/

export const roundToDynamicPrecisionForRating = (value: number) => {
    const fractionalPart = value % 1;

    // If fractional part is between 0.1 and 0.49, round up to the nearest 0.5
    if (fractionalPart > 0 && fractionalPart <= 0.49) {
        return Math.floor(value) + 0.5;
    }

    // If fractional part is 0.5, keep the value unchanged
    if (fractionalPart === 0.5) {
        return value;
    }

    // If fractional part is between 0.51 and 0.99, round down to the nearest 0.5
    if (fractionalPart > 0.5 && fractionalPart < 1) {
        return Math.floor(value) + 0.5;
    }

    return value;
};

export const formatKeywordVisibilityData = (
    data: IKeywordVisibilityInputData[]
): IKeywordVisibilityFormattedData[] => {
    // Group data by keyword
    const grouped = groupBy(data, AggregationField.KEYWORD);

    return map(grouped, (items, keyword) => {
        const initialStats = {
            count: 0,
            sumPaidKwd: 0,
            sumPaidCat: 0,
            sumOrgKwd: 0,
            sumOrgCat: 0,
            organicTimePage1: 0,
            sponsoredTimePage1: 0,
            organicTop5: 0,
            sponsoredTop5: 0,
            indexed: items[0].indexed_organic,
        };

        // Aggregate values
        const stats = reduce(
            items,
            (acc, item) => {
                acc.count++;

                acc.sumPaidKwd += item.paid_kwd_wt_crawl_sv ?? 0;
                acc.sumPaidCat += item.paid_cat_wt_crawl_sv ?? 0;
                acc.sumOrgKwd += item.org_kwd_wt_crawl_sv ?? 0;
                acc.sumOrgCat += item.org_cat_wt_crawl_sv ?? 0;

                if (item.page_number === 1) {
                    item.indexed_organic === "Yes"
                        ? acc.organicTimePage1++
                        : acc.sponsoredTimePage1++;
                }

                if (item.organic_rank !== null && item.organic_rank <= 5) {
                    acc.organicTop5++;
                }

                if (item.sponsored_rank !== null && item.sponsored_rank <= 5) {
                    acc.sponsoredTop5++;
                }

                return acc;
            },
            initialStats
        );

        // Compute percentage values
        const deltaPaid = stats.sumPaidCat
            ? (stats.sumPaidKwd / stats.sumPaidCat) * 100
            : 0;
        const deltaOrg = stats.sumOrgCat
            ? (stats.sumOrgKwd / stats.sumOrgCat) * 100
            : 0;
        const totalCat = stats.sumPaidCat + stats.sumOrgCat;
        const totalKwd = stats.sumPaidKwd + stats.sumOrgKwd;
        const deltaOverall = totalCat ? (totalKwd / totalCat) * 100 : 0;

        // Calculate percentage for counts
        const toPercentage = (value: number) =>
            (stats.count ? (value / stats.count) * 100 : 0).toFixed(2) + "%";

        return {
            key: keyword,
            title: keyword,
            indexed: stats.indexed,
            delta_organic_impr: deltaOrg.toFixed(2) + "%",
            delta_paid_impr: deltaPaid.toFixed(2) + "%",
            delta_overall_impr: deltaOverall.toFixed(2) + "%",
            organic_time_page1: toPercentage(stats.organicTimePage1),
            sponsored_time_page1: toPercentage(stats.sponsoredTimePage1),
            organic_top5_rank: toPercentage(stats.organicTop5),
            sponsored_top5_rank: toPercentage(stats.sponsoredTop5),
        };
    });
};

export const formatmySovVsCompetitionData = (
    data: ISovDataItem[]
): ISovFormattedData => {
    // Extract unique SKUs for categories
    const categories = [...new Set(data.map((item) => item.sku))];

    const bcgClasses = [
        KeywordTypeValues.BRANDED,
        KeywordTypeValues.GENERIC,
        KeywordTypeValues.COMPETITION,
    ];

    function calculateSOV(item: ISovDataItem): number | null {
        const org_kwd = item.org_kwd_wt_crawl_sv || 0;
        const paid_kwd = item.paid_kwd_wt_crawl_sv || 0;
        const org_cat = item.org_cat_wt_crawl_sv || 0;
        const paid_cat = item.paid_cat_wt_crawl_sv || 0;

        return org_cat + paid_cat > 0
            ? ((org_kwd + paid_kwd) / (org_cat + paid_cat)) * 100
            : null;
    }

    // Initialize series structure
    const series: ICTRSeriesItem[] = bcgClasses.map((className) => ({
        name: className.charAt(0).toUpperCase() + className.slice(1), // Capitalize first letter
        data: categories.map((sku) => {
            const item = data.find(
                (d) => d.sku === sku && d.bcg_class === className
            );
            return item ? parseFloat(calculateSOV(item).toFixed(2)) : null;
        }),
    }));

    return { categories, series };
};

export const formatCtrTrendData = (
    rawData: IPerformanceComparisionRawDataItem[]
): ICTRFormattedData => {
    const groupedData = rawData.reduce(
        (
            acc: Record<string, ICTRGroupedDataItem>,
            item: IPerformanceComparisionRawDataItem
        ) => {
            const formattedDate = dayjs(item.date).format("DD-MM-YYYY");

            if (!acc[formattedDate]) {
                acc[formattedDate] = {
                    impression: 0,
                    click: 0,
                    sale: 0,
                    spend: 0,
                    orders: 0,
                };
            }

            acc[formattedDate].impression += item.impression;
            acc[formattedDate].click += item.click;
            acc[formattedDate].sale += item.sale;
            acc[formattedDate].spend += item.spend;
            acc[formattedDate].orders += item.orders;

            return acc;
        },
        {}
    );

    // Extract categories and calculate metrics
    const categories = Object.keys(groupedData);
    const series: ICTRSeriesItem[] = [
        {
            name: "ROAS",
            type: "line",
            data: categories.map((date) => {
                const { sale, spend } = groupedData[date];
                return sale > 0 ? round(spend / sale, 2) : 0;
            }),
            color: "#3FA9F5",
            yAxis: 0,
        },
        {
            name: "CTR",
            type: "line",
            data: categories.map((date) => {
                const { click, impression } = groupedData[date];
                return impression > 0
                    ? round((click / impression) * 100, 2)
                    : 0;
            }),
            color: "#5A3EAB",
            yAxis: 0,
        },
        {
            name: "Conversion Rate",
            type: "line",
            data: categories.map((date) => {
                const { click, orders } = groupedData[date];
                return click > 0 ? round((orders / click) * 100, 2) : 0;
            }),
            color: "#23A455",
            yAxis: 0,
        },
        {
            name: "Impressions",
            type: "column",
            data: categories.map((date) => groupedData[date].impression),
            color: "#007BFF",
            yAxis: 1,
        },
    ];

    return { categories, series };
};

export const PerformanceComparisionData = (
    rawData: IPerformanceComparisionRawDataItem[]
): IPerformanceComparisonData[] => {
    if (!isArray(rawData) || isEmpty(rawData)) {
        return [];
    }
    const aggregatedData: Record<
        string,
        IPerformanceComparisionAggregatedDataItem
    > = rawData.reduce(
        (
            acc: Record<string, IPerformanceComparisionAggregatedDataItem>,
            item
        ) => {
            const date = dayjs(item.date).format("YYYY-MM-DD");

            if (!acc[date]) {
                acc[date] = {
                    impression: 0,
                    clicks: 0,
                    sales: 0,
                    spend: 0,
                    orders: 0,
                    program_type: "",
                };
            }

            // Aggregate values for each date
            acc[date].impression += item.impression || 0;
            acc[date].clicks += item.click || 0;
            acc[date].sales += item.sale || 0;
            acc[date].spend += item.spend || 0;
            acc[date].orders += item.orders || 0;
            acc[date].program_type = item.program_type || "";

            return acc;
        },
        {}
    );

    return Object.keys(aggregatedData).map((date) => {
        const { impression, clicks, sales, spend, orders } =
            aggregatedData[date];

        return {
            date,
            impression: round(impression, 2),
            ctr: impression > 0 ? round((clicks / impression) * 100, 2) : 0,
            roas: sales > 0 ? round(spend / sales, 2) : 0,
            conversionRate: clicks > 0 ? round((orders / clicks) * 100, 2) : 0,
            programType: aggregatedData[date].program_type,
        };
    });
};

export const formatBbWinnersDistributionData = (
    originalData: IBBWinnersDistributionOriginalData[]
) => {
    if (!isArray(originalData) || isEmpty(originalData)) {
        return [];
    }

    return originalData.map((item, index) => ({
        name: item.merchant_name,
        value: item.avg_price,
        color: generateBlueShades(index, originalData.length),
    }));
};

export const categoryOverRadioFiltersReducer = (
    state: TCategoryOverviewRadioFiltersInitialState,
    action: TCategoryOverviewRadioFiltersActions
) => {
    switch (action.type) {
        case "SET_MS_TRENDS_OVERTIME":
            return { ...state, msTrendsOverTimeRadioFilter: action.payload };
        case "SET_BRAND_CONTRIBUTION":
            return { ...state, brandContributionRadioFilter: action.payload };
        case "SET_SUB_CATEGORY_CONTRIBUTION":
            return {
                ...state,
                subCategoriesContributionRadioFilter: action.payload,
            };
        case "SET_BEST_SELLER_SKU":
            return { ...state, bestSellerSkuRadioFilter: action.payload };
        case "SET_SUB_CAT_PERFORMANCE":
            return { ...state, subCatPerformanceRadioFilter: action.payload };
        case "SET_MS_OFFTAKE":
            return { ...state, msOfftakeRadioFilter: action.payload };
        case "SET_SUMMARY_WIDGET":
            return { ...state, revenueUnitsRadioFilter: action.payload };
        case "SET_MS_TRENDS_OVERTIME_METRICS":
            return {
                ...state,
                msTrendsOvertimeMetricsRadioFilter: action.payload,
            };
        default:
            throw new Error(`Unhandled action type: ${(action as any).type}`);
    }
};

export const categoryOverShowHideStatesReducer = (
    state: TCategoryOverviewShowHideStatesInitialState,
    action: TCategoryOverviewShowHideStatesActions
) => {
    switch (action.type) {
        case "SET_SHOW_DRAINERS":
            return { ...state, showDrainers: action.payload };
        case "SET_SHOW_DRAINERS_DELTA_VALUES":
            return { ...state, showDrainersDeltaValues: action.payload };
        case "SET_SHOW_SUBCAT_PERFORMANCE_DELTA_VALUES":
            return {
                ...state,
                showSubCatPerformanceDeltaValues: action.payload,
            };
        case "SET_SHOW_MY_BRANDS_TRENDS":
            return { ...state, showMyBrandTrends: action.payload };
        default:
            throw new Error(`Unhandled action type: ${(action as any).type}`);
    }
};

export const formatCategoryAvailabilityDataEcomm = (data: {
    competition_data: TAvailabilityEcommData[];
    category_data: TAvailabilityEcommData[];
    cross_channel_data: null;
}) => {
    const getPreviousAndCurrentData = (data: TAvailabilityEcommData[]) => {
        const { startDate, endDate } = getSelectedDateRange();

        const sortedData = sortBy(data, (item) =>
            moment(item.crawl_date).toDate()
        );

        const currentData = filter(sortedData, (item) =>
            moment(item.crawl_date).isBetween(startDate, endDate, null, "[]")
        );

        const previousData = filter(sortedData, (item) =>
            moment(item.crawl_date).isBefore(startDate)
        );

        return {
            previousData,
            currentData,
        };
    };

    const {
        previousData: previousDataCategory,
        currentData: currentDataCategory,
    } = getPreviousAndCurrentData(data.category_data);

    const {
        previousData: previousDataCompetition,
        currentData: currentDataCompetition,
    } = getPreviousAndCurrentData(data.competition_data);

    const calculatePercentage = (
        data: TAvailabilityEcommData[],
        key: keyof TAvailabilityEcommData
    ): number => {
        if (!data.length) return 0;

        const count = data.reduce((acc, item) => {
            const value = item[key];
            if (typeof value === "number") {
                return acc + value;
            } else if (value === true) {
                return acc + 1;
            }
            return acc;
        }, 0);

        return round((count / data.length) * 100, 2);
    };

    const availabilityCurrent = calculatePercentage(
        currentDataCategory,
        AggregationField.CURR_AVAILABILITY
    );
    const availabilityPrevious = calculatePercentage(
        previousDataCategory,
        AggregationField.CURR_AVAILABILITY
    );
    const buyboxCurrent = calculatePercentage(
        currentDataCategory,
        AggregationField.BUYBOX_WIN
    );
    const buyboxPrevious = calculatePercentage(
        previousDataCategory,
        AggregationField.BUYBOX_WIN
    );
    const estimatedSalesLossCurrent =
        calculateEstimatedSalesLoss(currentDataCategory);
    const estimatedSalesLossPrevious =
        calculateEstimatedSalesLoss(previousDataCategory);

    const calculateAvailabilityTrendsOverTime = (
        data_arr: TAvailabilityEcommData[]
    ) => {
        if (!data_arr?.length) {
            return { categories: [], yAxisData: [], yAxisOppositeData: [] };
        }

        const grouped_by_date = groupBy(
            data_arr,
            CommonWidgetMetrics.CRAWL_DATE
        );
        const sorted_dates = sortBy(keys(grouped_by_date));

        const get_percent_value = (value: boolean | number | null): number => {
            if (typeof value === "boolean") return value ? 100 : 0;
            if (typeof value === "number") return value * 100;
            return 0;
        };

        const categories: string[] = [];
        const availability_data: number[] = [];
        const buybox_data: number[] = [];

        each(sorted_dates, (date) => {
            const items = grouped_by_date[date];
            const total = items.length;

            const total_availability = reduce(
                items,
                (sum, item) => sum + get_percent_value(item.curr_availability),
                0
            );

            const total_buybox = reduce(
                items,
                (sum, item) => sum + get_percent_value(item.buybox_win),
                0
            );

            categories.push(date);
            availability_data.push(+(total_availability / total).toFixed(2));
            buybox_data.push(+(total_buybox / total).toFixed(2));
        });

        return {
            categories,
            yAxisData: availability_data,
            yAxisOppositeData: buybox_data,
        };
    };

    const availabilityTrendsOverTime =
        calculateAvailabilityTrendsOverTime(currentDataCategory);

    const availabilityIssuesBySubCat = calculateAvailabilityIssues(
        currentDataCategory,
        currentDataCategory,
        CommonWidgetMetrics.SUB_CATEGORY
    );

    const priceImpactOnBuyBoxWinDataFormatted = map(
        groupBy(currentDataCategory, CommonWidgetMetrics.CRAWL_DATE),
        (items, date) => {
            const total = items.length;

            const totalPrice = reduce(
                items,
                (sum, item) =>
                    sum +
                    (typeof item.curr_price === "number" ? item.curr_price : 0),
                0
            );

            const totalBuybox = reduce(
                items,
                (sum, item) => {
                    const value = item.buybox_win;
                    if (typeof value === "number") {
                        return sum + value;
                    } else if (value === true) {
                        return sum + 1;
                    }
                    return sum;
                },
                0
            );

            const totalAvailability = reduce(
                items,
                (sum, item) => {
                    const value = item.curr_availability;
                    if (typeof value === "number") {
                        return sum + value;
                    } else if (value === true) {
                        return sum + 1;
                    }
                    return sum;
                },
                0
            );

            return {
                ...items[0],
                crawl_date: date,
                curr_price: round(totalPrice / total),
                buybox_win: round((totalBuybox / total) * 100),
                curr_availability: round((totalAvailability / total) * 100),
            };
        }
    );

    const priceImpactOnBuyBoxWinData = formatPriceImpactOnBuyBoxWinData(
        priceImpactOnBuyBoxWinDataFormatted,
        getSelectedDateRange(),
        {
            price: AggregationField.CURR_PRICE,
            buyboxWin: AggregationField.BUYBOX_WIN,
            availability: AggregationField.CURR_AVAILABILITY,
        }
    );

    const myBrandVsCompetitionData = getAvailabilityVsBuyboxBySubCategory([
        ...currentDataCategory,
        ...currentDataCompetition,
    ]);

    const oosMsBySubCategoryData = formatOosMsBySubCategory({
        my_sku_data: currentDataCategory,
        competition_data: currentDataCompetition,
    });

    const productsTableData =
        formatProductEcommTableDataBySubCat(currentDataCategory);

    const competitionChartData = formatCompetitionChartData(
        currentDataCompetition
    );

    const comparisonChartData = formatComparisonChartData(currentDataCategory);

    const comparisonTableCurrentData = formatCompetitionTableData(
        currentDataCompetition
    );

    const comparisonTablePreviousData = formatCompetitionTableData(
        previousDataCompetition
    );

    const combinedComparisonTableData = combineComparisonTablesByBrand(
        comparisonTableCurrentData,
        comparisonTablePreviousData
    );

    const buyboxWinnersAndLoserDrawerData =
        calcaulateBuyboxWinnerAndLosersData(currentDataCategory);

    const topSubcategoriesEstimatedSalesLossData =
        calculateTopSubcateogiesWithEstimatedSalesLossEcommAvailabilityData(
            currentDataCategory
        );

    const oosProductsDrawerData =
        calculateTopProductsWithEstimatedLoss(currentDataCategory);

    return {
        summaryWidgetData: {
            availabilityPercentage: {
                value: availabilityCurrent,
                change: round(availabilityCurrent - availabilityPrevious),
            },
            buyboxPercentage: {
                value: buyboxCurrent,
                change: round(buyboxCurrent - buyboxPrevious),
            },
            estimatedSalesLoss: {
                value: estimatedSalesLossCurrent,
                change: round(
                    estimatedSalesLossCurrent - estimatedSalesLossPrevious
                ),
            },
        },
        availabilityTrendsOverTimeData: availabilityTrendsOverTime,
        availabilityIssuesByRegionAndSubcategory: {
            mainSeries: [...availabilityIssuesBySubCat.mainSeries],
            drilldownSeries: [...availabilityIssuesBySubCat.drilldownSeries],
        },
        categoryData: currentDataCategory,
        competitionData: currentDataCompetition,
        comparisonChartData,
        competitionChartData,
        competitionTableData: combinedComparisonTableData,
        crossChannelData: data.cross_channel_data,
        priceImpactOnBuyBoxWinData,
        myBrandVsCompetitionData,
        oosMsBySubCategoryData,
        productsTableData,
        buyboxWinnersAndLoserDrawerData,
        topSubcategoriesEstimatedSalesLossData,
        oosProductsDrawerData,
    };
};
export const getAvailabilityVsBuyboxBySubCategory = (
    data: TAvailabilityEcommData[]
) => {
    const result: Record<
        string,
        {
            brand: string;
            availabilityPercentage: number;
            buyboxPercentage: number;
        }[]
    > = {};

    const groupedBySubCategory = groupBy(
        data,
        CommonWidgetMetrics.SUB_CATEGORY
    );

    Object.entries(groupedBySubCategory).forEach(([subCategory, items]) => {
        const groupedByBrand = groupBy(items, CommonWidgetMetrics.BRAND);

        const brandStats = Object.entries(groupedByBrand).map(
            ([brand, brandItems]) => {
                const total = brandItems.length;

                const sumBoolOrNumber = <T>(
                    items: T[],
                    key: keyof T
                ): number => {
                    return items.reduce((sum, item) => {
                        const value = item[key];
                        if (typeof value === "number") return sum + value;
                        if (value === true) return sum + 1;
                        return sum;
                    }, 0);
                };

                const totalAvailability = sumBoolOrNumber(
                    brandItems,
                    AggregationField.CURR_AVAILABILITY
                );
                const totalBuybox = sumBoolOrNumber(
                    brandItems,
                    AggregationField.BUYBOX_WIN
                );

                return {
                    brand,
                    availabilityPercentage: +(
                        (totalAvailability / total) *
                        100
                    ).toFixed(2),
                    buyboxPercentage: +((totalBuybox / total) * 100).toFixed(2),
                };
            }
        );

        result[subCategory] = brandStats;
    });

    return result;
};

export const formatOosMsBySubCategory = (data: {
    my_sku_data?: TAvailabilityEcommData[];
    competition_data?: TAvailabilityEcommData[];
}) => {
    const { my_sku_data = [], competition_data = [] } = data || {};
    if (!Array.isArray(my_sku_data) || !Array.isArray(competition_data))
        return {};

    const allData = [...my_sku_data, ...competition_data];
    const subCategories = Array.from(
        new Set(allData.map((d) => d.sub_category || "Unknown"))
    );

    const groupedData: Record<string, any> = {};

    subCategories.forEach((subCat) => {
        const myData = my_sku_data.filter(
            (d) => (d.sub_category || "Unknown") === subCat
        );
        const compData = competition_data.filter(
            (d) => (d.sub_category || "Unknown") === subCat
        );
        const combined = [...myData, ...compData];

        const uniqueDates = Array.from(
            new Set(combined.map((d) => d.crawl_date))
        ).sort();

        const myBrandMarketShare: number[] = [];
        const myBrandOOS: number[] = [];
        const competitorDataMap: Record<
            string,
            { marketShare: number[]; oos: number[] }
        > = {};
        const skuLists: Set<string> = new Set();

        uniqueDates.forEach((date) => {
            // 1. Get category total revenue for this sub-cat and date
            const catDataForDate = combined.filter(
                (d) => d.crawl_date === date
            );
            const catRevenue =
                catDataForDate.reduce(
                    (sum, d) => sum + (d.curr_revenue || 0),
                    0
                ) || 1;

            // 2. My Brand Data
            const myRevenueForDate = myData
                .filter((d) => d.crawl_date === date)
                .reduce((sum, d) => sum + (d.curr_revenue || 0), 0);

            myBrandMarketShare.push(
                round((myRevenueForDate / catRevenue) * 100)
            );

            const myAvailabilityForDate = myData.find(
                (d) => d.crawl_date === date
            )?.curr_availability;
            myBrandOOS.push(round(myAvailabilityForDate === false ? 100 : 0));

            // 3. Competitor SKU breakdown
            const compDataForDate = compData.filter(
                (d) => d.crawl_date === date
            );
            const skuGrouped: Record<
                string,
                { revenue: number; unavailable: number; total: number }
            > = {};

            compDataForDate.forEach((d) => {
                const sku = `${d.sku_title} - ${d.sku}` || "Unknown";
                skuLists.add(sku);
                if (!skuGrouped[sku]) {
                    skuGrouped[sku] = { revenue: 0, unavailable: 0, total: 0 };
                }
                skuGrouped[sku].revenue += d.curr_revenue || 0;
                skuGrouped[sku].total += 1;
                if (!d.curr_availability) skuGrouped[sku].unavailable += 1;
            });

            Object.entries(skuGrouped).forEach(([sku, stats]) => {
                if (!competitorDataMap[sku]) {
                    competitorDataMap[sku] = { marketShare: [], oos: [] };
                }
                competitorDataMap[sku].marketShare.push(
                    round((stats.revenue / catRevenue) * 100)
                );
                competitorDataMap[sku].oos.push(
                    round((stats.unavailable / stats.total) * 100)
                );
            });
        });

        const series = [
            {
                name: "My Brand Market Share %",
                type: "column",
                data: myBrandMarketShare,
                color: "#005eff",
            },
            {
                name: "My Brand Out of Stock %",
                type: "line",
                yAxis: 1,
                data: myBrandOOS,
                color: "#005eff",
                marker: { enabled: true },
            },
            ...Object.entries(competitorDataMap).flatMap(([sku, values]) => [
                {
                    name: `SKU ${sku} Market Share %`,
                    type: "column",
                    data: values.marketShare,
                    color: "#ff492c",
                },
                {
                    name: `SKU ${sku} Out of Stock %`,
                    type: "line",
                    yAxis: 1,
                    data: values.oos,
                    color: "#ff492c",
                    dashStyle: "Dash",
                    marker: { enabled: true },
                },
            ]),
        ];

        groupedData[subCat] = {
            categories: uniqueDates,
            skuLists: Array.from(skuLists),
            series,
        };
    });

    return groupedData;
};

export const formatProductEcommTableDataBySubCat = (
    data: TAvailabilityEcommData[]
): Record<string, any[]> => {
    const groupedBySubCat: Record<string, any[]> = {};

    // Group items by sub-category
    for (const item of data) {
        const subCat = item.sub_category || "Unknown";
        if (!groupedBySubCat[subCat]) groupedBySubCat[subCat] = [];
        groupedBySubCat[subCat].push(item);
    }

    const result: Record<string, any[]> = {};

    for (const [subCat, items] of Object.entries(groupedBySubCat)) {
        const skuGrouped: Record<string, any[]> = {};
        let totalCatDrrRevenue = 0;

        for (const item of items) {
            const sku = item.sku;
            if (!skuGrouped[sku]) skuGrouped[sku] = [];
            skuGrouped[sku].push(item);

            totalCatDrrRevenue += item.curr_drr_revenue || 0;
        }

        const tableData = Object.entries(skuGrouped).map(([sku, records]) => {
            // Sort by date to get latest
            const sorted = [...records].sort(
                (a, b) =>
                    new Date(b.crawl_date).getTime() -
                    new Date(a.crawl_date).getTime()
            );
            const latest = sorted[0];

            const title = latest.sku_title;
            const latestSR = latest.sales_rank;
            const currentAvailabilityStatus = latest.curr_availability
                ? "Available"
                : "Unavailable";
            const latestBBwin = latest.merchant_name?.[0] || "N/A";

            // Aggregate over full range
            const availabilityCount = records.filter(
                (r) => r.curr_availability
            ).length;
            const totalCount = records.length;
            const availability = `${round(
                (availabilityCount / totalCount) * 100
            )}%`;
            const timesAvailable = availabilityCount;

            const unavailableRevenue = records
                .filter((r) => !r.curr_availability)
                .reduce((sum, r) => sum + (r.curr_drr_revenue || 0), 0);
            const estimatedLoss =
                totalCatDrrRevenue > 0
                    ? `${round(
                          (unavailableRevenue / totalCatDrrRevenue) * 100
                      )}%`
                    : "0%";

            return {
                title,
                latestSR,
                availability,
                timesAvailable,
                currentAvailabilityStatus,
                latestBBwin,
                estimatedLoss,
            };
        });

        result[subCat] = tableData;
    }

    return result;
};

export const formatCompetitionChartData = (
    data: TAvailabilityEcommData[]
): AvailabilityCompetitionData[] => {
    // Group data by date and brand
    const grouped: Record<
        string,
        Record<string, TAvailabilityEcommData[]>
    > = {};

    data.forEach((item) => {
        const date = item.crawl_date;
        const brand = item.brand || "Unknown";

        if (!grouped[date]) grouped[date] = {};
        if (!grouped[date][brand]) grouped[date][brand] = [];

        grouped[date][brand].push(item);
    });

    // Precompute total revenue per brand (across all dates)
    const totalRevenueByBrand: Record<string, number> = {};

    data.forEach((item) => {
        const brand = item.brand || "Unknown";
        if (!totalRevenueByBrand[brand]) totalRevenueByBrand[brand] = 0;
        totalRevenueByBrand[brand] += item.curr_revenue || 0;
    });

    const result: AvailabilityCompetitionData[] = [];

    Object.entries(grouped).forEach(([date, brandData]) => {
        Object.entries(brandData).forEach(([brand, rows]) => {
            const totalRevenueForDate = rows.reduce(
                (sum, r) => sum + (r.curr_revenue || 0),
                0
            );
            const totalSpend = rows.reduce((sum, r) => sum + (r.spend || 0), 0);
            const totalSales = rows.reduce((sum, r) => sum + (r.sale || 0), 0);

            const availability =
                rows.length > 0
                    ? round(
                          (rows.filter((r) => r.curr_availability).length /
                              rows.length) *
                              100
                      )
                    : 0;

            const buybox_win =
                rows.length > 0
                    ? round(
                          (rows.filter((r) => r.buybox_win).length /
                              rows.length) *
                              100
                      )
                    : 0;

            const ms_percent =
                totalRevenueByBrand[brand] > 0
                    ? round(
                          (totalRevenueForDate / totalRevenueByBrand[brand]) *
                              100
                      )
                    : 0;

            const roas = totalSales > 0 ? round(totalSpend / totalSales) : 0;

            result.push({
                crawl_date: date,
                brand,
                sku_title: rows[0].sku_title, // Can be any representative SKU title
                ms_percent,
                availability,
                buybox_win,
                roas,
                sale: totalSales,
                spend: totalSpend,
            });
        });
    });

    return result;
};

export const formatComparisonChartData = (
    data: TAvailabilityEcommData[]
): AvailabilityCompetitionData[] => {
    const groupedByDate: Record<string, TAvailabilityEcommData[]> = {};

    // Group all records by crawl_date
    data.forEach((item) => {
        const date = item.crawl_date;
        if (!groupedByDate[date]) groupedByDate[date] = [];
        groupedByDate[date].push(item);
    });

    // Calculate total revenue across all dates for MS%
    const totalRevenueAllDates = data.reduce(
        (sum, r) => sum + (r.curr_revenue || 0),
        0
    );

    const result: AvailabilityCompetitionData[] = [];

    Object.entries(groupedByDate).forEach(([date, rows]) => {
        const dateRevenue = rows.reduce(
            (sum, r) => sum + (r.curr_revenue || 0),
            0
        );
        const dateSales = rows.reduce((sum, r) => sum + (r.sale || 0), 0);
        const dateSpend = rows.reduce((sum, r) => sum + (r.spend || 0), 0);

        const availability =
            rows.length > 0
                ? round(
                      (rows.filter((r) => r.curr_availability).length /
                          rows.length) *
                          100
                  )
                : 0;

        const buybox_win =
            rows.length > 0
                ? round(
                      (rows.filter((r) => r.buybox_win).length / rows.length) *
                          100
                  )
                : 0;

        const ms_percent =
            totalRevenueAllDates > 0
                ? round((dateRevenue / totalRevenueAllDates) * 100)
                : 0;

        const roas = dateSales > 0 ? round(dateSpend / dateSales) : 0;

        result.push({
            crawl_date: date,
            ms_percent,
            availability,
            buybox: buybox_win,
            roas,
            sale: round(dateSales),
            spend: round(dateSpend),
        });
    });

    return result;
};

export const formatCompetitionTableData = (
    data: TAvailabilityEcommData[]
): AvailabilityCompetitionData[] => {
    const groupedByBrand: Record<string, TAvailabilityEcommData[]> = {};

    // Group data by brand
    data.forEach((item) => {
        const brand = item.brand || "Unknown";
        if (!groupedByBrand[brand]) groupedByBrand[brand] = [];
        groupedByBrand[brand].push(item);
    });

    // Total revenue of all brands
    const totalRevenueAllBrands = data.reduce(
        (sum, r) => sum + (r.curr_revenue || 0),
        0
    );

    const result: AvailabilityCompetitionData[] = [];

    Object.entries(groupedByBrand).forEach(([brand, rows]) => {
        const brandRevenue = rows.reduce(
            (sum, r) => sum + (r.curr_revenue || 0),
            0
        );
        const brandSales = rows.reduce((sum, r) => sum + (r.sale || 0), 0);
        const brandSpend = rows.reduce((sum, r) => sum + (r.spend || 0), 0);

        const availability =
            rows.length > 0
                ? round(
                      (rows.filter((r) => r.curr_availability).length /
                          rows.length) *
                          100
                  )
                : 0;

        const buybox =
            rows.length > 0
                ? round(
                      (rows.filter((r) => r.buybox_win).length / rows.length) *
                          100
                  )
                : 0;

        const ms_percent =
            totalRevenueAllBrands > 0
                ? round((brandRevenue / totalRevenueAllBrands) * 100)
                : 0;

        const roas = brandSales > 0 ? round(brandSpend / brandSales) : 0;

        result.push({
            brand,
            ms_percent,
            availability,
            buybox,
            roas,
            sale: round(brandSales),
            spend: round(brandSpend),
        });
    });

    return result;
};

export const combineComparisonTablesByBrand = (
    currentData: AvailabilityCompetitionData[],
    previousData: AvailabilityCompetitionData[]
): Record<string, any>[] => {
    const combinedMap: Record<string, Record<string, any>> = {};

    const appendData = (
        source: AvailabilityCompetitionData[],
        prefix: string
    ) => {
        source.forEach(({ brand, ...rest }) => {
            const key = brand || "Unknown";
            if (!combinedMap[key]) combinedMap[key] = { brand: key };
            Object.entries(rest).forEach(([k, v]) => {
                combinedMap[key][`${prefix}${k}`] = v;
            });
        });
    };

    appendData(currentData, "curr_");
    appendData(previousData, "prev_");

    return Object.values(combinedMap);
};

export const calcaulateBuyboxWinnerAndLosersData = (
    data: TAvailabilityEcommData[]
): {
    winners: TBuyboxWinnerAndLosersData[];
    losers: TBuyboxWinnerAndLosersData[];
} => {
    const filterLatestBySkuSubCat = (items: TAvailabilityEcommData[]) => {
        const grouped = groupBy(
            items,
            (item) => `${item.sku}_${item.sub_category}`
        );
        return Object.values(grouped)
            .map((group) =>
                max(group, (item) => new Date(item.crawl_date).getTime())
            )
            .filter(Boolean) as TAvailabilityEcommData[];
    };

    const transform = (
        items: TAvailabilityEcommData[]
    ): TBuyboxWinnerAndLosersData[] =>
        items.map((item) => ({
            product: item.sku_title,
            subCategory: item.sub_category,
            seller: item.merchant_name?.[0] || "",
            sellerType: null as string | null,
            sellerRating: null as string | null,
            discountedPrice: `₹${
                item.curr_price?.toLocaleString("en-IN") || "0"
            }`,
            mrp: `₹${item.curr_mrp?.toLocaleString("en-IN") || "0"}`,
        }));

    const winnersRaw = filterLatestBySkuSubCat(
        data.filter((item) => item.buybox_win)
    );
    const losersRaw = filterLatestBySkuSubCat(
        data.filter((item) => !item.buybox_win)
    );

    return {
        winners: transform(winnersRaw),
        losers: transform(losersRaw),
    };
};

export const calculateTopSubcateogiesWithEstimatedSalesLossEcommAvailabilityData =
    (
        data: TAvailabilityEcommData[]
    ): TopSubcategoriesWithEstimatedSalesLossEcommRow[] => {
        const allGroupedBySubCat = groupBy(data, (item) => item.sub_category);

        const skuGroups = groupBy(data, (item) => item.sku);
        const latestSkuRecords = Object.values(skuGroups).map((group) =>
            group.reduce((latest, curr) =>
                new Date(curr.crawl_date) > new Date(latest.crawl_date)
                    ? curr
                    : latest
            )
        );
        const latestGroupedBySubCat = groupBy(
            latestSkuRecords,
            (item) => item.sub_category
        );

        const totalRevenueAcrossAll = data.reduce(
            (sum, item) => sum + (item.curr_drr_revenue ?? 0),
            0
        );

        const result: TopSubcategoriesWithEstimatedSalesLossEcommRow[] =
            Object.keys(allGroupedBySubCat).map((subCategory) => {
                const records = allGroupedBySubCat[subCategory];

                const totalProducts = records.length;
                const availableCount = records.filter(
                    (r) => r.curr_availability === true
                ).length;
                const availabilityPercent =
                    totalProducts === 0
                        ? 0
                        : Math.round((availableCount / totalProducts) * 100);

                const latestGroup = latestGroupedBySubCat[subCategory] || [];
                const oosItems = latestGroup.filter(
                    (item) => item.curr_availability === false
                );
                const oosProducts = oosItems.length;

                const oosRevenue = oosItems.reduce(
                    (sum, item) => sum + (item.curr_drr_revenue ?? 0),
                    0
                );
                const estimatedLossPercent =
                    totalRevenueAcrossAll === 0
                        ? 0
                        : Math.round(
                              (oosRevenue / totalRevenueAcrossAll) * 100
                          );

                return {
                    subCategory,
                    availability: `${availabilityPercent}%`,
                    estimatedSalesLoss: `${estimatedLossPercent}%`,
                    totalProducts,
                    oosProducts,
                };
            });

        return result;
    };

export const calculateTopProductsWithEstimatedLoss = (
    data: TAvailabilityEcommData[]
): TopProductsWithEstimatedSalesLossEcommRow[] => {
    const totalRevenueAcrossAll = data.reduce(
        (sum, item) => sum + (item.curr_drr_revenue ?? 0),
        0
    );

    const groupedBySku = groupBy(data, (item) => item.sku);

    const rows: TopProductsWithEstimatedSalesLossEcommRow[] = Object.values(
        groupedBySku
    ).map((skuGroup) => {
        const sortedByDate = skuGroup.sort(
            (a, b) =>
                new Date(b.crawl_date).getTime() -
                new Date(a.crawl_date).getTime()
        );
        const latest = sortedByDate[0];

        const latestBBwin =
            sortedByDate.find((r) => r.merchant_name?.length)
                ?.merchant_name?.[0] ?? "-";

        const oosRevenue = skuGroup
            .filter((item) => item.curr_availability === false)
            .reduce((sum, item) => sum + (item.curr_drr_revenue ?? 0), 0);

        const estimatedLossPct =
            totalRevenueAcrossAll === 0
                ? 0
                : (oosRevenue / totalRevenueAcrossAll) * 100;

        return {
            title: latest.sku_title,
            subCategory: latest.sub_category,
            latestSr: latest.sales_rank ?? "-",
            availabilityStatus: latest.curr_availability
                ? "Available"
                : "Not Available",
            estimatedSalesLoss: round(estimatedLossPct),
            latestBBwin,
        };
    });

    return rows;
};
export const formatCategoryOverviewSubCategoryPerformanceData = (
    data: ISubCategoryPerformance[] | null | undefined
): IFormattedSubCategoryPerformance[] => {
    if (!data?.length) return [];

    const roundToTwo = (value: number) => Math.round(value * 100) / 100;

    const getValue = <T>(value: T | null | undefined, defaultValue: T): T =>
        typeof value === "number"
            ? (roundToTwo(value) as T)
            : value ?? defaultValue;

    const createMetric = (
        current: number | null | undefined,
        prev: number | null | undefined
    ): MetricWithDelta => {
        const value = getValue(current, 0);
        if (prev == null || value === 0) return valueDeltaDefault;

        const previous = getValue(prev, 0);
        const delta = round((value - previous) / value);

        return { value, delta };
    };

    return data.map((item) => {
        const format = createMetric;
        return {
            [CommonWidgetMetrics.SUB_CATEGORY]: getValue(
                item.tag_subcategory,
                "N/A"
            ),
            [CommonWidgetMetrics.MS]: {
                revenue: format(item.revenue, item.prev_revenue),
                units: format(item.upd, item.prev_upd),
            },
            [CommonWidgetMetrics.MARKET_SIZE]: {
                revenue: format(item.revenue_size, item.prev_revenue_size),
                units: format(item.upd_size, item.prev_upd_size),
            },
            [CommonWidgetMetrics.AD_SALES]: format(item.sale, item.prev_sale),
            [CommonWidgetMetrics.AD_SPENDS]: format(
                item.spend,
                item.prev_spend
            ),
            [CommonWidgetMetrics.ROAS]: format(item.roas, item.prev_roas),
            [CommonWidgetMetrics.ORGANIC_SOV]: format(
                item.org_sov,
                item.prev_org_sov
            ),
            [CommonWidgetMetrics.PAID_SOV]: format(
                item.paid_sov,
                item.prev_paid_sov
            ),
            [CommonWidgetMetrics.SOV]: format(
                item.overall_sov,
                item.prev_overall_sov
            ),
            [CommonWidgetMetrics.RPI]: format(item.rpi, item.prev_rpi),
            [CommonWidgetMetrics.RATING]: format(item.rating, item.prev_rating),
            [CommonWidgetMetrics.REVIEWS]: format(
                item.review_count,
                item.prev_review_count
            ),
            [CommonWidgetMetrics.AVAILABILITY]: format(
                item.availability,
                item.prev_availability
            ),
            [CommonWidgetMetrics.BUYBOX]: format(
                item.buybox_win,
                item.prev_buybox_win
            ),
            [CommonWidgetMetrics.STOCK]: format(
                item.stock_in_hand,
                item.prev_stock_in_hand
            ),
            [CommonWidgetMetrics.COMPARE]: "", // Placeholder
        };
    });
};

export const formatCategoryOverviewDrainersData = (
    data: ICategoryOverviewDrainers[] | null | undefined
): IFormattedDrainerData[] => {
    if (!data || data.length === 0) {
        return [];
    }

    return data.map((item) => {
        return {
            [CommonWidgetMetrics.SUB_CATEGORY]: item.tag_subcategory,

            [CommonWidgetMetrics.MS]: {
                value: round(getSafeValue(item.cur_revenue_ms)),
                delta: round(
                    safeDivide(
                        getSafeValue(item.cur_revenue_ms) -
                            getSafeValue(item.prev_revenue_ms),
                        getSafeValue(item.prev_revenue_ms)
                    ) * 100
                ),
            },

            [CommonWidgetMetrics.TOTAL_SALES]: {
                value: round(getSafeValue(item.cur_total_sales)),
                delta: round(
                    safeDivide(
                        getSafeValue(item.cur_total_sales) -
                            getSafeValue(item.prev_total_sales),
                        getSafeValue(item.prev_total_sales)
                    ) * 100
                ),
            },

            [CommonWidgetMetrics.AD_SALES]: {
                value: round(getSafeValue(item.cur_sale)),
                delta: round(
                    safeDivide(
                        getSafeValue(item.cur_sale) -
                            getSafeValue(item.prev_sale),
                        getSafeValue(item.prev_sale)
                    ) * 100
                ),
            },

            [CommonWidgetMetrics.AD_SPENDS]: {
                value: round(getSafeValue(item.cur_spend)),
                delta: round(
                    safeDivide(
                        getSafeValue(item.cur_spend) -
                            getSafeValue(item.prev_spend),
                        getSafeValue(item.prev_spend)
                    ) * 100
                ),
            },

            [CommonWidgetMetrics.ROAS]: {
                value: round(getSafeValue(item.cur_roas)),
                delta: round(
                    safeDivide(
                        getSafeValue(item.cur_roas) -
                            getSafeValue(item.prev_roas),
                        getSafeValue(item.prev_roas)
                    ) * 100
                ),
            },

            [CommonWidgetMetrics.CTR]: {
                value: round(getSafeValue(item.cur_ctr)),
                delta: round(
                    safeDivide(
                        getSafeValue(item.cur_ctr) -
                            getSafeValue(item.prev_ctr),
                        getSafeValue(item.prev_ctr)
                    ) * 100
                ),
            },

            [CommonWidgetMetrics.CTC]: {
                value: round(getSafeValue(item.cur_cpc)),
                delta: round(
                    safeDivide(
                        getSafeValue(item.cur_cpc) -
                            getSafeValue(item.prev_cpc),
                        getSafeValue(item.prev_cpc)
                    ) * 100
                ),
            },

            [CommonWidgetMetrics.CLICKS]: {
                value: getSafeValue(item.cur_click),
                delta: round(
                    safeDivide(
                        getSafeValue(item.cur_click) -
                            getSafeValue(item.prev_click),
                        getSafeValue(item.prev_click)
                    ) * 100
                ),
            },

            [CommonWidgetMetrics.ORDERS]: {
                value: getSafeValue(item.cur_orders),
                delta: round(
                    safeDivide(
                        getSafeValue(item.cur_orders) -
                            getSafeValue(item.prev_orders),
                        getSafeValue(item.prev_orders)
                    ) * 100
                ),
            },

            [CommonWidgetMetrics.IMPRESSIONS]: {
                value: getSafeValue(item.cur_impression),
                delta: round(
                    safeDivide(
                        getSafeValue(item.cur_impression) -
                            getSafeValue(item.prev_impression),
                        getSafeValue(item.prev_impression)
                    ) * 100
                ),
            },
        };
    });
};

export const formatCategoryOverviewCrossChannelAndCompetitionGraph = (
    data:
        | ICategoryOverviewCrossChannelGraphData[]
        | ICategoryOverviewCompetitionGraphData[]
        | null
        | undefined,
    type: MyProductTrendsModules
): ICategoryOverviewCrossChannelCompetitionComparisonGraphItem[] => {
    if (!Array.isArray(data)) return [];

    const result: ICategoryOverviewCrossChannelCompetitionComparisonGraphItem[] =
        [];

    const groupedByDate: Record<
        string,
        (
            | ICategoryOverviewCrossChannelGraphData
            | ICategoryOverviewCompetitionGraphData
        )[]
    > = {};

    // Group by crawl_date
    for (const item of data) {
        const { crawl_date } = item;
        if (!groupedByDate[crawl_date]) {
            groupedByDate[crawl_date] = [];
        }
        groupedByDate[crawl_date].push(item);
    }

    // Format individual items
    for (const item of data) {
        const {
            tag_subcategory = "",
            crawl_date = "",
            roas = 0,
            sale = 0,
            spend = 0,
            total_sales = 0,
            revenue = 0,
            cat_revenue = AggregationField.CAT_REVENUE in item
                ? item.cat_revenue
                : 0,
        } = item;

        const ms_percent =
            cat_revenue === 0
                ? 0
                : (round(revenue, 2) / round(cat_revenue, 2)) * 100;

        const formattedItem: ICategoryOverviewCrossChannelCompetitionComparisonGraphItem =
            {
                [CommonWidgetMetrics.TAG_SUBCATEGORY]: tag_subcategory,
                [CommonWidgetMetrics.CRAWL_DATE]: crawl_date,
                [AggregationField.MS_PERCENT]: round(ms_percent, 2),
                [AggregationField.ROAS]: round(roas, 2),
                [AggregationField.SALE]: round(sale, 2),
                [AggregationField.SPEND]: round(spend, 2),
                [AggregationField.TOTAL_SALES]: round(total_sales, 2),
            };

        if (type === MyProductTrendsModules.CROSS_CHANNEL) {
            formattedItem[CommonWidgetMetrics.NAME] =
                CommonWidgetMetrics.NAME in item ? item.name : "";
        } else if (type === MyProductTrendsModules.COMPETITION) {
            formattedItem[CommonWidgetMetrics.BRAND] =
                CommonWidgetMetrics.BRAND in item ? item.brand : "";
        }

        result.push(formattedItem);
    }

    // Add "all" rows per crawl_date
    for (const [crawl_date, items] of Object.entries(groupedByDate)) {
        const groupedByKey: Record<string, typeof items> = {};

        for (const item of items) {
            const key =
                type === MyProductTrendsModules.CROSS_CHANNEL
                    ? CommonWidgetMetrics.NAME in item
                        ? item.name
                        : ""
                    : CommonWidgetMetrics.BRAND in item
                    ? item.brand
                    : "";

            if (!groupedByKey[key]) {
                groupedByKey[key] = [];
            }

            groupedByKey[key].push(item);
        }

        for (const [key, groupedItems] of Object.entries(groupedByKey)) {
            let totalRevenue = 0;
            let totalCatRevenue = 0;
            let totalRoas = 0;
            let totalSale = 0;
            let totalSpend = 0;
            let totalSales = 0;

            for (const item of groupedItems) {
                totalRevenue += item.revenue;
                totalCatRevenue += item.cat_revenue;
                totalRoas += item.roas;
                totalSale += item.sale;
                totalSpend += item.spend;
                totalSales += item.total_sales;
            }

            const ms_percent = round(
                safeDivide(totalRevenue, totalCatRevenue) * 100,
                2
            );

            const aggregatedItem: ICategoryOverviewCrossChannelCompetitionComparisonGraphItem =
                {
                    [CommonWidgetMetrics.TAG_SUBCATEGORY]:
                        CommonWidgetMetrics.All,
                    [CommonWidgetMetrics.CRAWL_DATE]: crawl_date,
                    [AggregationField.MS_PERCENT]: round(ms_percent, 2),
                    [AggregationField.ROAS]: round(totalRoas, 2),
                    [AggregationField.SALE]: round(totalSale, 2),
                    [AggregationField.SPEND]: round(totalSpend, 2),
                    [AggregationField.TOTAL_SALES]: round(totalSales, 2),
                };

            if (type === MyProductTrendsModules.CROSS_CHANNEL) {
                aggregatedItem[CommonWidgetMetrics.NAME] = key;
            } else if (type === MyProductTrendsModules.COMPETITION) {
                aggregatedItem[CommonWidgetMetrics.BRAND] = key;
            }

            result.push(aggregatedItem);
        }
    }

    //  Sort the final result by crawl_date ascending
    result.sort((a, b) => {
        const dateA = new Date(a[CommonWidgetMetrics.CRAWL_DATE]).getTime();
        const dateB = new Date(b[CommonWidgetMetrics.CRAWL_DATE]).getTime();
        return dateA - dateB;
    });

    return result;
};

export const formatCategoryOverviewComparisonGraph = (
    data: ICategoryOverviewComparisonGraphData[] | null | undefined,
    date: TDate
): ICategoryOverviewCrossChannelCompetitionComparisonGraphItem[] => {
    if (!Array.isArray(data)) return [];

    const { startDate, endDate } = date;

    const start = startDate.toDate();
    const end = endDate.toDate();

    const filteredData = filter(data, ({ crawl_date }) => {
        const crawlDate = new Date(crawl_date);
        return crawlDate >= start && crawlDate <= end;
    });

    // Group by crawl_date
    const groupedByDate: Record<
        string,
        ICategoryOverviewComparisonGraphData[]
    > = {};

    for (const item of filteredData) {
        const { crawl_date } = item;
        if (!groupedByDate[crawl_date]) {
            groupedByDate[crawl_date] = [];
        }
        groupedByDate[crawl_date].push(item);
    }

    // Create "all" rows
    const allRows: ICategoryOverviewComparisonGraphData[] = [];

    for (const [crawl_date, items] of Object.entries(groupedByDate)) {
        let revenue_ms = 0;
        let roas = 0;
        let sale = 0;
        let spend = 0;
        let total_sales = 0;

        for (const item of items) {
            revenue_ms += item.revenue_ms || 0;
            roas += item.roas || 0;
            sale += item.sale || 0;
            spend += item.spend || 0;
            total_sales += item.total_sales || 0;
        }

        allRows.push({
            tag_subcategory: CommonWidgetMetrics.All,
            crawl_date,
            revenue_ms: round(revenue_ms, 2),
            roas: round(roas, 2),
            sale: round(sale, 2),
            spend: round(spend, 2),
            total_sales: round(total_sales, 2),
            upd_ms: 0,
        });
    }

    //Combine and sort
    const combinedData = [...filteredData, ...allRows].sort((a, b) => {
        return (
            new Date(a.crawl_date).getTime() - new Date(b.crawl_date).getTime()
        );
    });

    // Map to formatted output
    return combinedData.map((item) => {
        const {
            tag_subcategory = "",
            crawl_date = "",
            revenue_ms = 0,
            roas = 0,
            sale = 0,
            spend = 0,
            total_sales = 0,
        } = item;

        return {
            [CommonWidgetMetrics.TAG_SUBCATEGORY]: tag_subcategory,
            [CommonWidgetMetrics.CRAWL_DATE]: crawl_date,
            [AggregationField.MS_PERCENT]: round(revenue_ms, 2),
            [AggregationField.ROAS]: round(roas, 2),
            [AggregationField.SALE]: round(sale, 2),
            [AggregationField.SPEND]: round(spend, 2),
            [AggregationField.TOTAL_SALES]: round(total_sales, 2),
        };
    });
};

export const formatCategoryOverviewComparisonChartData = (
    data: ICategoryOverviewComparisonGraphFormattedData[],
    requiredCharts: AggregationField[] = [
        AggregationField.MS_PERCENT,
        AggregationField.ROAS,
        AggregationField.SALE,
        AggregationField.SPEND,
        AggregationField.TOTAL_SALES,
    ]
): TCategoryOverviewComparisonGraphFormattedDataForXAxisOpposite => {
    const skuTitles = {
        [AggregationField.MS_PERCENT]: "Ms%",
        [AggregationField.ROAS]: "ROAS",
        [AggregationField.SALE]: "Sale",
        [AggregationField.SPEND]: "Ad Spend",
        [AggregationField.TOTAL_SALES]: "Total Sales",
        [AggregationField.AVAILABILITY]: "Availability",
        [AggregationField.BUYBOX]: "Buybox",
    };

    const emptyChartData = {
        categories: [""],
        series: requiredCharts.map((field) => ({
            name: field,
            data: [0],
        })),
    };

    if (!Array.isArray(data) || data.length === 0) {
        return requiredCharts.reduce((acc: any, field) => {
            acc[field] = {
                chartDataSeries: emptyChartData,
                skuTitles,
            };
            return acc;
        }, {} as TCategoryOverviewComparisonGraphFormattedDataForXAxisOpposite);
    }

    const sortedData = [...data].sort((a, b) =>
        moment(a.crawl_date).diff(moment(b.crawl_date))
    );

    const categories = sortedData.map((item) => item.crawl_date);

    const series = requiredCharts.map((field) => ({
        name: field,
        data: sortedData.map((item: any) => item[field] ?? 0),
    }));

    const chartDataSeries = {
        categories,
        series,
    };

    return requiredCharts.reduce((acc: any, field) => {
        acc[field] = {
            chartDataSeries,
            skuTitles,
        };
        return acc;
    }, {} as TCategoryOverviewComparisonGraphFormattedDataForXAxisOpposite);
};

export const formatBestSellerSKUTableData = (
    data: IBestSellerSKUData[]
): ICategoryOverviewBestSellerSKUTableRow[] => {
    if (!Array.isArray(data) || data.length === 0) {
        return [];
    }

    // Step 1: Sort by unit_per_day in descending order
    const sorted = [...data].sort((a, b) => {
        const unitA = a.unit_per_day ?? -Infinity;
        const unitB = b.unit_per_day ?? -Infinity;
        return unitB - unitA;
    });

    // Step 2: Assign rank only to items with valid unit_per_day
    let currentRank = 1;

    return sorted.map((item) => {
        const hasUnit = item.unit_per_day != null;
        const row = {
            sku: item.sku,
            title: item.sku_title,
            rank: hasUnit ? currentRank : "-",
            price: item.price != null ? round(item.price, 2) : "-",
        };
        if (hasUnit) currentRank++;
        return row;
    });
};
const calculateMaxSalesLossByGroup = (data: any[], groupKey: string) => {
    if (!Array.isArray(data) || data.length === 0) {
        return [];
    }

    const groupedData = groupBy(data, (item) => get(item, groupKey, "Unknown"));

    return Object.entries(groupedData).map(([group, items], index) => {
        const totalRevenue = reduce(
            items,
            (sum, item) =>
                sum + (get(item, AggregationField.CURR_DRR_REVENUE, 0) || 0),
            0
        );

        const lostRevenue = reduce(
            filter(
                items,
                (item) =>
                    get(item, AggregationField.CURR_AVAILABILITY, true) ===
                    false
            ),
            (sum, item) =>
                sum + (get(item, AggregationField.CURR_DRR_REVENUE, 0) || 0),
            0
        );

        const totalItems = items.length;
        const availableItems = filter(
            items,
            (item) =>
                get(item, AggregationField.CURR_AVAILABILITY, false) === true
        ).length;

        const availability =
            totalItems > 0 ? (availableItems / totalItems) * 100 : 0;
        const salesLoss = totalRevenue > 0 ? lostRevenue : 0;

        return {
            name: group || "Unknown",
            availability: Math.round(availability),
            salesLoss: Math.round(salesLoss),
            color: COLORS[index % COLORS.length] || "#000000", // Default to black if COLORS is undefined
        };
    });
};

export const calculateAvailabilityIssues = (
    currentData: any[],
    previousData: any[],
    groupKey: string
) => {
    if (!Array.isArray(currentData) || !Array.isArray(previousData)) {
        return { mainSeries: [], drilldownSeries: [] };
    }

    const groupedCurrentData = groupBy(currentData, (item) =>
        get(item, groupKey, "Unknown")
    );
    const groupedPreviousData = groupBy(previousData, (item) =>
        get(item, groupKey, "Unknown")
    );

    const availabilityGroups: {
        below50: { name: string; availability: number; delta: number }[];
        fiftyToEighty: { name: string; availability: number; delta: number }[];
        above80: { name: string; availability: number; delta: number }[];
    } = {
        below50: [],
        fiftyToEighty: [],
        above80: [],
    };

    Object.entries(groupedCurrentData).forEach(([group, currentItems]) => {
        const totalCurrDrrUpd = reduce(
            currentItems,
            (sum, item) =>
                sum + (get(item, AggregationField.CURR_DRR_UPD, 0) || 0),
            0
        );

        const weightedAvailability = reduce(
            filter(
                currentItems,
                (item) =>
                    get(item, AggregationField.CURR_AVAILABILITY, false) ===
                    true
            ),
            (sum, item) =>
                sum + (get(item, AggregationField.CURR_DRR_UPD, 0) || 0),
            0
        );

        const wtAvailability =
            totalCurrDrrUpd > 0
                ? (weightedAvailability / totalCurrDrrUpd) * 100
                : 0;

        const previousItems = groupedPreviousData[group] || [];
        const totalPrevDrrUpd = reduce(
            previousItems,
            (sum, item) =>
                sum + (get(item, AggregationField.CURR_DRR_UPD, 0) || 0),
            0
        );

        const prevWeightedAvailability = reduce(
            filter(
                previousItems,
                (item) =>
                    get(item, AggregationField.CURR_AVAILABILITY, false) ===
                    true
            ),
            (sum, item) =>
                sum + (get(item, AggregationField.CURR_DRR_UPD, 0) || 0),
            0
        );

        const prevWtAvailability =
            totalPrevDrrUpd > 0
                ? (prevWeightedAvailability / totalPrevDrrUpd) * 100
                : 0;

        const delta = Math.round(wtAvailability - prevWtAvailability);

        const groupData = {
            name: group,
            availability: Math.round(wtAvailability),
            delta,
        };

        if (wtAvailability < 50) {
            availabilityGroups.below50.push(groupData);
        } else if (wtAvailability >= 50 && wtAvailability <= 80) {
            availabilityGroups.fiftyToEighty.push(groupData);
        } else {
            availabilityGroups.above80.push(groupData);
        }
    });

    const mainSeries =
        availabilityGroups.below50.length > 0 ||
        availabilityGroups.fiftyToEighty.length > 0 ||
        availabilityGroups.above80.length > 0
            ? [
                  {
                      name: "Below 50%",
                      y: availabilityGroups.below50.length,
                      drilldown: "below50",
                      color: "#1E90FF",
                  },
                  {
                      name: "50-80%",
                      y: availabilityGroups.fiftyToEighty.length,
                      drilldown: "fiftyToEighty",
                      color: "#5A4FCF",
                  },
                  {
                      name: "Above 80%",
                      y: availabilityGroups.above80.length,
                      drilldown: "above80",
                      color: "#00E676",
                  },
              ]
            : [];

    const drilldownSeries = [
        {
            id: "below50",
            name: "Actual",
            type: "column",
            data: availabilityGroups.below50.map((item) => [
                item.name,
                item.availability,
            ]),
            color: "#1E90FF",
        },
        {
            id: "below50_delta",
            name: "Delta",
            type: "column",
            data: availabilityGroups.below50.map((item) => [
                item.name,
                item.delta,
            ]),
            color: "green",
        },
        {
            id: "fiftyToEighty",
            name: "Actual",
            type: "column",
            data: availabilityGroups.fiftyToEighty.map((item) => [
                item.name,
                item.availability,
            ]),
            color: "#5A4FCF",
        },
        {
            id: "fiftyToEighty_delta",
            name: "Delta",
            type: "column",
            data: availabilityGroups.fiftyToEighty.map((item) => [
                item.name,
                item.delta,
            ]),
            color: "green",
        },
        {
            id: "above80",
            name: "Actual",
            type: "column",
            data: availabilityGroups.above80.map((item) => [
                item.name,
                item.availability,
            ]),
            color: "#00E676",
        },
        {
            id: "above80_delta",
            name: "Delta",
            type: "column",
            data: availabilityGroups.above80.map((item) => [
                item.name,
                item.delta,
            ]),
            color: "green",
        },
    ];

    return {
        mainSeries,
        drilldownSeries,
    };
};
function calculateAvailabilityIssuesByCity(
    currentData: any[]
): TAvailabilityIssuesByCityDataResult {
    const emptyDataValues: {
        categories: string[];
        data: TAvailabilityIssuesByCityData[];
    } = { categories: [], data: [] };

    if (!Array.isArray(currentData) || currentData.length === 0) {
        return {
            below50: emptyDataValues,
            fiftyToEighty: emptyDataValues,
            above80: emptyDataValues,
        };
    }

    const groupedByCity = groupBy(currentData, AggregationField.CITY);

    const result: TAvailabilityIssuesByCityDataResult = {
        below50: emptyDataValues,
        fiftyToEighty: emptyDataValues,
        above80: emptyDataValues,
    };

    Object.entries(groupedByCity).forEach(([city, cityItems]) => {
        const groupedBySubCategory = groupBy(
            cityItems,
            CommonWidgetMetrics.SUB_CATEGORY
        );

        const cityData = {
            below50: [] as TSubCategoryAvailabilityData[],
            fiftyToEighty: [] as TSubCategoryAvailabilityData[],
            above80: [] as TSubCategoryAvailabilityData[],
        };

        Object.entries(groupedBySubCategory).forEach(([subCategory, items]) => {
            const totalCurrDrrUpd = reduce(
                items,
                (sum, item) => sum + (item.curr_drr_upd || 0),
                0
            );

            const weightedAvailability = reduce(
                items,
                (sum, item) =>
                    sum + (item.curr_availability ? item.curr_drr_upd || 0 : 0),
                0
            );

            const wtAvailability =
                totalCurrDrrUpd > 0
                    ? (weightedAvailability / totalCurrDrrUpd) * 100
                    : 0;

            if (wtAvailability < 50) {
                cityData.below50.push({ subCategory, value: wtAvailability });
            } else if (wtAvailability <= 80) {
                cityData.fiftyToEighty.push({
                    subCategory,
                    value: wtAvailability,
                });
            } else {
                cityData.above80.push({ subCategory, value: wtAvailability });
            }

            [
                AvailabilityDrilldownTypes.BELOW50,
                AvailabilityDrilldownTypes.FIFTY_TO_EIGHTY,
                AvailabilityDrilldownTypes.ABOVE80,
            ].forEach((key) => {
                if (
                    cityData[key as keyof typeof cityData].some(
                        (data) => data.subCategory === subCategory
                    )
                ) {
                    const catList =
                        result[key as keyof TAvailabilityIssuesByCityDataResult]
                            .categories;
                    if (!catList.includes(subCategory)) {
                        catList.push(subCategory);
                    }
                }
            });
        });

        [
            AvailabilityDrilldownTypes.BELOW50,
            AvailabilityDrilldownTypes.FIFTY_TO_EIGHTY,
            AvailabilityDrilldownTypes.ABOVE80,
        ].forEach((key) => {
            const categoryList =
                result[key as keyof TAvailabilityIssuesByCityDataResult]
                    .categories;
            const cityValues = categoryList.map((category) => {
                const subCategoryData = cityData[
                    key as keyof typeof cityData
                ].find((data) => data.subCategory === category);
                return subCategoryData ? subCategoryData.value : 0;
            });

            result[key as keyof TAvailabilityIssuesByCityDataResult].data.push({
                city,
                data: cityValues,
                color: COLORS[Math.floor(Math.random() * COLORS.length)],
            });
        });
    });

    return result;
}
const calculateCitywiseAvailabilityAndSalesLossWidgetData = (data: any[]) => {
    if (!Array.isArray(data) || data.length === 0) {
        return {};
    }

    const groupedBySubCategory = groupBy(data, (item) =>
        get(item, CommonWidgetMetrics.SUB_CATEGORY, "Unknown")
    );

    const citywiseDataBySubCategory = Object.entries(
        groupedBySubCategory
    ).reduce((result: Record<string, any[]>, [subCategory, items]) => {
        // Calculate totalCurrDrrUpd and totalSalesLoss for the entire subcategory
        const totalCurrDrrUpd = reduce(
            items,
            (sum, item) =>
                sum + (get(item, AggregationField.CURR_DRR_UPD, 0) || 0),
            0
        );

        const totalSalesLoss = reduce(
            items,
            (sum, item) =>
                sum + (get(item, AggregationField.CURR_DRR_REVENUE, 0) || 0),
            0
        );

        const groupedByCity = groupBy(items, (item) =>
            get(item, AggregationField.CITY, "Unknown")
        );

        // Calculate metrics for each city
        const cityData = Object.entries(groupedByCity).map(
            ([city, cityItems]) => {
                const weightedAvailability = reduce(
                    filter(
                        cityItems,
                        (item) =>
                            get(
                                item,
                                AggregationField.CURR_AVAILABILITY,
                                false
                            ) === true
                    ),
                    (sum, item) =>
                        sum +
                        (get(item, AggregationField.CURR_DRR_UPD, 0) || 0),
                    0
                );

                const wtAvailability =
                    totalCurrDrrUpd > 0
                        ? (weightedAvailability / totalCurrDrrUpd) * 100
                        : 0;

                const citySalesLoss = reduce(
                    cityItems,
                    (sum, item) =>
                        sum +
                        (get(item, AggregationField.CURR_DRR_REVENUE, 0) || 0),
                    0
                );

                const estimatedSalesLossPercentage =
                    totalSalesLoss > 0
                        ? (citySalesLoss / totalSalesLoss) * 100
                        : 0;

                const assortment = uniq(
                    cityItems,
                    CommonWidgetMetrics.SKU
                ).length;

                return {
                    city,
                    wtAvailability: Math.round(wtAvailability),
                    estimatedSalesLossPercentage: Math.round(
                        estimatedSalesLossPercentage
                    ),
                    assortment,
                };
            }
        );

        result[subCategory] = cityData;
        return result;
    }, {});

    return citywiseDataBySubCategory;
};
const calculateProductsAvailabilityByPincode = (data: any[]) => {
    if (!Array.isArray(data) || data.length === 0) {
        return {};
    }

    // Group data by subcategory
    const groupedBySubCategory = groupBy(data, (item) =>
        get(item, CommonWidgetMetrics.SUB_CATEGORY, "Unknown")
    );

    // Iterate over each subcategory and calculate metrics for each pincode
    const availabilityByPincode = Object.entries(groupedBySubCategory).reduce(
        (result: Record<string, any[]>, [subCategory, items]) => {
            // Calculate totalCurrDrrUpd for the entire subcategory
            const totalCurrDrrUpd = reduce(
                items,
                (sum, item) =>
                    sum + (get(item, AggregationField.CURR_DRR_UPD, 0) || 0),
                0
            );

            // Group data by pincode within the subcategory
            const groupedByPincode = groupBy(items, (item) =>
                get(item, AggregationField.PINCODE, "Unknown")
            );

            // Calculate metrics for each pincode
            const pincodeData = Object.entries(groupedByPincode).map(
                ([pincode, pincodeItems]) => {
                    const weightedAvailability = reduce(
                        filter(
                            pincodeItems,
                            (item) =>
                                get(
                                    item,
                                    AggregationField.CURR_AVAILABILITY,
                                    false
                                ) === true
                        ),
                        (sum, item) =>
                            sum +
                            (get(item, AggregationField.CURR_DRR_UPD, 0) || 0),
                        0
                    );

                    const wtAvailability =
                        totalCurrDrrUpd > 0
                            ? (weightedAvailability / totalCurrDrrUpd) * 100
                            : 0;

                    const asp =
                        reduce(
                            pincodeItems,
                            (sum, item) =>
                                sum +
                                (get(item, AggregationField.CUR_PRICE, 0) || 0),
                            0
                        ) / pincodeItems.length;

                    return {
                        product: get(
                            pincodeItems[0],
                            CommonWidgetMetrics.SKU,
                            "Unknown"
                        ), // Use SKU for product
                        region: get(
                            pincodeItems[0],
                            GroupingKey.REGION,
                            "Unknown"
                        ),
                        pincode,
                        listingStatus: "N/A", // Placeholder for now
                        availability: `${wtAvailability.toFixed(1)}%`,
                        stockInHand: "N/A", // Placeholder for now
                        asp: `₹ ${asp.toFixed(1)}`,
                    };
                }
            );

            // Add the pincode data for the current subcategory to the result
            result[subCategory] = pincodeData;
            return result;
        },
        {}
    );

    return availabilityByPincode;
};
function calculateProductsAvailabilityByRegion(currentData: any[]) {
    if (!Array.isArray(currentData) || currentData.length === 0) {
        return [];
    }

    function formatAvailability(value: number): string {
        const formattedValue = `${value.toFixed(1)}%`;
        return value < 50 ? `${formattedValue} ⚠️` : formattedValue;
    }

    // Define the explicit regions
    const explicitRegions = [
        "bengaluru",
        "delhi",
        "hyderabad",
        "kolkata",
        "mumbai",
    ];

    // Group data by SKU (product)
    const groupedByProduct = groupBy(currentData, (item) =>
        get(item, GroupingKey.SKU, "Unknown")
    );

    // Iterate over each product and calculate metrics for each region
    const availabilityByRegion = Object.entries(groupedByProduct).map(
        ([product, items]) => {
            const totalCurrDrrUpd = reduce(
                items,
                (sum, item) =>
                    sum + (get(item, AggregationField.CURR_DRR_UPD, 0) || 0),
                0
            );

            // Initialize region-wise availability
            const regionAvailability: Record<string, number> = {
                bengaluru: 0,
                delhi: 0,
                hyderabad: 0,
                kolkata: 0,
                mumbai: 0,
                restOfIndia: 0,
            };

            // Group data by region
            const groupedByRegion = groupBy(items, (item) => {
                const region = get(item, GroupingKey.REGION, "Unknown");
                return explicitRegions.includes(region)
                    ? region
                    : "Rest of India";
            });

            // Calculate availability for each region
            Object.entries(groupedByRegion).forEach(([region, regionItems]) => {
                const weightedAvailability = reduce(
                    filter(
                        regionItems,
                        (item) =>
                            get(
                                item,
                                AggregationField.CURR_AVAILABILITY,
                                false
                            ) === true
                    ),
                    (sum, item) =>
                        sum +
                        (get(item, AggregationField.CURR_DRR_UPD, 0) || 0),
                    0
                );

                const wtAvailability =
                    totalCurrDrrUpd > 0
                        ? (weightedAvailability / totalCurrDrrUpd) * 100
                        : 0;

                const regionKey = region.toLowerCase().replace(/ /g, ""); // Normalize region key
                regionAvailability[regionKey] = wtAvailability;
            });

            // Calculate total availability
            const totalAvailability =
                reduce(
                    Object.values(regionAvailability),
                    (sum, value) => sum + value,
                    0
                ) / explicitRegions.length;

            // Format the data for the row
            return {
                product,
                bengaluru: formatAvailability(regionAvailability.bengaluru),
                delhi: formatAvailability(regionAvailability.delhi),
                hyderabad: formatAvailability(regionAvailability.hyderabad),
                kolkata: formatAvailability(regionAvailability.kolkata),
                mumbai: formatAvailability(regionAvailability.mumbai),
                restOfIndia: formatAvailability(regionAvailability.restOfIndia),
                total: formatAvailability(totalAvailability),
            };
        }
    );

    return availabilityByRegion;
}
function prepareOosProductsDrawerData(currentData: any[]) {
    if (!Array.isArray(currentData) || currentData.length === 0) {
        return [];
    }

    // Group data by SKU (product)
    const groupedByProduct = groupBy(currentData, (item) =>
        get(item, CommonWidgetMetrics.SKU, "Unknown")
    );

    // Calculate total `curr_upd` for each SKU and sort in descending order
    const sortedSKUs = Object.entries(groupedByProduct)
        .map(([sku, items]) => ({
            sku,
            totalUpd: reduce(
                items,
                (sum, item) =>
                    sum + (get(item, AggregationField.CURR_UPD, 0) || 0),
                0
            ),
        }))
        .sort((a, b) => b.totalUpd - a.totalUpd);

    // Assign `latestSR` based on the sorted order
    const skuRankMap = sortedSKUs.reduce((acc, { sku }, index) => {
        acc[sku] = index + 1; // Rank starts from 1
        return acc;
    }, {} as Record<string, number>);

    // Prepare row data
    const rowData = Object.entries(groupedByProduct).map(([product, items]) => {
        const subCategory = get(
            items[0],
            CommonWidgetMetrics.SUB_CATEGORY,
            "Unknown"
        );

        // Calculate totalCurrDrrUpd for the product in its subcategory
        const totalCurrDrrUpd = reduce(
            items,
            (sum, item) =>
                sum + (get(item, AggregationField.CURR_DRR_UPD, 0) || 0),
            0
        );

        // Calculate weighted availability (wtAvailability)
        const weightedAvailability = reduce(
            filter(
                items,
                (item) =>
                    get(item, AggregationField.CURR_AVAILABILITY, false) ===
                    true
            ),
            (sum, item) =>
                sum + (get(item, AggregationField.CURR_DRR_UPD, 0) || 0),
            0
        );

        const wtAvailability =
            totalCurrDrrUpd > 0
                ? (weightedAvailability / totalCurrDrrUpd) * 100
                : 0;

        // Calculate estimated sales loss
        const totalRevenue = reduce(
            items,
            (sum, item) =>
                sum + (get(item, AggregationField.CURR_DRR_REVENUE, 0) || 0),
            0
        );

        const lostRevenue = reduce(
            filter(
                items,
                (item) =>
                    get(item, AggregationField.CURR_AVAILABILITY, false) ===
                    false
            ),
            (sum, item) =>
                sum + (get(item, AggregationField.CURR_DRR_UPD, 0) || 0),
            0
        );

        const estimatedSalesLoss = totalRevenue > 0 ? lostRevenue : 0;

        // Calculate unavailable on dark stores
        const unavailableOnDarkStores = filter(
            items,
            (item) =>
                get(item, AggregationField.CURR_AVAILABILITY, false) ===
                    false &&
                get(item, AggregationField.STORE_TYPE, "") === "dark"
        ).length;

        // Get the `latestSR` for the current SKU
        const latestSR = skuRankMap[product] || 0;

        return {
            productTitle: product,
            subCategory,
            availability: `${wtAvailability.toFixed(1)}%`,
            listingStatus: "", // Placeholder for now
            estimatedSalesLoss: `₹ ${estimatedSalesLoss.toFixed(2)}`,
            unavailableOnDarkStores,
            latestSR, // Add the latestSR value
        };
    });

    return rowData;
}
function prepareOosDarkStoresData(currentData: any[]) {
    if (!Array.isArray(currentData) || currentData.length === 0) {
        return [];
    }

    // Group data by dark store (store_id or store_name)
    const groupedByDarkStore = groupBy(currentData, (item) =>
        get(item, AggregationField.STORE_ID, "Unknown")
    );

    // Prepare row data
    const rowData = Object.entries(groupedByDarkStore).map(
        ([darkStore, items]) => {
            const region = get(items[0], GroupingKey.REGION, "Unknown");

            // Calculate total number of products in the dark store
            const totalProducts = unique(items, GroupingKey.SKU).length;

            // Calculate number of products with availability < 30%
            const lowAvailabilityProducts = items.filter((item) => {
                const totalCurrDrrUpd = reduce(
                    items,
                    (sum, item) =>
                        sum +
                        (get(item, AggregationField.CURR_DRR_UPD, 0) || 0),
                    0
                );

                const weightedAvailability = reduce(
                    filter(
                        items,
                        (item) =>
                            get(
                                item,
                                AggregationField.CURR_AVAILABILITY,
                                false
                            ) === true
                    ),
                    (sum, item) =>
                        sum +
                        (get(item, AggregationField.CURR_DRR_UPD, 0) || 0),
                    0
                );

                const wtAvailability =
                    totalCurrDrrUpd > 0
                        ? (weightedAvailability / totalCurrDrrUpd) * 100
                        : 0;

                return wtAvailability < 30;
            }).length;

            // Calculate estimated sales loss for the dark store
            const estimatedSalesLoss = reduce(
                items,
                (sum, item) =>
                    sum +
                    (get(item, AggregationField.CURR_DRR_REVENUE, 0) || 0),
                0
            );

            return {
                darkStore,
                region,
                totalProducts,
                lowAvailabilityProducts,
                estimatedSalesLoss: `₹ ${estimatedSalesLoss.toFixed(2)}`,
            };
        }
    );

    return rowData;
}
function prepareTopSubcategoriesEstimatedSalesLossData(currentData: any[]) {
    if (!Array.isArray(currentData) || currentData.length === 0) {
        return [];
    }

    // Group data by subcategory
    const groupedBySubCategory = groupBy(currentData, (item) =>
        get(item, CommonWidgetMetrics.SUB_CATEGORY, "Unknown")
    );

    // Prepare row data
    const rowData = Object.entries(groupedBySubCategory).map(
        ([subCategory, items]) => {
            // Calculate totalCurrDrrUpd for the subcategory
            const totalCurrDrrUpd = reduce(
                items,
                (sum, item) =>
                    sum + (get(item, AggregationField.CURR_DRR_UPD, 0) || 0),
                0
            );

            // Calculate weighted availability (wtAvailability)
            const weightedAvailability = reduce(
                filter(
                    items,
                    (item) =>
                        get(item, AggregationField.CURR_AVAILABILITY, false) ===
                        true
                ),
                (sum, item) =>
                    sum + (get(item, AggregationField.CURR_DRR_UPD, 0) || 0),
                0
            );

            const wtAvailability =
                totalCurrDrrUpd > 0
                    ? (weightedAvailability / totalCurrDrrUpd) * 100
                    : 0;

            // Calculate estimated sales loss
            const totalRevenue = reduce(
                items,
                (sum, item) =>
                    sum +
                    (get(item, AggregationField.CURR_DRR_REVENUE, 0) || 0),
                0
            );

            const lostRevenue = reduce(
                filter(
                    items,
                    (item) =>
                        get(item, AggregationField.CURR_AVAILABILITY, false) ===
                        false
                ),
                (sum, item) =>
                    sum +
                    (get(item, AggregationField.CURR_DRR_REVENUE, 0) || 0),
                0
            );

            const estimatedSalesLoss = totalRevenue > 0 ? lostRevenue : 0;

            // Calculate total products
            const totalProducts = unique(items, GroupingKey.SKU).length;

            // Calculate OOS products
            const oosProducts = filter(
                items,
                (item) =>
                    get(item, AggregationField.CURR_AVAILABILITY, false) ===
                    false
            ).length;

            // Calculate products with availability < 30%
            const lowAvailabilityProducts = items.filter((item) => {
                const itemCurrDrrUpd =
                    get(item, AggregationField.CURR_DRR_UPD, 0) || 0;
                const itemWtAvailability =
                    totalCurrDrrUpd > 0
                        ? (itemCurrDrrUpd / totalCurrDrrUpd) * 100
                        : 0;
                return itemWtAvailability < 30;
            }).length;

            return {
                subCategory,
                availability: `${wtAvailability.toFixed(1)}%`,
                listingStatus: "", // Placeholder for now
                estimatedSalesLoss: `₹ ${estimatedSalesLoss.toFixed(2)}`,
                totalProducts,
                oosProducts,
                lowAvailabilityProducts,
            };
        }
    );

    return rowData;
}
function preparePincodeLevelData(currentData: any[]) {
    if (!Array.isArray(currentData) || currentData.length === 0) {
        return {
            productsPincodeLevelAvailability: [],
            pincodeLevelInsights: [],
        };
    }

    // Group data by SKU (product) for Products Pincode Level Availability
    const groupedByProduct = groupBy(currentData, (item) =>
        get(item, GroupingKey.SKU, "Unknown")
    );

    // Group data by Pincode for Pincode Level Insights
    const groupedByPincode = groupBy(currentData, (item) =>
        get(item, GroupingKey.PINCODE, "Unknown")
    );

    // Prepare Products Pincode Level Availability row data
    const productsPincodeLevelAvailability = Object.entries(
        groupedByProduct
    ).map(([product, items]) => {
        const subCategory = get(
            items[0],
            CommonWidgetMetrics.SUB_CATEGORY,
            "Unknown"
        );
        const region = get(items[0], GroupingKey.REGION, "Unknown");

        // Calculate ASP (Average Selling Price)
        const asp =
            reduce(
                items,
                (sum, item) =>
                    sum + (get(item, AggregationField.CURR_PRICE, 0) || 0),
                0
            ) / items.length;

        // Calculate wtAvailability
        const totalCurrDrrUpd = reduce(
            items,
            (sum, item) =>
                sum + (get(item, AggregationField.CURR_DRR_UPD, 0) || 0),
            0
        );

        const weightedAvailability = reduce(
            filter(
                items,
                (item) =>
                    get(item, AggregationField.CURR_AVAILABILITY, false) ===
                    true
            ),
            (sum, item) =>
                sum + (get(item, AggregationField.CURR_DRR_UPD, 0) || 0),
            0
        );

        const wtAvailability =
            totalCurrDrrUpd > 0
                ? (weightedAvailability / totalCurrDrrUpd) * 100
                : 0;

        // Calculate Avg. Stock in Hand
        const avgStockInHand =
            totalCurrDrrUpd > 0
                ? reduce(
                      items,
                      (sum, item) =>
                          sum +
                          ((get(item, AggregationField.CURR_INVENTORY, 0) ||
                              0) /
                              (get(item, AggregationField.CURR_DRR_UPD, 0) ||
                                  1)) *
                              (get(item, AggregationField.CURR_DRR_UPD, 0) ||
                                  0),
                      0
                  ) / totalCurrDrrUpd
                : 0;

        // Calculate Unavailable on Dark Stores
        const unavailableOnDarkStores = filter(
            items,
            (item) =>
                get(item, AggregationField.CURR_AVAILABILITY, false) ===
                    false &&
                get(item, AggregationField.STORE_TYPE, "") === "dark"
        ).length;

        // Calculate Estimated Sales Loss
        const totalRevenue = reduce(
            items,
            (sum, item) =>
                sum + (get(item, AggregationField.CURR_DRR_REVENUE, 0) || 0),
            0
        );

        const lostRevenue = reduce(
            filter(
                items,
                (item) =>
                    get(item, AggregationField.CURR_AVAILABILITY, false) ===
                    false
            ),
            (sum, item) =>
                sum + (get(item, AggregationField.CURR_DRR_REVENUE, 0) || 0),
            0
        );

        const estimatedSalesLoss = totalRevenue > 0 ? lostRevenue : 0;

        return {
            product,
            subCategory,
            region,
            asp: `₹ ${asp.toFixed(1)}`,
            availability: `${wtAvailability.toFixed(1)}%`,
            listingStatus: "", // Placeholder for now
            avgStockInHand: avgStockInHand.toFixed(1),
            unavailableOnDarkStores,
            estimatedSalesLoss: `₹ ${estimatedSalesLoss.toFixed(2)}`,
        };
    });

    // Prepare Pincode Level Insights row data
    const pincodeLevelInsights = Object.entries(groupedByPincode).map(
        ([pincode, items]) => {
            const darkStore = get(
                items[0],
                AggregationField.STORE_ID,
                "Unknown"
            );

            // Calculate wtAvailability
            const totalCurrDrrUpd = reduce(
                items,
                (sum, item) =>
                    sum + (get(item, AggregationField.CURR_DRR_UPD, 0) || 0),
                0
            );

            const weightedAvailability = reduce(
                filter(
                    items,
                    (item) =>
                        get(item, AggregationField.CURR_AVAILABILITY, false) ===
                        true
                ),
                (sum, item) =>
                    sum + (get(item, AggregationField.CURR_DRR_UPD, 0) || 0),
                0
            );

            const wtAvailability =
                totalCurrDrrUpd > 0
                    ? (weightedAvailability / totalCurrDrrUpd) * 100
                    : 0;

            // Calculate #Products
            const totalProducts = unique(items, GroupingKey.SKU).length;

            // Calculate #Unavailable Products
            const unavailableProducts = filter(
                items,
                (item) =>
                    get(item, AggregationField.CURR_AVAILABILITY, false) ===
                    false
            ).length;

            // Calculate Estimated Sales Loss
            const totalRevenue = reduce(
                items,
                (sum, item) =>
                    sum +
                    (get(item, AggregationField.CURR_DRR_REVENUE, 0) || 0),
                0
            );

            const lostRevenue = reduce(
                filter(
                    items,
                    (item) =>
                        get(item, AggregationField.CURR_AVAILABILITY, false) ===
                        false
                ),
                (sum, item) =>
                    sum +
                    (get(item, AggregationField.CURR_DRR_REVENUE, 0) || 0),
                0
            );

            const estimatedSalesLoss = totalRevenue > 0 ? lostRevenue : 0;

            return {
                pincode,
                darkStore,
                availability: `${wtAvailability.toFixed(1)}%`,
                listingStatus: "", // Placeholder for now
                totalProducts,
                unavailableProducts,
                estimatedSalesLoss: `₹ ${estimatedSalesLoss.toFixed(2)}`,
            };
        }
    );

    return {
        productsPincodeLevelAvailability,
        pincodeLevelInsights,
    };
}
function prepareMaxSalesLossData(currentData: any[]) {
    if (!Array.isArray(currentData) || currentData.length === 0) {
        return {
            subcategoriesMaxSalesLossData: [],
            productsMaxSalesLossData: [],
        };
    }

    // Group data by subcategory
    const groupedBySubCategory = groupBy(currentData, (item) =>
        get(item, CommonWidgetMetrics.SUB_CATEGORY, "Unknown")
    );

    // Prepare Subcategories with Max Sales Loss row data
    const subcategoriesMaxSalesLossData = Object.entries(
        groupedBySubCategory
    ).map(([subCategory, items]) => {
        // Calculate ASP (Average Selling Price)
        const asp =
            reduce(
                items,
                (sum, item) =>
                    sum + (get(item, AggregationField.CURR_PRICE, 0) || 0),
                0
            ) / items.length;

        // Calculate Latest Availability
        const latestAvailability = reduce(
            filter(
                items,
                (item) =>
                    get(item, AggregationField.CURR_AVAILABILITY, false) ===
                    true
            ),
            (sum, item) =>
                sum + (get(item, AggregationField.CURR_DRR_UPD, 0) || 0),
            0
        );

        const totalCurrDrrUpd = reduce(
            items,
            (sum, item) =>
                sum + (get(item, AggregationField.CURR_DRR_UPD, 0) || 0),
            0
        );

        const availabilityPercentage =
            totalCurrDrrUpd > 0
                ? (latestAvailability / totalCurrDrrUpd) * 100
                : 0;

        // Calculate #Dark Stores
        const darkStores = unique(
            filter(
                items,
                (item) =>
                    get(item, AggregationField.CURR_AVAILABILITY, false) ===
                        false &&
                    get(item, AggregationField.STORE_TYPE, "") === "dark"
            ),
            AggregationField.STORE_ID
        ).length;

        // Calculate #Products
        const totalProducts = unique(items, GroupingKey.SKU).length;

        // Calculate Unavailable Products
        const unavailableProducts = filter(
            items,
            (item) =>
                get(item, AggregationField.CURR_AVAILABILITY, false) === false
        ).length;

        // Calculate Estimated Sales Loss
        const totalRevenue = reduce(
            items,
            (sum, item) =>
                sum + (get(item, AggregationField.CURR_DRR_REVENUE, 0) || 0),
            0
        );

        const lostRevenue = reduce(
            filter(
                items,
                (item) =>
                    get(item, AggregationField.CURR_AVAILABILITY, false) ===
                    false
            ),
            (sum, item) =>
                sum + (get(item, AggregationField.CURR_DRR_REVENUE, 0) || 0),
            0
        );

        const estimatedSalesLoss = totalRevenue > 0 ? lostRevenue : 0;

        return {
            subCategory,
            region: get(items[0], GroupingKey.REGION, "Unknown"), // Add region field
            pincode: get(items[0], GroupingKey.PINCODE, "Unknown"),
            asp: `₹ ${asp.toFixed(1)}`,
            latestAvailability: `${latestAvailability.toFixed(1)}%`,
            availabilityPercentage: `${availabilityPercentage.toFixed(1)}%`,
            darkStores,
            listingStatus: "", // Placeholder for now
            totalProducts,
            unavailableProducts,
            estimatedSalesLoss: `₹ ${estimatedSalesLoss.toFixed(2)}`,
        };
    });

    // Prepare Products with Max Sales Loss row data
    const groupedByProduct = groupBy(currentData, (item) =>
        get(item, GroupingKey.SKU, "Unknown")
    );

    const productsMaxSalesLossData = Object.entries(groupedByProduct).map(
        ([product, items]) => {
            const subCategory = get(
                items[0],
                CommonWidgetMetrics.SUB_CATEGORY,
                "Unknown"
            );

            // Calculate wtAvailability
            const totalCurrDrrUpd = reduce(
                items,
                (sum, item) =>
                    sum + (get(item, AggregationField.CURR_DRR_UPD, 0) || 0),
                0
            );

            const weightedAvailability = reduce(
                filter(
                    items,
                    (item) =>
                        get(item, AggregationField.CURR_AVAILABILITY, false) ===
                        true
                ),
                (sum, item) =>
                    sum + (get(item, AggregationField.CURR_DRR_UPD, 0) || 0),
                0
            );

            const wtAvailability =
                totalCurrDrrUpd > 0
                    ? (weightedAvailability / totalCurrDrrUpd) * 100
                    : 0;

            // Calculate Estimated Sales Loss
            const totalRevenue = reduce(
                items,
                (sum, item) =>
                    sum +
                    (get(item, AggregationField.CURR_DRR_REVENUE, 0) || 0),
                0
            );

            const lostRevenue = reduce(
                filter(
                    items,
                    (item) =>
                        get(item, AggregationField.CURR_AVAILABILITY, false) ===
                        false
                ),
                (sum, item) =>
                    sum +
                    (get(item, AggregationField.CURR_DRR_REVENUE, 0) || 0),
                0
            );

            const estimatedSalesLoss = totalRevenue > 0 ? lostRevenue : 0;

            // Calculate Unavailable on Dark Stores
            const unavailableOnDarkStores = filter(
                items,
                (item) =>
                    get(item, AggregationField.CURR_AVAILABILITY, false) ===
                        false &&
                    get(item, AggregationField.STORE_TYPE, "") === "dark"
            ).length;

            return {
                productTitle: product,
                subCategory,
                region: get(items[0], GroupingKey.REGION, "Unknown"), // Add region field
                availability: `${wtAvailability.toFixed(1)}%`,
                listingStatus: "", // Placeholder for now
                estimatedSalesLoss: `₹ ${estimatedSalesLoss.toFixed(2)}`,
                unavailableOnDarkStores,
            };
        }
    );

    return {
        subcategoriesMaxSalesLossData,
        productsMaxSalesLossData,
    };
}

export const calculateEstimatedSalesLoss = (data: TAvailabilityEcommData[]) => {
    const totalRevenue = reduce(
        data,
        (sum, item) => sum + (item.curr_drr_revenue || 0),
        0
    );

    const lostRevenue = reduce(
        filter(data, (item) => item.curr_availability === false),
        (sum, item) => sum + (item.curr_drr_revenue || 0),
        0
    );

    return totalRevenue > 0 ? round(lostRevenue / totalRevenue, 2) : 0;
};

export function formatCategoryAvailabilityData(data: any[]) {
    if (!Array.isArray(data) || data.length === 0) {
        return {
            summaryWidgetData: {
                wtAvailability: { value: 0, change: 0 },
                assortment: { value: 0, change: 0 },
                estimatedSalesLoss: { value: 0, change: 0 },
            },
            availabilityTrendsOverTimeData: {
                categories: [] as string[],
                yAxisData: [] as number[],
            },
            maxSalesLossData: {
                byRegion: [] as string[],
                bySubCategory: [] as string[],
            },
            availabilityIssuesByRegionAndSubcategory: {
                mainSeries: [] as string[],
                drilldownSeries: [] as string[],
            },
            citywiseAvailabilityAndSalesLossWidgetData: [] as string[],
            availabilityByPincode: [] as string[],
        };
    }

    const getPreviousAndCurrentData = (data: any[]) => {
        const { startDate, endDate } = getSelectedDateRange();

        const sortedData = sortBy(data, (item) =>
            moment(item.crawl_date).toDate()
        );

        const currentData = filter(sortedData, (item) =>
            moment(item.crawl_date).isBetween(startDate, endDate, null, "[]")
        );

        const previousData = filter(sortedData, (item) =>
            moment(item.crawl_date).isBefore(startDate)
        );

        return {
            previousData,
            currentData,
        };
    };

    const calculateWtAvailability = (data: any[], totalCurrDrrUpd: number) => {
        const weightedAvailability = reduce(
            filter(data, (item) => item.curr_availability === true),
            (sum, item) => sum + item.curr_drr_upd,
            0
        );

        return totalCurrDrrUpd > 0 ? weightedAvailability / totalCurrDrrUpd : 0;
    };

    const calculateAssortment = (data: any[]) => {
        return uniq(data, GroupingKey.SKU).length;
    };

    const calculateAvailabilityTrendsOverTime = (
        data: any[],
        totalCurrDrrUpd: number
    ) => {
        const groupedByDate = groupBy(data, CommonWidgetMetrics.CRAWL_DATE);

        const categories: string[] = [];
        const yAxisData: number[] = [];

        for (const [date, items] of Object.entries(groupedByDate)) {
            const weightedAvailabilityForDate = reduce(
                items,
                (sum, item) => sum + item.curr_drr_upd * item.curr_availability,
                0
            );

            const wtAvailability =
                totalCurrDrrUpd > 0
                    ? weightedAvailabilityForDate / totalCurrDrrUpd
                    : 0;

            categories.push(date);
            yAxisData.push(wtAvailability);
        }

        return {
            categories,
            yAxisData,
        };
    };

    const { previousData, currentData } = getPreviousAndCurrentData(data);

    const totalCurrDrrUpd = reduce(
        currentData,
        (sum, item) => sum + (item.curr_drr_upd || 0),
        0
    );

    const wtAvailabilityCurrent = calculateWtAvailability(
        currentData,
        totalCurrDrrUpd
    );
    const wtAvailabilityPrevious = calculateWtAvailability(
        previousData,
        totalCurrDrrUpd
    );

    const assortmentCurrent = calculateAssortment(currentData);
    const assortmentPrevious = calculateAssortment(previousData);

    const estimatedSalesLossCurrent = calculateEstimatedSalesLoss(currentData);
    const estimatedSalesLossPrevious =
        calculateEstimatedSalesLoss(previousData);

    const wtAvailability = {
        value: wtAvailabilityCurrent,
        change: wtAvailabilityCurrent - wtAvailabilityPrevious,
    };

    const assortment = {
        value: assortmentCurrent,
        change: assortmentCurrent - assortmentPrevious,
    };

    const estimatedSalesLoss = {
        value: estimatedSalesLossCurrent,
        change: estimatedSalesLossCurrent - estimatedSalesLossPrevious,
    };

    const availabilityTrendsOverTime = calculateAvailabilityTrendsOverTime(
        currentData,
        totalCurrDrrUpd
    );

    const dataBySubCategory = calculateMaxSalesLossByGroup(
        currentData,
        CommonWidgetMetrics.SUB_CATEGORY
    );
    const dataByRegion = calculateMaxSalesLossByGroup(
        currentData,
        GroupingKey.REGION
    );

    const availabilityIssuesBySubCat = calculateAvailabilityIssues(
        currentData,
        previousData,
        CommonWidgetMetrics.SUB_CATEGORY
    );
    const availabilityIssuesByCity =
        calculateAvailabilityIssuesByCity(currentData);
    const availabilityIssuesByRegion = calculateAvailabilityIssues(
        currentData,
        previousData,
        GroupingKey.REGION
    );
    const citywiseAvailabilityAndSalesLossWidgetData =
        calculateCitywiseAvailabilityAndSalesLossWidgetData(currentData);
    const availabilityByPincode =
        calculateProductsAvailabilityByPincode(currentData);
    const availabilityByRegion =
        calculateProductsAvailabilityByRegion(currentData);
    const oosProductsDrawerData = prepareOosProductsDrawerData(currentData);
    const oosDarkStoresDrawerData = prepareOosDarkStoresData(currentData);
    const topSubcategoriesEstimatedSalesLossData =
        prepareTopSubcategoriesEstimatedSalesLossData(currentData);
    const { productsPincodeLevelAvailability, pincodeLevelInsights } =
        preparePincodeLevelData(currentData);
    const { subcategoriesMaxSalesLossData, productsMaxSalesLossData } =
        prepareMaxSalesLossData(currentData);

    return {
        summaryWidgetData: {
            wtAvailability,
            assortment,
            estimatedSalesLoss,
        },
        availabilityTrendsOverTimeData: availabilityTrendsOverTime,
        maxSalesLossData: {
            byRegion: dataByRegion,
            bySubCategory: dataBySubCategory,
        },
        availabilityIssuesByRegionAndSubcategory: {
            mainSeries: [
                ...availabilityIssuesByRegion.mainSeries,
                ...availabilityIssuesBySubCat.mainSeries,
            ],
            drilldownSeries: [
                ...availabilityIssuesByRegion.drilldownSeries,
                ...availabilityIssuesBySubCat.drilldownSeries,
            ],
            regionChartData: availabilityIssuesByCity,
        },
        citywiseAvailabilityAndSalesLossWidgetData,
        availabilityByPincode,
        availabilityByRegion,
        oosProductsDrawerData,
        oosDarkStoresDrawerData,
        topSubcategoriesEstimatedSalesLossData,
        productsPincodeLevelAvailability,
        pincodeLevelInsights,
        productsMaxSalesLossData,
        subcategoriesMaxSalesLossData,
    };
}

export const groupValuesByFeature = (rawData: any[]) => {
    const grouped: Record<
        string,
        { displayName: string; values: Set<string> }
    > = {};

    rawData.forEach(({ feature, value }) => {
        if (!feature || value == null) return;

        const featureKey = feature.toLowerCase();

        if (!grouped[featureKey]) {
            grouped[featureKey] = {
                displayName: feature,
                values: new Set(),
            };
        }

        const titleCaseValue = titleCase(String(value));
        grouped[featureKey].values.add(titleCaseValue);
    });

    return Object.values(grouped).map(({ displayName, values }) => ({
        feature: displayName,
        values: Array.from(values),
    }));
};

export const formatCategoryOverviewCrossChannelAndCompetitionTableData = (
    data: IcategoryOverviewCrossChannelCompetitonComparisonData[],
    groupByKey: CommonWidgetMetrics.NAME | CommonWidgetMetrics.BRAND
): TFormattedCategoryOverviewCrossChannelCompetitonComparisonData[] => {
    if (!Array.isArray(data)) return [];

    const initAggEntry = (
        groupValue: string
    ): TCatOverviewCrossChannelCompetitionComparisonAggEntry =>
        ({
            [groupByKey]: groupValue,
            tag_subcategory: CommonWidgetMetrics.All,
            ...Object.fromEntries(
                catOverviewCompareTablesMetricsToSum.map((key) => [key, 0])
            ),
        } as TCatOverviewCrossChannelCompetitionComparisonAggEntry);

    const grouped: Record<
        string,
        TCatOverviewCrossChannelCompetitionComparisonAggEntry
    > = {};

    for (const item of data) {
        const groupValue = item[groupByKey];
        if (!groupValue) continue;

        if (!grouped[groupValue]) {
            grouped[groupValue] = initAggEntry(groupValue);
        }

        const agg = grouped[groupValue];

        for (const key of catOverviewCompareTablesMetricsToSum) {
            agg[key] += item[key] || 0;
        }
    }

    const allRows = Object.values(
        grouped
    ) as TFormattedCategoryOverviewCrossChannelCompetitonComparisonData[];

    return [...data, ...allRows].map(
        (item) =>
            item as TFormattedCategoryOverviewCrossChannelCompetitonComparisonData
    );
};

export const formatCategoryOverviewComparisonTableData = (
    data: IcategoryOverviewCrossChannelCompetitonComparisonData[]
): IcategoryOverviewCrossChannelCompetitonComparisonData[] => {
    if (!Array.isArray(data)) return [];

    const updatedData = data.map((item) => ({
        ...item,
        name: item.tag_subcategory,
    }));

    const allEntry = {
        tag_subcategory: CommonWidgetMetrics.All,
        name: CommonWidgetMetrics.All,
        ...Object.fromEntries(
            catOverviewComparisonTableMetricsToSum.map((key) => [key, 0])
        ),
    } as IcategoryOverviewCrossChannelCompetitonComparisonData;

    for (const item of updatedData) {
        for (const key of catOverviewComparisonTableMetricsToSum) {
            allEntry[key] += item[key] || 0;
        }
    }

    return [...updatedData, allEntry];
};

export const formatCategoryOverviewData = (
    data: any,
    section: string,
    date: TDate
) => {
    let formattedData: any;

    if (section === CategoryInsightsOverviewSections.CHARTS) {
        formattedData = {
            [CategoryOverviewChartsKeys.BRAND_CONTRIBUTION]:
                formatCategoryOverviewBrandContributionData(
                    data[0]?.brand_contribution
                ),
            [CategoryOverviewChartsKeys.MS_TRENDS_OVER_TIME]:
                formatCategoryOverviewMSTrendsOverTimeData(
                    data[0]?.ms_trend_over_time
                ),
            [CategoryOverviewChartsKeys.SUB_CATEGORIES_CONTRIBUTION]:
                formatCategoryOverviewSubCategoriesData(
                    data[0]?.sub_cat_contribution
                ),
            [CategoryOverviewChartsKeys.MARKET_SHARE_AND_SIZE]:
                formatCategoryOverviewMarketShareAndSizeData(
                    data[0]?.market_share_and_size
                ),
            [CategoryOverviewChartsKeys.CROSS_CHANNEL_GRAPH]:
                formatCategoryOverviewCrossChannelAndCompetitionGraph(
                    data[0]?.my_brand_cross_channel_graph,
                    MyProductTrendsModules.CROSS_CHANNEL
                ),
            [CategoryOverviewChartsKeys.CROSS_CHANNEL_TABLE]:
                formatCategoryOverviewCrossChannelAndCompetitionTableData(
                    data[0]?.cross_channel_table,
                    CommonWidgetMetrics.NAME
                ),
            [CategoryOverviewChartsKeys.COMPETITION_GRAPH]:
                formatCategoryOverviewCrossChannelAndCompetitionGraph(
                    data[0]?.my_brand_competition_graph,
                    MyProductTrendsModules.COMPETITION
                ),
            [CategoryOverviewChartsKeys.COMPETITION_TABLE]:
                formatCategoryOverviewCrossChannelAndCompetitionTableData(
                    data[0]?.competition_table,
                    CommonWidgetMetrics.BRAND
                ),
        };
    } else if (section === CategoryInsightsOverviewSections.SERP) {
        formattedData = {
            [CategoryOverviewSerpKeys.SUMMARY_WIDGET]:
                formatCategoryOverviewSummaryWidgetData(data),
            [CategoryOverviewSerpKeys.SUB_CATEGORY_PERFORMANCE]:
                formatCategoryOverviewSubCategoryPerformanceData(
                    data[0]?.sub_category_performance_rating_buybox_review_rpi
                ),
            [CategoryOverviewSerpKeys.DRAINERS]:
                formatCategoryOverviewDrainersData(data[0]?.drainers),
            [CategoryOverviewSerpKeys.COMPARISON_TABLE]:
                formatCategoryOverviewComparisonTableData(data[0]?.comparison),
            [CategoryOverviewSerpKeys.COMPARISON_GRAPH]:
                formatCategoryOverviewComparisonGraph(
                    data[0]?.comparison_graph,
                    date
                ),
            [CategoryOverviewSerpKeys.BEST_SELLER_SKU]:
                formatBestSellerSKUTableData(data[0]?.best_seller_sku),
        };
    }

    return formattedData;
};

export const numericChartLabelFormatter = (value: number): string => {
    const thresholds = [
        { limit: 10000000, suffix: "Cr" }, // 1 Crore
        { limit: 100000, suffix: "L" }, // 1 Lakh
        { limit: 1000, suffix: "K" }, // 1 Thousand
    ];

    const matched = find(thresholds, ({ limit }) => value >= limit);

    if (matched) {
        const formatted = (value / matched.limit)
            .toFixed(1)
            .replace(/\.0$/, "");
        return `${formatted}${matched.suffix}`;
    }

    return value.toString();
};
export const getSafeValue = (val: number | null | undefined): number =>
    val !== null && val !== undefined ? val : 0;
export const safeDivide = (numerator: number, denominator: number): number => {
    if (denominator === 0) return 0;
    return numerator / denominator;
};
export const formatCategoryOverviewBrandContributionData = (
    data: ICategoryOverviewBrandContributionData[]
): TBrandContributionFormattedData => {
    if (!Array.isArray(data)) {
        return {
            [CATEGORY_OVERVIEW_SKU_FILTERS.UNITS_SOLD]: [],
            [CATEGORY_OVERVIEW_SKU_FILTERS.REVENUE]: [],
        };
    }

    const formatData = (
        key:
            | CategoryOverviewBrandContributionMetricKey.UNITS_PER_DAY
            | CategoryOverviewBrandContributionMetricKey.REVENUE
    ) =>
        data.map((item: any) => ({
            name: item?.brand || "",
            subCat: item?.tag_subcategory || "",
            value:
                round(
                    safeDivide(item?.[key], item?.[`sub_cat_${key}`]) * 100,
                    2
                ) || 0,
            color: COLORS[Math.floor(Math.random() * COLORS.length)],
        }));

    return {
        [CATEGORY_OVERVIEW_SKU_FILTERS.UNITS_SOLD]: formatData(
            CategoryOverviewBrandContributionMetricKey.UNITS_PER_DAY
        ),
        [CATEGORY_OVERVIEW_SKU_FILTERS.REVENUE]: formatData(
            CategoryOverviewBrandContributionMetricKey.REVENUE
        ),
    };
};

export const formatCategoryOverviewMSTrendsOverTimeData = (
    data: ICategoryOverviewMSTrendsOverTimeData[] | null | undefined
): IFormattedCategoryOverviewMsTrendsOverTimeData => {
    const defaultTrendData: ITrendsWithCompareModalWidgetData = {
        categories: [],
        yAxisData: [],
        yAxisOppositeData: [],
    };

    const defaultReturn: IFormattedCategoryOverviewMsTrendsOverTimeData = {
        [CATEGORY_OVERVIEW_MS_TRENDS_OVERTIME_RADIO.MS_PERCENT]: {
            [CATEGORY_OVERVIEW_SKU_FILTERS.UNITS_SOLD]: { ...defaultTrendData },
            [CATEGORY_OVERVIEW_SKU_FILTERS.REVENUE]: { ...defaultTrendData },
        },
        [CATEGORY_OVERVIEW_MS_TRENDS_OVERTIME_RADIO.ROAS]: {
            ...defaultTrendData,
        },
        [CATEGORY_OVERVIEW_MS_TRENDS_OVERTIME_RADIO.SALES]: {
            ...defaultTrendData,
        },
        [CATEGORY_OVERVIEW_MS_TRENDS_OVERTIME_RADIO.AD_SPENDS]: {
            ...defaultTrendData,
        },
        [CATEGORY_OVERVIEW_MS_TRENDS_OVERTIME_RADIO.TOTAL_SALES]: {
            ...defaultTrendData,
        },
    };

    if (!Array.isArray(data) || data.length === 0) return defaultReturn;

    const formatData = (filter: string) => {
        const categories = data.map((item) => item.crawl_date || "");

        switch (filter) {
            case CATEGORY_OVERVIEW_SKU_FILTERS.UNITS_SOLD:
                return {
                    categories,
                    yAxisData: data.map((item) => round(item?.upd || 0, 2)),
                    yAxisOppositeData: data.map((item) =>
                        round((item?.upd / item?.cat_upd) * 100 || 0, 2)
                    ),
                };
            case CATEGORY_OVERVIEW_SKU_FILTERS.REVENUE:
                return {
                    categories,
                    yAxisData: data.map((item) => round(item?.revenue || 0, 2)),
                    yAxisOppositeData: data.map((item) =>
                        round((item?.revenue / item?.cat_revenue) * 100 || 0, 2)
                    ),
                };
            case CATEGORY_OVERVIEW_MS_TRENDS_OVERTIME_RADIO.ROAS:
                return {
                    categories,
                    yAxisData: data.map((item) => round(item.roas || 0, 2)),
                };
            case CATEGORY_OVERVIEW_MS_TRENDS_OVERTIME_RADIO.SALES:
                return {
                    categories,
                    yAxisData: data.map((item) => round(item.sale || 0, 2)),
                };
            case CATEGORY_OVERVIEW_MS_TRENDS_OVERTIME_RADIO.AD_SPENDS:
                return {
                    categories,
                    yAxisData: data.map((item) => round(item.spend || 0, 2)),
                };
            case CATEGORY_OVERVIEW_MS_TRENDS_OVERTIME_RADIO.TOTAL_SALES:
                return {
                    categories,
                    yAxisData: data.map((item) => round(item.revenue || 0, 2)),
                };
            default:
                return { categories: [], yAxisData: [] };
        }
    };

    return {
        [CATEGORY_OVERVIEW_MS_TRENDS_OVERTIME_RADIO.MS_PERCENT]: {
            [CATEGORY_OVERVIEW_SKU_FILTERS.UNITS_SOLD]: formatData(
                CATEGORY_OVERVIEW_SKU_FILTERS.UNITS_SOLD
            ),
            [CATEGORY_OVERVIEW_SKU_FILTERS.REVENUE]: formatData(
                CATEGORY_OVERVIEW_SKU_FILTERS.REVENUE
            ),
        },
        [CATEGORY_OVERVIEW_MS_TRENDS_OVERTIME_RADIO.ROAS]: formatData(
            CATEGORY_OVERVIEW_MS_TRENDS_OVERTIME_RADIO.ROAS
        ),
        [CATEGORY_OVERVIEW_MS_TRENDS_OVERTIME_RADIO.SALES]: formatData(
            CATEGORY_OVERVIEW_MS_TRENDS_OVERTIME_RADIO.SALES
        ),
        [CATEGORY_OVERVIEW_MS_TRENDS_OVERTIME_RADIO.AD_SPENDS]: formatData(
            CATEGORY_OVERVIEW_MS_TRENDS_OVERTIME_RADIO.AD_SPENDS
        ),
        [CATEGORY_OVERVIEW_MS_TRENDS_OVERTIME_RADIO.TOTAL_SALES]: formatData(
            CATEGORY_OVERVIEW_MS_TRENDS_OVERTIME_RADIO.TOTAL_SALES
        ),
    };
};

export const formatCategoryOverviewSubCategoriesData = (
    data: {
        tag_subcategory: string;
        sub_category_upd: number;
        sub_category_revenue: number;
        brand_upd: number;
        brand_revenue: number;
    }[]
): TCategoryOverviewSubCategoriesData => {
    if (!Array.isArray(data)) return {};

    const formatData = (
        valueKey:
            | CategoryOverviewSubCategoryMetricKey.UNITS_PER_DAY
            | CategoryOverviewSubCategoryMetricKey.REVENUE
    ) => ({
        categories: data.map((item: any) => item?.tag_subcategory || ""),
        series: [
            {
                name: "Your Brand Share %",
                data: data.map((item: any) =>
                    round(
                        safeDivide(
                            item?.[`brand_${valueKey}`],
                            item?.[`sub_category_${valueKey}`]
                        ) * 100,
                        2
                    )
                ),
                color: "#544fc5",
            },
            {
                name: "Category Market Size",
                data: data.map((item: any) =>
                    round(item?.[`sub_category_${valueKey}`], 2)
                ),
                color: "#2caffe",
            },
        ],
    });

    return {
        [CATEGORY_OVERVIEW_SKU_FILTERS.REVENUE]: formatData(
            CategoryOverviewSubCategoryMetricKey.REVENUE
        ),
        [CATEGORY_OVERVIEW_SKU_FILTERS.UNITS_SOLD]: formatData(
            CategoryOverviewSubCategoryMetricKey.UNITS_PER_DAY
        ),
    };
};

export const getCategoryInsightsFilters = (
    categoryInsightsFilters: ICategoryInsightFilters[]
) => {
    const categories = sortBy(
        uniq(
            categoryInsightsFilters
                .filter((item) => item?.tag_category)
                .map((item) => item.tag_category.trim())
        )
    );

    const subCategories = sortBy(
        uniq(
            categoryInsightsFilters
                .filter((item) => item?.tag_subcategory)
                .map((item) => item.tag_subcategory.trim())
        )
    );

    const brands = sortBy(
        uniq(
            categoryInsightsFilters
                .filter((item) => item?.brand)
                .map((item) => item.brand.trim())
        )
    );

    const features = sortBy(
        uniq(
            categoryInsightsFilters
                .filter((item) => item?.feature)
                .map((item) => item.feature.trim())
        )
    );

    return { categories, subCategories, brands, features };
};

export const getCategoryMatchingSubCategories = (
    selectedCategories: string[],
    data: ICategoryInsightFilters[]
): string[] => {
    const subcategories: Set<string> = new Set();
    data.forEach((item) => {
        if (selectedCategories.includes(item.tag_category)) {
            subcategories.add(item.tag_subcategory);
        }
    });
    return Array.from(subcategories);
};

export const getCategoryMatchingBrands = (
    selectedSubCategories: string[],
    data: ICategoryInsightFilters[]
): string[] => {
    const brands: Set<string> = new Set();
    data.forEach((item) => {
        if (selectedSubCategories.includes(item.tag_subcategory)) {
            brands.add(item.brand.trim().toLowerCase() as string);
        }
    });
    return Array.from(brands);
};

export const formatCategoryInsightsFilters = (
    categories: string[],
    subCategories: string[],
    brands: string[],
    features: string[]
) => {
    const formatItems = (items: string[]) =>
        items.map((item, index) => ({ label: item, value: item, key: index }));

    return {
        categories: formatItems(categories),
        subCategories: formatItems(subCategories),
        brands: formatItems(brands),
        features: formatItems(features),
    };
};

export const formatCategoryOverviewMarketShareAndSizeData = (
    data: ICategoryMarketShareAndSizeData[] | null | undefined
): ICategoryOverviewMarketShareAndSizeFormattedData[] => {
    if (!data?.length) {
        const zeroBlock = {
            revenueValue: 0,
            revenueDelta: 0,
            unitsValue: 0,
            unitsDelta: 0,
            chartPoints: categoryOverviewDefaultChartPoints,
        };
        return [
            {
                marketShare: zeroBlock,
                offtake: zeroBlock,
                marketSize: zeroBlock,
            },
        ];
    }

    const getChartPoints = (prev: number, curr: number) => [
        round(prev),
        round(curr),
    ];
    const getValueDelta = (curr: number, prev: number) => round(curr - prev);
    const getSafeDelta = (curr: number, prev: number) =>
        round(
            safeDivide(
                getSafeValue(curr) - getSafeValue(prev),
                getSafeValue(prev)
            ) * 100
        );
    const getIntlValue = (value: number) =>
        internationalizeNumericValue(round(value));

    return data.map((item) => {
        const {
            cur_brand_revenue = 0,
            prev_brand_revenue = 0,
            cur_brand_upd = 0,
            prev_brand_upd = 0,
            cur_revenue_share = 0,
            prev_revenue_share = 0,
            cur_upd_share = 0,
            prev_upd_share = 0,
            cur_market_size_by_revenue = 0,
            prev_market_size_by_revenue = 0,
            cur_market_size_by_upd = 0,
            prev_market_size_by_upd = 0,
        } = item;

        return {
            marketShare: {
                revenueValue: round(cur_revenue_share, 2),
                revenueDelta: getValueDelta(
                    cur_revenue_share,
                    prev_revenue_share
                ),
                unitsValue: round(cur_upd_share),
                unitsDelta: getValueDelta(cur_upd_share, prev_upd_share),
                chartPoints: {
                    revenue: getChartPoints(
                        prev_revenue_share,
                        cur_revenue_share
                    ),
                    units: getChartPoints(prev_upd_share, cur_upd_share),
                },
            },
            offtake: {
                revenueValue: getIntlValue(cur_brand_revenue),
                revenueDelta: getSafeDelta(
                    cur_brand_revenue,
                    prev_brand_revenue
                ),
                unitsValue: getIntlValue(cur_brand_upd),
                unitsDelta: getSafeDelta(cur_brand_upd, prev_brand_upd),
                chartPoints: {
                    revenue: getChartPoints(
                        prev_brand_revenue,
                        cur_brand_revenue
                    ),
                    units: getChartPoints(prev_brand_upd, cur_brand_upd),
                },
            },
            marketSize: {
                revenueValue: getIntlValue(cur_market_size_by_revenue),
                revenueDelta: getSafeDelta(
                    cur_market_size_by_revenue,
                    prev_market_size_by_revenue
                ),
                unitsValue: getIntlValue(cur_market_size_by_upd),
                unitsDelta: getSafeDelta(
                    cur_market_size_by_upd,
                    prev_market_size_by_upd
                ),
                chartPoints: {
                    revenue: getChartPoints(
                        prev_market_size_by_revenue,
                        cur_market_size_by_revenue
                    ),
                    units: getChartPoints(
                        prev_market_size_by_upd,
                        cur_market_size_by_upd
                    ),
                },
            },
        };
    });
};

export const formatCategoryOverviewSummaryWidgetData = (
    data: ICategoryOverviewSerpData[]
): ICategoryOverviewSummaryMetrics => {
    if (!data || data.length === 0) {
        return {
            [CommonWidgetMetrics.SALES]: valueDeltaDefault,
            [CommonWidgetMetrics.SPENDS]: valueDeltaDefault,
            [CommonWidgetMetrics.ROAS]: valueDeltaDefault,
            [CommonWidgetMetrics.ORGANIC_SOV]: valueDeltaDefault,
            [CommonWidgetMetrics.PAID_SOV]: valueDeltaDefault,
            [CommonWidgetMetrics.SEARCH_VOLUME]: valueDeltaDefault,
            [CommonWidgetMetrics.PRICING_RPI]: valueDeltaDefault,
            [CommonWidgetMetrics.RATING]: valueDeltaDefault,
            [CommonWidgetMetrics.REVIEW_COUNT]: valueDeltaDefault,
            [CommonWidgetMetrics.AVAILABILITY]: valueDeltaDefault,
            [CommonWidgetMetrics.BUYBOX]: valueDeltaDefault,
            categoryContribution: "N/A",
        };
    }

    const formatMetric = (
        cur: number | null | undefined,
        prev: number | null | undefined,
        format = (v: number) => round(v),
        isDeltaPercentage = true
    ) => ({
        value: round(getSafeValue(cur)),
        delta: round(
            safeDivide(
                getSafeValue(cur) - getSafeValue(prev),
                getSafeValue(prev)
            ) * 100
        ),
    });

    const categoryData = data[0];
    const sov =
        categoryData.sov_rating_buybox_review[0] ||
        ({} as ISovRatingBuyboxReview);
    const sales = categoryData.sale_spend_roas[0] || ({} as ISaleSpendRoas);

    return {
        [CommonWidgetMetrics.SALES]: formatMetric(
            sales.cur_sale,
            sales.prev_sale
        ),
        [CommonWidgetMetrics.SPENDS]: formatMetric(
            sales.cur_spend,
            sales.prev_spend
        ),
        [CommonWidgetMetrics.ROAS]: formatMetric(
            sales.cur_roas,
            sales.prev_roas
        ),
        [CommonWidgetMetrics.ORGANIC_SOV]: formatMetric(
            sov.cur_org_sov,
            sov.prev_org_sov
        ),
        [CommonWidgetMetrics.PAID_SOV]: formatMetric(
            sov.cur_paid_sov,
            sov.prev_paid_sov
        ),
        [CommonWidgetMetrics.SEARCH_VOLUME]: formatMetric(
            sov.cur_search_volume,
            sov.prev_search_volume
        ),
        [CommonWidgetMetrics.PRICING_RPI]: formatMetric(
            sov.cur_rpi,
            sov.prev_rpi
        ),
        [CommonWidgetMetrics.RATING]: formatMetric(
            sov.cur_rating,
            sov.prev_rating
        ),
        [CommonWidgetMetrics.REVIEW_COUNT]: formatMetric(
            sov.current_review_count,
            sov.previous_review_count
        ),
        [CommonWidgetMetrics.AVAILABILITY]: formatMetric(
            sov.cur_availability,
            sov.prev_availability
        ),
        [CommonWidgetMetrics.BUYBOX]: formatMetric(
            sov.cur_buybox_win,
            sov.prev_buybox_win
        ),
        categoryContribution: round(getSafeValue(sov.category_share)) || "N/A",
    };
};

export const formatVisibilityData = (data: any) => {
    const {
        my_product_trend_competition,
        my_product_trend_cross_channel,
        organic_paid_gv,
        visibility_trends,
        keyword_visibility,
        sov_my_sku_vs_competition,
        performance_comparision_ctr_trend,
        overall_table_data_competition,
        overall_table_data_cross_channel,
        overall_expanded_table_data_cross_channel,
        overall_expanded_table_data_competition,
        keyword_performance_graph,
        keyword_performance_graph_competition,
        working_not_working,
    } = data[0];

    return {
        myProductTrendCompetition: formatVisibilityMyProductTrendData(
            my_product_trend_competition
        ),
        myProductTrendCrossChannel: formatVisibilityMyProductTrendData(
            my_product_trend_cross_channel
        ),
        organicPaidGV: organic_paid_gv
            ? formatVisibilitySummaryData(organic_paid_gv[0])
            : organic_paid_gv,
        visibilityTrends: formatTrendsWithCompareModalData(visibility_trends, {
            categoryKey: CommonWidgetMetrics.CRAWL_DATE,
            yAxisKey: AggregationField.CURRENT_PAID_VISIBILITY,
            yAxisOppositeKey: AggregationField.CURRENT_ORGANIC_VISIBILITY,
            yAxisOppositeKeyOptional: AggregationField.OVERALL_VISIBILITY,
        }),
        workingNotWorking:
            formatVisibilitySatisfactionDriversSummary(working_not_working),
        keywordVisibility: keyword_visibility?.length
            ? formatKeywordVisibilityData(keyword_visibility)
            : keyword_visibility,
        myProductTrendsCrossChannelTableData: overall_table_data_cross_channel,
        myProductTrendsCompetitionTableData: overall_table_data_competition,
        myProductTrendsCrossChannelExpandedTableData:
            overall_expanded_table_data_cross_channel,
        myProductTrendsCompetitionExpandedTableData:
            overall_expanded_table_data_competition,
        mySovVsCompetitionData: sov_my_sku_vs_competition,
        ctrTrendData: performance_comparision_ctr_trend,
        performanceComparisionData: PerformanceComparisionData(
            performance_comparision_ctr_trend
        ),
        keywordPerformanceGraphCrossChannel: groupBy(
            keyword_performance_graph,
            AggregationField.KEYWORD
        ),
        keywordPerformanceTableCrossChannel: groupBy(
            keyword_visibility,
            AggregationField.KEYWORD
        ),
        keywordPerformanceExpandedTableCrossChannel: groupBy(
            keyword_visibility,
            AggregationField.KEYWORD
        ),
        keywordPerformanceGraphCompetition: groupBy(
            keyword_performance_graph_competition,
            AggregationField.KEYWORD
        ),
    };
};

export const generateBlueShades = (index: number, total: number) => {
    const baseHue = 221;
    const saturation = 90;
    const minLightness = 53;
    const maxLightness = 80;
    const lightness =
        minLightness +
        index * ((maxLightness - minLightness) / Math.max(1, total - 1));
    return `hsl(${baseHue}, ${saturation}%, ${lightness}%)`;
};
const formatproductVsCompetitionTrendsAvailabilityData = (
    data: IAvailabilityData
) => {
    const { my_sku_data, competition_data } = data || {};
    if (!my_sku_data && !competition_data) {
        return {
            categories: [],
            yAxisData: [],
            statusData: [],
        };
    }

    const productAvailability: Record<
        string,
        { available: number; total: number }
    > = {};
    const latestAvailabilityStatus: Record<string, string> = {};

    const latestDate = [...(my_sku_data || []), ...(competition_data || [])]
        .map((d) => d?.crawl_date)
        .filter(Boolean)
        .sort()
        .pop();

    // Process my product data
    my_sku_data.forEach((entry) => {
        const productName = `${entry.sku}`;
        if (!productAvailability[productName]) {
            productAvailability[productName] = { available: 0, total: 0 };
        }
        productAvailability[productName].total += 1;
        if (entry.availability) productAvailability[productName].available += 1;

        if (entry.crawl_date === latestDate) {
            latestAvailabilityStatus[productName] = entry.availability
                ? "available"
                : "not-available";
        }
    });

    // Process competitor product data
    competition_data?.forEach((entry) => {
        const productName = `${entry.sku}`;
        if (!productAvailability[productName]) {
            productAvailability[productName] = { available: 0, total: 0 };
        }
        productAvailability[productName].total += 1;
        if (entry.availability) productAvailability[productName].available += 1;

        if (entry.crawl_date === latestDate) {
            latestAvailabilityStatus[productName] = entry.availability
                ? "available"
                : "not-available";
        }
    });

    const categories: string[] = [];
    const yAxisData: number[] = [];
    const statusData: string[] = [];

    for (const product in productAvailability) {
        categories.push(product);
        yAxisData.push(
            (productAvailability[product].available /
                productAvailability[product].total) *
                100
        );
        statusData.push(latestAvailabilityStatus[product] || "not-available");
    }

    return {
        categories,
        yAxisData,
        statusData,
    };
};

export const formatOosMsDynamicsChartData = (
    data: IAvailabilityData,
    date: TDate
) => {
    const { my_sku_data = [], competition_data = [] } = data || {};

    if (!Array.isArray(my_sku_data) || !Array.isArray(competition_data)) {
        return { categories: [], series: [], skuLists: [] };
    }

    const { startDate, endDate } = date;

    const start = startDate.toDate();
    const end = endDate.toDate();

    const filterByDateRange = (items: any[], key: string) =>
        items.filter((item) => {
            const itemDate = new Date(item[key]);
            return itemDate >= start && itemDate <= end;
        });

    const filteredMySkuData = filterByDateRange(
        my_sku_data,
        CommonWidgetMetrics.CRAWL_DATE
    );
    const filteredCompData = filterByDateRange(
        competition_data,
        CommonWidgetMetrics.CRAWL_DATE
    );

    // Extract unique dates
    const uniqueDates = Array.from(
        new Set(
            [...filteredMySkuData, ...filteredCompData].map((d) => d.crawl_date)
        )
    ).sort();

    // Initialize data storage
    const myBrandMarketShare: number[] = [];
    const myBrandOOS: number[] = [];
    const competitorDataMap: Record<
        string,
        { marketShare: number[]; oos: number[] }
    > = {};

    const skuLists: Set<string> = new Set();

    // Process data for each unique date
    uniqueDates.forEach((date) => {
        // My Brand calculations
        const myDataForDate = filteredMySkuData.find(
            (d) => d.crawl_date === date
        );
        const myRevenue = myDataForDate ? myDataForDate.revenue : 0;
        const myCatRevenue = myDataForDate ? myDataForDate.cat_revenue : 1;
        const myAvailability = myDataForDate
            ? myDataForDate.availability
            : false;

        myBrandMarketShare.push((myRevenue / myCatRevenue) * 100);
        myBrandOOS.push(myAvailability ? 0 : 100); // If unavailable, OOS = 100%

        // Competitor calculations (track each SKU separately)
        const compDataForDate = filteredCompData.filter(
            (d) => d.crawl_date === date
        );
        const skuGroupedData: Record<
            string,
            {
                revenue: number;
                cat_revenue: number;
                unavailableCount: number;
                total: number;
            }
        > = {};

        compDataForDate.forEach((comp) => {
            skuLists.add(comp.sku);
            if (!skuGroupedData[comp.sku]) {
                skuGroupedData[comp.sku] = {
                    revenue: 0,
                    cat_revenue: 1,
                    unavailableCount: 0,
                    total: 0,
                };
            }
            skuGroupedData[comp.sku].revenue += comp.revenue || 0;
            skuGroupedData[comp.sku].cat_revenue += comp.cat_revenue || 1;
            skuGroupedData[comp.sku].total += 1;
            if (!comp.availability) skuGroupedData[comp.sku].unavailableCount++;
        });

        // Store SKU-specific data in competitorDataMap
        Object.keys(skuGroupedData).forEach((sku) => {
            if (!competitorDataMap[sku]) {
                competitorDataMap[sku] = { marketShare: [], oos: [] };
            }
            const { revenue, cat_revenue, unavailableCount, total } =
                skuGroupedData[sku];
            competitorDataMap[sku].marketShare.push(
                (revenue / cat_revenue) * 100
            );
            competitorDataMap[sku].oos.push(
                total ? (unavailableCount / total) * 100 : 0
            );
        });
    });

    // Construct the series data
    const series = [
        {
            name: "My Brand Market Share %",
            type: "column",
            data: myBrandMarketShare,
            color: "blue",
        },
        {
            name: "My Brand Out of Stock %",
            type: "line",
            yAxis: 1,
            data: myBrandOOS,
            color: "blue",
            marker: { enabled: true },
        },
        ...Object.keys(competitorDataMap).map((sku) => [
            {
                name: `SKU ${sku} Market Share %`,
                type: "column",
                data: competitorDataMap[sku].marketShare,
                color: "red",
            },
            {
                name: `SKU ${sku} Out of Stock %`,
                type: "line",
                yAxis: 1,
                data: competitorDataMap[sku].oos,
                color: "red",
                dashStyle: "Dash",
                marker: { enabled: true },
            },
        ]),
    ].flat();

    return {
        categories: uniqueDates,
        series,
        skuLists: Array.from(skuLists),
    };
};

export const formatAvailabilityTrendsOverTimeChartData = (
    data: IAvailabilityData,
    date: TDate
) => {
    const { startDate, endDate } = date;
    const start = startDate.toDate();
    const end = endDate.toDate();

    const filteredData =
        data.my_sku_data?.filter((entry) => {
            const entryDate = new Date(entry.crawl_date);
            return entryDate >= start && entryDate <= end;
        }) || [];

    const categories = filteredData.map((entry) => entry.crawl_date);

    const yAxisData = filteredData.map((entry) =>
        entry.availability ? 100 : 0
    );

    const yAxisOppositeData = filteredData.map((entry) =>
        entry.buybox_win ? 100 : 0
    );

    return {
        categories,
        yAxisData,
        yAxisOppositeData,
    };
};

export const formatPriceImpactOnBuyBoxWinData = (
    data: IAvailabilityMySkuData[] | TAvailabilityEcommData[],
    date: TDate,
    keyMap = {
        price: AggregationField.PRICE,
        availability: AggregationField.AVAILABILITY,
        buyboxWin: AggregationField.BUYBOX_WIN,
    }
) => {
    const { startDate, endDate } = date;
    const start = startDate.toDate();
    const end = endDate.toDate();

    const filteredData = (data || []).filter((item) => {
        const crawlDate = new Date(item.crawl_date);
        return crawlDate >= start && crawlDate <= end;
    });

    const categories: string[] = [];
    const prices: number[] = [];
    const availabilityPercentage: number[] = [];
    const bbwinPercentages: number[] = [];

    filteredData.forEach((item) => {
        const priceVal = item[keyMap.price as keyof typeof item];
        const availabilityVal = item[keyMap.availability as keyof typeof item];
        const buyboxVal = item[keyMap.buyboxWin as keyof typeof item];

        categories.push(item.crawl_date);
        prices.push(typeof priceVal === "number" ? priceVal : 0);
        availabilityPercentage.push(
            typeof availabilityVal === "number"
                ? availabilityVal
                : availabilityVal
                ? 100
                : 0
        );

        bbwinPercentages.push(
            typeof buyboxVal === "number" ? buyboxVal : buyboxVal ? 100 : 0
        );
    });

    return {
        categories,
        prices,
        availabilityPercentage,
        bbwinPercentages,
    };
};
const formatAvailabilityBuyboxEstimatedLossData = (data: IAvailabilityData) => {
    const latestSkuData = [...(data.my_sku_data ?? [])].sort(
        (a, b) =>
            new Date(b.crawl_date).getTime() - new Date(a.crawl_date).getTime()
    );

    let winner = "Unknown Seller";
    for (const sku of latestSkuData) {
        if (sku.merchant_name && sku.merchant_name.length > 0) {
            winner = sku.merchant_name[0];
            break;
        }
    }

    const latestSku = latestSkuData[0]?.sku ?? null;

    const availabilityData = data.widget_avail_data_resp?.find(
        (item) => item.sku === latestSku
    );
    const buyboxData = data.widget_buybox_data_resp?.find(
        (item) => item.sku === latestSku
    );
    const estimatedLossData = data.widget_estimated_loss_resp?.find(
        (item) => item.sku === latestSku
    );

    return {
        availabilityPercentage: {
            value: availabilityData?.availability_percent ?? 0,
            change: availabilityData?.availability_change ?? 0,
            outOfstockSince: availabilityData?.out_of_stock_days ?? 0,
        },
        buyboxPercentage: {
            value: buyboxData?.buybox_win_rate ?? 0,
            change: buyboxData?.buybox_win_rate_change ?? 0,
            winner,
        },
        estimatedSalesLoss: {
            value: estimatedLossData?.current_total_sales_loss ?? 0,
            change: estimatedLossData?.percentage_change ?? 0,
        },
    };
};

export const formatOtherSellerData = (data: IAvailabilityData) => {
    return data?.widget_dailog_buybox_data_resp
        ?.map((item) => {
            const sellerData: TOtherSellerFormattedData[] = [];

            Object.keys(item).forEach((key) => {
                const match = key.match(/^seller_(\d+)(?:_(.*))?$/);
                if (match) {
                    const index = Number(match[1]); // Extract seller index
                    const field = match[2] || "seller"; // Default field if only seller_N exists

                    if (!sellerData[index]) {
                        sellerData[index] = {
                            key: String(index),
                            seller: "N/A",
                            rating: 0,
                            review: 0,
                            positiveFeedback: 0,
                            discountedPrice:
                                item[`avg_seller_${index}_price`] ?? 0,
                            mrp: item.mrp ?? 0,
                            deliveryDate: "N/A",
                        };
                    }

                    // Assign values dynamically
                    sellerData[index][field] =
                        (item as Record<string, any>)[key] ??
                        sellerData[index][field];
                }
            });

            return Object.values(sellerData);
        })
        .flat();
};

export const formatMyProductTrendsTableAvailabilityData = (
    data: any,
    date: TDate,
    groupKey: string
) => {
    const { startDate, endDate } = date;
    const groupedData = groupBy(data, groupKey);

    const formattedData = map(Object.keys(groupedData), (channelId) => {
        const items = groupedData[channelId];
        const sortedItems = sortBy(items, (item) => moment(item.crawl_date));

        const currItems = sortedItems.filter((item) =>
            moment(item.crawl_date).isBetween(startDate, endDate, null, "[]")
        );
        const prevItems = sortedItems.filter((item) =>
            moment(item.crawl_date).isBefore(startDate)
        );

        const sumCurrRevenue = reduce(
            currItems,
            (sum, item) => sum + item.revenue,
            0
        );
        const sumCurrCatRevenue = reduce(
            currItems,
            (sum, item) => sum + item.cat_revenue,
            0
        );
        const sumPrevRevenue = reduce(
            prevItems,
            (sum, item) => sum + item.revenue,
            0
        );
        const sumPrevCatRevenue = reduce(
            prevItems,
            (sum, item) => sum + item.cat_revenue,
            0
        );

        const currAvailability =
            (currItems.filter((item) => item.availability).length /
                (currItems.length || 1)) *
            100;
        const prevAvailability =
            (prevItems.filter((item) => item.availability).length /
                (prevItems.length || 1)) *
            100;

        const currBuybox =
            (currItems.filter((item) => item.buybox_win).length /
                (currItems.length || 1)) *
            100;
        const prevBuybox =
            (prevItems.filter((item) => item.buybox_win).length /
                (prevItems.length || 1)) *
            100;

        const currMsPercentage = (
            (sumCurrRevenue / (sumCurrCatRevenue || 1)) *
            100
        ).toFixed(2);
        const prevMsPercentage = (
            (sumPrevRevenue / (sumPrevCatRevenue || 1)) *
            100
        ).toFixed(2);

        const latestEntry = currItems.length
            ? last(currItems)
            : last(sortedItems);
        const availabilityStatus = latestEntry
            ? latestEntry.availability
            : false;

        return {
            name:
                groupKey === CommonWidgetMetrics.CHANNEL_ID
                    ? latestEntry.channel
                    : latestEntry.sku,
            curr_availability: +currAvailability.toFixed(2),
            prev_availability: +prevAvailability.toFixed(2),
            curr_buybox: +currBuybox.toFixed(2),
            prev_buybox: +prevBuybox.toFixed(2),
            curr_ms_percentage: +currMsPercentage,
            prev_ms_percentage: +prevMsPercentage,
            availability_status: availabilityStatus
                ? "Available"
                : "Not Available",
        };
    });

    return formattedData;
};

export const formatAvalabilityComparisionData = (
    rawData: IPerformanceComparisionRawDataItem[],
    my_sku_data: IAvailabilityMySkuData[] | null | undefined
): IPerformanceComparisionAggregatedDataItem[] => {
    if (!isArray(rawData) || isEmpty(rawData)) {
        return [];
    }
    // Map my_sku_data by crawl_date for quick lookup
    const mySkuDataMap = (my_sku_data ?? []).reduce((acc, item) => {
        const date = dayjs(item.crawl_date).format("YYYY-MM-DD");
        acc[date] = {
            availability: item.availability || false,
            buybox_win: item.buybox_win || false,
            sku: item.sku,
            revenue: item.revenue,
        };
        return acc;
    }, {} as Record<string, { availability: boolean; buybox_win: boolean; sku: string; revenue: number }>);

    // Aggregate rawData
    const aggregatedData: Record<
        string,
        IPerformanceComparisionAggregatedDataItem
    > = rawData.reduce(
        (
            acc: Record<string, IPerformanceComparisionAggregatedDataItem>,
            item
        ) => {
            const date = dayjs(item.date).format("YYYY-MM-DD");

            if (!acc[date]) {
                acc[date] = {
                    impression: 0,
                    clicks: 0,
                    sales: 0,
                    spend: 0,
                    orders: 0,
                    program_type: "",
                };
            }

            // Aggregate values for each date
            acc[date].impression += item.impression || 0;
            acc[date].clicks += item.click || 0;
            acc[date].sales += item.sale || 0;
            acc[date].spend += item.spend || 0;
            acc[date].orders += item.orders || 0;
            acc[date].program_type = item.program_type || "";

            return acc;
        },
        {}
    );

    return Object?.keys(aggregatedData).map((date) => {
        const { impression, sales, spend, program_type } = aggregatedData[date];

        return {
            crawl_date: date,
            impression,
            sales,
            spend: spend,
            roas: sales > 0 ? spend / sales : 0,
            program_type: program_type,
            availability: mySkuDataMap[date]?.availability || false,
            buybox_win: mySkuDataMap[date]?.buybox_win || false,
            sku: mySkuDataMap[date]?.sku || "",
            revenue: mySkuDataMap[date]?.revenue || 0,
        };
    });
};

export const formatAvailablityComparisonChartData = (
    rawData: IPerformanceComparisionAggregatedDataItem[]
) => {
    // Sort the data by date in ascending order
    const sortedData = rawData
        .slice()
        .sort((a, b) => moment(a.crawl_date).diff(moment(b.crawl_date)));

    // Extract the categories (dates)
    const categories = sortedData.map((item) => item.crawl_date);

    // Create series for each metric
    const roasSeries = {
        name: AggregationField.ROAS,
        data: sortedData.map((item) => item.roas),
    };

    const salesSeries = {
        name: AggregationField.SALE,
        data: sortedData.map((item) => item.sales),
    };

    const spendsSeries = {
        name: AggregationField.SPEND,
        data: sortedData.map((item) => item.spend),
    };

    const totalSalesSeries = {
        name: AggregationField.TOTAL_SALES,
        data: sortedData.map((item) => item.revenue),
    };

    // Return the formatted chart data object
    return {
        categories,
        series: [roasSeries, salesSeries, spendsSeries, totalSalesSeries],
    };
};

export const formatAvailabilityData = (
    data: IAvailabilityData,
    date: TDate
) => {
    return {
        ...data,
        workingNotWorkingInsights:
            formatVisibilitySatisfactionDriversSummary(null),
        aiSummary: {},
        bbwinnerDistributionData: data?.buy_box_winner_distribution,
        OosMsDynamicsChartData: formatOosMsDynamicsChartData(data, date),
        productVsCompetitionTrendsData:
            formatproductVsCompetitionTrendsAvailabilityData(data),
        priceImpactOnBuyBoxWinData: formatPriceImpactOnBuyBoxWinData(
            data?.my_sku_data || [],
            date
        ),
        availabilityTrendsData: formatAvailabilityTrendsOverTimeChartData(
            data,
            date
        ),
        availabilityBuyboxEstimatedLossData:
            formatAvailabilityBuyboxEstimatedLossData(data),
        otherSellersData: formatOtherSellerData(data),
        myProductTrendsChartCrossChannelChartData: groupBy(
            data.cross_channel_and_direct_competitor_data,
            GroupingKey.SKU
        ),
        myProductTrendsChartCompetitionChartData: data.competition_data,
        myProductCrossChannelTableData:
            formatMyProductTrendsTableAvailabilityData(
                data.cross_channel_and_direct_competitor_data,
                date,
                GroupingKey.CHANNEL_ID
            ),
        myProductCompetitionChannelTableData:
            formatMyProductTrendsTableAvailabilityData(
                data.competition_data,
                date,
                GroupingKey.SKU
            ),
        myProductComparisonChartData: formatAvalabilityComparisionData(
            data.performance_comparision_ctr_trend,
            data.my_sku_data
        ),
    };
};
export const formatDataBasedOnFrequency = (
    data: any,
    module: ProductDeepdiveModules | string,
    parentModule?: string
) => {
    let tempData;

    if (parentModule === SubModule.CATEGORY_INSIGHTS) {
        switch (module) {
            case ProductDeepdiveModules.OVERVIEW:
                tempData = formatDataWithAggregations(
                    data,
                    CommonWidgetMetrics.CRAWL_DATE,
                    [
                        AggregationType.MS_TREND_OVER_TIME,
                        AggregationType.MY_BRAND_CROSS_CHANNEL_GRAPH,
                        AggregationType.MY_BRAND_COMPETITION_GRAPH,
                        AggregationType.COMPARISON_GRAPH,
                    ],
                    [
                        AggregationField.UPD,
                        AggregationField.CAT_UPD,
                        AggregationField.REVENUE,
                        AggregationField.CAT_REVENUE,
                        AggregationField.SALE,
                        AggregationField.SPEND,
                        AggregationField.ROAS,
                        AggregationField.TOTAL_SALES,
                        AggregationField.CUR_PRICE,
                        AggregationField.UPD_MS,
                        AggregationField.REVENUE_MS,
                    ],
                    {},
                    [
                        GroupingKey.TAG_SUBCATEGORY,
                        GroupingKey.NAME,
                        GroupingKey.BRAND,
                    ]
                );

                return {
                    rawData: tempData.rawData,
                    weeklyData: tempData.weeklyData,
                    monthlyData: tempData.monthlyData,
                };
            case ProductDeepdiveModules.AVAILABILITY:
                tempData = formatDataWithAggregations(
                    data,
                    CommonWidgetMetrics.CRAWL_DATE,
                    [
                        AggregationType.CATEGORY_DATA,
                        AggregationType.COMPETITION_DATA,
                    ],
                    [
                        AggregationField.CURR_AVAILABILITY,
                        AggregationField.CURR_DRR_PRICE,
                        AggregationField.CURR_UPD,
                        AggregationField.CURR_DRR_UPD,
                        AggregationField.CURR_PRICE,
                        AggregationField.CURR_DRR_REVENUE,
                        AggregationField.CURR_REVENUE,
                        AggregationField.BUYBOX_WIN,
                    ],
                    {
                        [AggregationType.CATEGORY_DATA]:
                            CustomGroupingFunction.CATEGORY_DATA_ECOMM,
                        // [AggregationType.CATEGORY_DATA]:
                        // CustomGroupingFunction.MY_PRODUCT_PRICE_AND_DEAL,
                        [AggregationType.COMPETITION_DATA]:
                            CustomGroupingFunction.CATEGORY_DATA_ECOMM,
                    },
                    [
                        GroupingKey.BRAND,
                        GroupingKey.SKU,
                        GroupingKey.TAG_SUBCATEGORY,
                        GroupingKey.STORE_ID,
                        GroupingKey.CATEGORY,
                        GroupingKey.SUB_CATEGORY,
                        GroupingKey.CITY,
                        GroupingKey.PINCODE,
                        GroupingKey.REGION,
                        GroupingKey.CHANNEL_ID,
                        GroupingKey.SKU_TITLE,
                    ]
                );

                return {
                    rawData: tempData.rawData,
                    weeklyData: tempData.weeklyData,
                    monthlyData: tempData.monthlyData,
                };
            default:
                return data;
        }
    } else {
        switch (module) {
            case ProductDeepdiveModules.OVERVIEW:
                if (parentModule === SubModule.CATEGORY_INSIGHTS) {
                    tempData = formatDataWithAggregations(
                        data,
                        CommonWidgetMetrics.CRAWL_DATE,
                        [
                            AggregationType.MS_TREND_OVER_TIME,
                            AggregationType.MY_BRAND_CROSS_CHANNEL_GRAPH,
                            AggregationType.MY_BRAND_COMPETITION_GRAPH,
                            AggregationType.COMPARISON_GRAPH,
                        ],
                        [
                            AggregationField.UPD,
                            AggregationField.CAT_UPD,
                            AggregationField.REVENUE,
                            AggregationField.CAT_REVENUE,
                            AggregationField.SALE,
                            AggregationField.SPEND,
                            AggregationField.ROAS,
                            AggregationField.TOTAL_SALES,
                            AggregationField.CUR_PRICE,
                            AggregationField.UPD_MS,
                            AggregationField.REVENUE_MS,
                        ],
                        {},
                        [
                            GroupingKey.TAG_SUBCATEGORY,
                            GroupingKey.NAME,
                            GroupingKey.BRAND,
                        ]
                    );

                    return {
                        rawData: tempData.rawData,
                        weeklyData: tempData.weeklyData,
                        monthlyData: tempData.monthlyData,
                    };
                } else {
                    tempData = formatDataWithAggregations(
                        data,
                        CommonWidgetMetrics.CRAWL_DATE,
                        [AggregationType.OVERVIEW],
                        [
                            AggregationField.BSR_RANK_2,
                            AggregationField.CAT_UPD,
                            AggregationField.CONTENT_SCORE,
                            AggregationField.MRP,
                            AggregationField.ORG_CAT_WT_CRAWL_SV,
                            AggregationField.ORG_SKU_WT_CRAWL_SV,
                            AggregationField.PAID_CAT_WT_CRAWL_SV,
                            AggregationField.PAID_SKU_WT_CRAWL_SV,
                            AggregationField.PRICE,
                            AggregationField.RATING,
                            AggregationField.UNIT_PER_DAY,
                        ],
                        {},
                        [
                            GroupingKey.CHANNEL_ID,
                            GroupingKey.CLIENT_SUBGROUP_ID,
                            GroupingKey.SKU_LINK,
                            GroupingKey.SKU_TITLE,
                        ]
                    );

                    return {
                        rawData: tempData.rawData[0].overview,
                        weeklyData: tempData.weeklyData[0].overview,
                        monthlyData: tempData.monthlyData[0].overview,
                    };
                }
            case ProductDeepdiveModules.PRICING:
                return formatDataWithAggregations(
                    data,
                    CommonWidgetMetrics.CRAWL_DATE,
                    [
                        AggregationType.DATEWISE_TRENDS_OF_COMPETITIVE_PRODUCTS,
                        AggregationType.MS_VS_RPI,
                        AggregationType.MY_PRODUCT_PRICE_AND_DEAL,
                        AggregationType.MY_PRODUCT_TRENDS_GRAPH_COMPETITION,
                        AggregationType.MY_PRODUCT_TRENDS_GRAPH_CROSS_CHANNEL,
                        AggregationType.PRICING_AND_DEAL_TRENDS,
                    ],
                    [
                        AggregationField.RATING,
                        AggregationField.MARKET_SHARE,
                        AggregationField.PRICE,
                        AggregationField.AVG_PRICE_ON_DATE,
                        AggregationField.CURRENT_DEAL_PERCENTAGE,
                        AggregationField.DEAL_PERCENTAGE,
                        AggregationField.DEAL,
                    ],
                    {
                        [AggregationType.MY_PRODUCT_PRICE_AND_DEAL]:
                            CustomGroupingFunction.MY_PRODUCT_PRICE_AND_DEAL,
                        [AggregationType.MY_PRODUCT_TRENDS_GRAPH_COMPETITION]:
                            CustomGroupingFunction.MY_PRODUCT_TRENDS_GRAPH_COMPETITION,
                        [AggregationType.MY_PRODUCT_TRENDS_GRAPH_CROSS_CHANNEL]:
                            CustomGroupingFunction.MY_PRODUCT_TRENDS_GRAPH_CROSS_CHANNEL,
                        [AggregationType.DATEWISE_TRENDS_OF_COMPETITIVE_PRODUCTS]:
                            CustomGroupingFunction.DATEWISE_TRENDS_OF_COMPETITIVE_PRODUCTS,
                    },
                    [GroupingKey.CHANNEL_ID]
                );
            case ProductDeepdiveModules.AVAILABILITY:
                return formatDataWithAggregations(
                    data,
                    CommonWidgetMetrics.CRAWL_DATE,
                    [
                        AggregationType.MY_SKU_DATA,
                        AggregationType.COMPETITION_DATA,
                        AggregationType.CROSS_CHANNEL_AND_DIRECT_COMPETITOR_DATA,
                        AggregationType.PERFORMANCE_COMPARISON_CTR_TREND,
                    ],
                    [
                        AggregationField.PRICE,
                        AggregationField.UNIT_PER_DAY,
                        AggregationField.AVAILABILITY,
                        AggregationField.BUYBOX_WIN,
                    ],
                    {
                        [AggregationType.COMPETITION_DATA]:
                            CustomGroupingFunction.COMPETITION_DATA_VISIBILITY,
                        [AggregationType.CROSS_CHANNEL_AND_DIRECT_COMPETITOR_DATA]:
                            CustomGroupingFunction.CROSS_CHANNEL_AND_DIRECT_COMPETITOR_DATA_VISIBILITY,
                    },
                    [
                        GroupingKey.CHANNEL_ID,
                        GroupingKey.CHANNEL,
                        GroupingKey.SKU,
                        GroupingKey.SKU_TITLE,
                        GroupingKey.CLIENT_ID,
                        GroupingKey.ASIN_ID,
                        GroupingKey.PROGRAM_TYPE,
                    ]
                );
            case ProductDeepdiveModules.CONTENT_SCORE:
            case ProductDeepdiveModules.VISIBILITY:
                return formatDataWithAggregations(
                    data,
                    CommonWidgetMetrics.CRAWL_DATE,
                    [
                        AggregationType.VISIBILITY_TRENDS,
                        AggregationType.MY_PRODUCT_TREND_CROSS_CHANNEL,
                        AggregationType.MY_PRODUCT_TREND_COMPETITION,
                        AggregationType.PERFORMANCE_COMPARISON_CTR_TREND,
                        AggregationType.KEYWORD_PERFORMANCE_GRAPH,
                        AggregationType.KEYWORD_PERFORMANCE_GRAPH_COMPETITION,
                    ],
                    [
                        AggregationField.PRICE,
                        AggregationField.ORGANIC_RANK,
                        AggregationField.OVERALL_RANK,
                        AggregationField.SPONSORED_RANK,
                        AggregationField.ORG_SKU_WT_CRAWL_SV,
                        AggregationField.PAID_SKU_WT_CRAWL_SV,
                        AggregationField.ORG_CAT_WT_CRAWL_SV,
                        AggregationField.PAID_CAT_WT_CRAWL_SV,
                    ],
                    {
                        [AggregationType.MY_PRODUCT_TREND_COMPETITION]:
                            CustomGroupingFunction.MY_PRODUCT_TREND_COMPETITION_VISIBILITY,
                        [AggregationType.MY_PRODUCT_TREND_CROSS_CHANNEL]:
                            CustomGroupingFunction.MY_PRODUCT_TREND_COMPETITION_VISIBILITY,
                        [AggregationType.KEYWORD_PERFORMANCE_GRAPH]:
                            CustomGroupingFunction.KEYWORD_PERFORMANCE_GRAPH_VISIBILITY,
                        [AggregationType.KEYWORD_PERFORMANCE_GRAPH_COMPETITION]:
                            CustomGroupingFunction.KEYWORD_PERFORMANCE_GRAPH_COMPETITION_VISIBILITY,
                    },
                    [
                        GroupingKey.CHANNEL_ID,
                        GroupingKey.CHANNEL,
                        GroupingKey.SKU,
                        GroupingKey.KEYWORD,
                        GroupingKey.SKU_ID,
                        GroupingKey.CLIENT_ID,
                        GroupingKey.ASIN_ID,
                        GroupingKey.PROGRAM_TYPE,
                    ]
                );
            case ProductDeepdiveModules.RATINGS_REVIEWS:
                return formatDataWithAggregations(
                    data,
                    CommonWidgetMetrics.REVIEW_DATE,
                    [
                        AggregationType.ALL_REVIEW_TRENDS,
                        AggregationType.CROSS_CHANNEL_COUNT_RATINGS,
                        AggregationType.CROSS_CHANNEL_COUNT_REVIEWS,
                        AggregationType.CROSS_CHANNEL_RATINGS,
                        AggregationType.CROSS_CHANNEL_REVIEWS,
                        AggregationType.CROSS_CHANNEL_SCORE_RATINGS,
                        AggregationType.CROSS_CHANNEL_SCORE_REVIEWS_RATINGS,
                        AggregationType.RATING_AND_REVIEWS_TRENDS,
                        AggregationType.CUSTOMER_SATISFACTION_AND_FEATURE,
                    ],
                    [AggregationField.RATING, AggregationField.PER_DAY_RATING],
                    {
                        [AggregationType.CUSTOMER_SATISFACTION_AND_FEATURE]:
                            CustomGroupingFunction.CUSTOMER_SATISFACTION_AND_FEATURE,
                    },
                    [GroupingKey.CHANNEL_ID]
                );

            case ProductDeepdiveOverviewSections.SALES_TREND:
                tempData = formatDataWithAggregations(
                    data,
                    CommonWidgetMetrics.CRAWL_DATE,
                    [AggregationType.SALES_TREND],
                    [
                        AggregationField.DAILY_TREND_SALE,
                        AggregationField.UNIT_PER_DAY,
                    ],
                    {
                        [AggregationType.SALES_TREND]:
                            CustomGroupingFunction.SALES_TREND,
                    },
                    [GroupingKey.CHANNEL_ID]
                );

                return {
                    rawData: tempData.rawData[0].salesTrend,
                    weeklyData: tempData.weeklyData[0].salesTrend,
                    monthlyData: tempData.monthlyData[0].salesTrend,
                };
            case ProductDeepdiveOverviewSections.FUNNEL:
                return formatDataWithAggregations(
                    data,
                    CommonWidgetMetrics.DATE,
                    [
                        AggregationType.TOTAL_ROWS,
                        AggregationType.ROWS,
                        AggregationType.COMBINED_RESPONSE,
                    ],
                    [
                        AggregationField.ACOS,
                        AggregationField.AOV,
                        AggregationField.CPA,
                        AggregationField.CPC,
                        AggregationField.CPM,
                        AggregationField.CR,
                        AggregationField.CTR,
                        AggregationField.PERCENT_SPEND,
                        AggregationField.ROAS,
                    ],
                    {
                        [AggregationType.TOTAL_ROWS]:
                            CustomGroupingFunction.TOTAL_ROWS,
                        [AggregationType.ROWS]: CustomGroupingFunction.ROWS,
                        [AggregationType.COMBINED_RESPONSE]:
                            CustomGroupingFunction.COMBINED_RESPONSE,
                    },
                    [GroupingKey.CHANNEL_ID, GroupingKey.CLIENT_ID]
                );
            default:
                return data;
        }
    }
};

export const formatRatingAndReviewsData = (data: any) => {
    const {
        rating_ratings_reviews,
        working_not_working,
        ai_summary,
        rating_and_reviews_trends,
        customer_satisfaction,
        customer_satisfaction_and_feature,
        all_review_trends,
        all_review_table,
        products_rating,
        products_rating_with_feature,
        reviews_popup_value_for_money_nps_score,
        positive_negative_reviews,
        cross_channel_summary,
        cross_channel_summary_feature_score,
        cross_channel_count_ratings,
        cross_channel_count_reviews,
        cross_channel_score_ratings,
        cross_channel_score_reviews_ratings,
    } = data[0];

    const { positiveReviewData, negativeReviewData } =
        formatWordcloudReviewData(positive_negative_reviews);
    const formattedData = {
        ratingSummaryData: rating_ratings_reviews
            ? formatRatingSummary(rating_ratings_reviews[0])
            : rating_ratings_reviews,
        positiveReviewData,
        negativeReviewData,
        ratingsReviewsTrend: formatTrendsWithCompareModalData(
            rating_and_reviews_trends,
            {
                categoryKey: "review_date",
                yAxisKey: "review_count",
                yAxisOppositeKey: "rating",
                yAxisOppositeKeyOptional: "per_day_rating",
            }
        ),
        satisfactionDriversSummaryData: {
            ...formatSatisfactionDriversSummary(working_not_working),
            aiSummary: ai_summary,
        },
        satisfactionDriversPopup: reviews_popup_value_for_money_nps_score,
        customerSatisfactionDriver: customer_satisfaction,
        driverwiseReviewTrend: customer_satisfaction_and_feature,
        csDriversTrendsFeatures: customer_satisfaction
            ? map(
                  uniq(pluck(customer_satisfaction, "sentiment")),
                  (sentiment) => ({
                      value: sentiment,
                      label: titleCase(sentiment),
                  })
              )
            : [],
        allReviewData: {
            chart: formatReviewData(
                all_review_trends
                    ? groupReviewTrendByChannel(all_review_trends)
                    : all_review_trends
            ),
            table: formatReviewsAndVerbatimTableData(all_review_table),
        },
        crossChannelTrends: {
            reviews_count: cross_channel_count_reviews,
            reviews_score: cross_channel_score_reviews_ratings,
            ratings_count: cross_channel_count_ratings,
            ratings_score: cross_channel_score_ratings,
        },
        crossChannelData: map(cross_channel_summary, (item) => ({
            ...item,
            channel: titleCase(CHANNEL_CONFIGS[item.channel_id].name),
        })),
        crossChannelDataWithFeatures: map(
            cross_channel_summary_feature_score,
            (item) => ({
                ...item,
                channel: titleCase(CHANNEL_CONFIGS[item.channel_id].name),
            })
        ),
        productRatingVsCompetitors: {
            productRatings: products_rating,
            productFeatureRatings: products_rating_with_feature,
        },
    };
    return formattedData;
};

export const formatPricingData = (data: any, selectedSKU: string) => {
    const {
        price_rpi_deal,
        price_vs_sales,
        ppu_price_vs_sales,
        ms_vs_rpi,
        ppu_ms_vs_rpi,
        pricing_and_deal_trends,
        ppu_pricing_and_deal_trends,
        datewise_trends_of_competitive_products,
        competitive_analysis,
        ppu_competitive_analysis,
        working_not_working_insights,
        my_product_trends_chart_cross_channel,
        my_product_trends_graph_cross_channel,
        my_product_trends_chart_cross_channel_competitors_price,
        my_product_trends_chart_competition,
        my_product_trends_chart_competition_competitors_price,
        my_product_price_and_deal,
        ppu_my_product_price_and_deal,
        my_product_trends_graph_competition,
    } = data[0];

    const formattedData = {
        priceRpiDeal: price_rpi_deal
            ? formatPricingSummaryData(price_rpi_deal[0])
            : price_rpi_deal,
        priceVsSales: price_vs_sales,
        ppuPriceVsSales: ppu_price_vs_sales,
        msVsRpi: ms_vs_rpi,
        ppuMsVsRpi: ppu_ms_vs_rpi,
        pricingAndDealsTrends: pricing_and_deal_trends,
        ppuPricingAndDealsTrends: ppu_pricing_and_deal_trends,
        datewiseTrendsOfCompetitiveProducts:
            datewise_trends_of_competitive_products
                ? formatCompetitiveProductsDaywise(
                      datewise_trends_of_competitive_products,
                      selectedSKU
                  )
                : datewise_trends_of_competitive_products,
        competitiveAnalysis: competitive_analysis,
        ppuCompetitiveAnalysis: ppu_competitive_analysis,
        myProductPriceAndDeal: my_product_price_and_deal,
        ppuMyProductPriceAndDeal: ppu_my_product_price_and_deal,
        workingNotWorkingInsights: working_not_working_insights
            ? formatPricingSatisfactionDriversSummary(
                  working_not_working_insights
              )
            : working_not_working_insights,
        aiSummary: data[0].ai_summary,
        myProductTrendsChartCrossChannelChartData:
            my_product_trends_graph_cross_channel,
        myProductTrendsChartCrossChannelTableData:
            my_product_trends_chart_cross_channel,
        myProductTrendsChartCrossChannelExpandableTableData:
            my_product_trends_chart_cross_channel_competitors_price,
        myProductTrendsCompetitionChartData:
            my_product_trends_graph_competition,
        myProductTrendsCompetitionTableData:
            my_product_trends_chart_competition,
        myProductTrendsCompetitionExpandableTableData:
            my_product_trends_chart_competition_competitors_price,
    };

    return formattedData;
};

export const getDataBasedOnFrequency = (
    data: any,
    selectedDataFrequency: string
) => {
    switch (selectedDataFrequency) {
        case FrequencySlicerOptions.Daily:
            return data?.dailyData || {};
        case FrequencySlicerOptions.Weekly:
            return data?.weeklyData || {};
        case FrequencySlicerOptions.Monthly:
            return data?.monthlyData || {};
        default:
            return data?.dailyData || {};
    }
};
export const formatDataWithAggregations = (
    rawData: any[],
    dateKey: string,
    dataKey: string[],
    averageKeys: string[], // Fields to average
    compositeKeyMap: Record<string, (item: any, groupKey: string) => string>, // Mapping for composite keys
    excludedKeys: string[] = [] // Fields to exclude from aggregation
) => {
    const groupData = (
        dataArray: any[],
        frequency: string,
        keys: string[],
        compositeKeyGenerator?: (item: any, groupKey: string) => string
    ) => {
        const groupedData = dataArray.reduce((acc, item) => {
            const groupKey = getDateRange(item[dateKey], frequency);

            // Generate the composite key using the provided generator or fallback to groupKey
            const compositeKey = compositeKeyGenerator
                ? compositeKeyGenerator(item, groupKey)
                : groupKey;

            if (!acc[compositeKey]) {
                acc[compositeKey] = {
                    ...item,
                    [dateKey]: groupKey,
                };

                keys.forEach((key) => {
                    // Skip excluded keys
                    if (excludedKeys.includes(key)) {
                        acc[compositeKey][key] = item[key];
                        return;
                    }

                    if (averageKeys.includes(key)) {
                        acc[compositeKey][`${key}_sum`] = 0;
                        acc[compositeKey][`${key}_count`] = 0;
                    } else if (Array.isArray(item[key])) {
                        acc[compositeKey][key] = [];
                    } else if (typeof item[key] === "number") {
                        acc[compositeKey][key] = 0;
                    }
                });
            }

            keys.forEach((key) => {
                // Skip excluded keys
                if (excludedKeys.includes(key)) return;

                if (averageKeys.includes(key)) {
                    acc[compositeKey][`${key}_sum`] += item[key];
                    acc[compositeKey][`${key}_count`] += 1;
                } else if (Array.isArray(item[key])) {
                    if (!Array.isArray(acc[compositeKey][key])) {
                        acc[compositeKey][key] = [];
                    }
                    acc[compositeKey][key] = [
                        ...acc[compositeKey][key],
                        ...item[key],
                    ];
                } else if (typeof item[key] === "number") {
                    acc[compositeKey][key] += item[key];
                }
            });

            return acc;
        }, {});

        return Object.values(groupedData).map((group) => {
            keys.forEach((key) => {
                if (excludedKeys.includes(key)) return;

                if (averageKeys.includes(key)) {
                    const sum = (group as Record<string, any>)[`${key}_sum`];
                    const count = (group as Record<string, any>)[
                        `${key}_count`
                    ];
                    (group as Record<string, any>)[key] = count
                        ? +(sum / count).toFixed(1)
                        : 0;
                    delete (group as Record<string, any>)[`${key}_sum`];
                    delete (group as Record<string, any>)[`${key}_count`];
                }
            });
            return group;
        });
    };

    const processNestedData = (data: any[], frequency: string) => {
        return data.map((item) => {
            const processedItem = { ...item };

            dataKey?.forEach((key) => {
                if (Array.isArray(item[key]) && item[key].length) {
                    const compositeKeyGenerator = compositeKeyMap[key];
                    processedItem[key] = groupData(
                        item[key],
                        frequency,
                        Object.keys(item[key][0]),
                        compositeKeyGenerator
                    );
                }
            });

            return processedItem;
        });
    };

    const weeklyData = processNestedData(
        rawData,
        FrequencySlicerOptions.Weekly
    );
    const monthlyData = processNestedData(
        rawData,
        FrequencySlicerOptions.Monthly
    );

    return {
        rawData,
        weeklyData,
        monthlyData,
    };
};
export const getDateRange = (date: string, frequency: string) => {
    const startDate = moment(date)
        .startOf(
            frequency === FrequencySlicerOptions.Weekly ? "isoWeek" : "month"
        )
        .format("YYYY-MM-DD");
    return startDate;
};

// Utility function to merge data from multiple data keys
export const mergeModuleData = (moduleData: any, dataKeys: string[]): any => {
    if (!Array.isArray(dataKeys) || dataKeys.length === 0) {
        return null;
    }

    // If only one key, return data directly
    if (dataKeys.length === 1) {
        return moduleData[dataKeys[0]];
    }

    // Merge data from multiple keys
    const mergedData: any = {};
    dataKeys.forEach(key => {
        if (moduleData[key]) {
            // If the data is an array, concatenate
            if (Array.isArray(moduleData[key])) {
                if (!mergedData.combinedData) {
                    mergedData.combinedData = [];
                }
                mergedData.combinedData = [...mergedData.combinedData, ...moduleData[key]];
            } else if (typeof moduleData[key] === 'object') {
                // If the data is an object, spread it
                Object.assign(mergedData, moduleData[key]);
            } else {
                // For primitive values, store with key name
                mergedData[key] = moduleData[key];
            }
        }
    });

    return Object.keys(mergedData).length > 0 ? mergedData : null;
};
